const documentOldOption = [
  {
    id: "Canadian Certificate Of Salvage (Maryland)",
    label: "Canadian Certificate Of Salvage (Maryland)",
    color: "#008000",
  },
  {
    id: "Canadian Certificate Of Salvage (Massachusetts)",
    label: "Canadian Certificate Of Salvage (Massachusetts)",
    color: "#008000",
  },
  {
    id: "ENTERPRISE VEHICLES SALVAGE ONLY - NM",
    label: "ENTERPRISE VEHICLES SALVAGE ONLY - NM",
    color: "#008000",
  },
  { id: "NB - SALVAGE TITLE", label: "NB - SALVAGE TITLE", color: "#008000" },
  {
    id: "GA - SALVAGE/FIRE DAMAGE",
    label: "GA - SALVAGE/FIRE DAMAGE",
    color: "#FF681F",
  },
  {
    id: "FL - CERT OF TTL-SLVG REBULD&BUY-BK",
    label: "FL - CERT OF TTL-SLVG REBULD&BUY-BK",
    color: "#008000",
  },
  {
    id: "CANADIAN CERTIFICATE OF SALVAGE - IL",
    label: "CANADIAN CERTIFICATE OF SALVAGE - IL",
    color: "#008000",
  },
  {
    id: "LA - CERT OF TITLE-SALVAGE HISTORY",
    label: "LA - CERT OF TITLE-SALVAGE HISTORY",
    color: "#008000",
  },
  { id: "AL - HAIL SALVAGE", label: "AL - HAIL SALVAGE", color: "#008000" },
  {
    id: "CANADIAN CERTIFICATE OF SALVAGE - PA",
    label: "CANADIAN CERTIFICATE OF SALVAGE - PA",
    color: "#008000",
  },
  {
    id: "Bc-Salvage (British Columbia)",
    label: "Bc-Salvage (British Columbia)",
    color: "#008000",
  },
  {
    id: "MI - SALVAGE CERTIFICATE- MUNICIPAL",
    label: "MI - SALVAGE CERTIFICATE- MUNICIPAL",
    color: "#008000",
  },
  {
    id: "NJ - CERT OF TITLE-SLVG TAXI",
    label: "NJ - CERT OF TITLE-SLVG TAXI",
    color: "#008000",
  },
  {
    id: "Dcas - Salvage (New York)",
    label: "Dcas - Salvage (New York)",
    color: "#008000",
  },
  {
    id: "PA - CERT OF TTL-SLVG SNOWMOBILE",
    label: "PA - CERT OF TTL-SLVG SNOWMOBILE",
    color: "#008000",
  },
  {
    id: "SC - DLR ONLY CERT OF TITLE-SALVAGE",
    label: "SC - DLR ONLY CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "ON - RIV IMPORT SALVAGE",
    label: "ON - RIV IMPORT SALVAGE",
    color: "#008000",
  },
  {
    id: "ENTERPRISE VEHICLES SALVAGE ONLY - CO",
    label: "ENTERPRISE VEHICLES SALVAGE ONLY - CO",
    color: "#008000",
  },
  {
    id: "NY - CERT OF TITLE-SALVAGE",
    label: "NY - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "Sk-Rebuildable (Saskatchewan)",
    label: "Sk-Rebuildable (Saskatchewan)",
    color: "#008000",
  },
  {
    id: "MI - DEALER ONLY SALVAGE TITLE",
    label: "MI - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "SC - CERT OF TITLE-SALVAGE FIRE",
    label: "SC - CERT OF TITLE-SALVAGE FIRE",
    color: "#008000",
  },
  {
    id: "Pe-Salvage (Prince Edward Island)",
    label: "Pe-Salvage (Prince Edward Island)",
    color: "#008000",
  },
  {
    id: "OH - CERT OF TITLE-SALVAGE HISTORY",
    label: "OH - CERT OF TITLE-SALVAGE HISTORY",
    color: "#008000",
  },
  { id: "AL - FIRE SALVAGE", label: "AL - FIRE SALVAGE", color: "#008000" },
  {
    id: "QC - RIV IMPORT SALVAGE",
    label: "QC - RIV IMPORT SALVAGE",
    color: "#008000",
  },
  {
    id: "CA - CERT OF TITLE-SALVAGED",
    label: "CA - CERT OF TITLE-SALVAGED",
    color: "#008000",
  },
  {
    id: "UT - NOTICE OF REQUIREMENT SALVAGE",
    label: "UT - NOTICE OF REQUIREMENT SALVAGE",
    color: "#008000",
  },
  {
    id: "SALVAGE  -  DEALER ONLY - KS",
    label: "SALVAGE  -  DEALER ONLY - KS",
    color: "#008000",
  },
  {
    id: "Salvage (District Of Columbia)",
    label: "Salvage (District Of Columbia)",
    color: "#008000",
  },
  {
    id: "TX - SALVAGE CERT-MANUFACTURER BUYB",
    label: "TX - SALVAGE CERT-MANUFACTURER BUYB",
    color: "#008000",
  },
  {
    id: "OR - CERT OF TITLE W/SALVAGE HISTOR",
    label: "OR - CERT OF TITLE W/SALVAGE HISTOR",
    color: "#008000",
  },
  {
    id: "MD - CERT OF SALVAGE-RECOVERED STOL",
    label: "MD - CERT OF SALVAGE-RECOVERED STOL",
    color: "#008000",
  },
  {
    id: "WY - DEALER ONLY SALVAGE TITLE",
    label: "WY - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "AL - SALVAGE RECOVERED THEFT",
    label: "AL - SALVAGE RECOVERED THEFT",
    color: "#008000",
  },
  {
    id: "SD - DEALER ONLY SALVAGE TITLE",
    label: "SD - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "OH - DEALER ONLY SALVAGE TITLE",
    label: "OH - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  { id: "SALVAGE - WY", label: "SALVAGE - WY", color: "#008000" },
  {
    id: "Enterprise Vehicles Salvage Only (New York)",
    label: "Enterprise Vehicles Salvage Only (New York)",
    color: "#008000",
  },
  {
    id: "Salvage Retention (Iowa)",
    label: "Salvage Retention (Iowa)",
    color: "#008000",
  },
  {
    id: "TN - CERT OF TITLE-SALVAGE HISTORY",
    label: "TN - CERT OF TITLE-SALVAGE HISTORY",
    color: "#008000",
  },
  {
    id: "MO - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "MO - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  { id: "HI - SALVAGE TITLE", label: "HI - SALVAGE TITLE", color: "#008000" },
  {
    id: "UT - CERTIFICATE OF SALE - SALVAGE",
    label: "UT - CERTIFICATE OF SALE - SALVAGE",
    color: "#008000",
  },
  { id: "PA - SALVAGE TITLE", label: "PA - SALVAGE TITLE", color: "#008000" },
  { id: "AL - SALVAGE HISTORY", label: "AL - SALVAGE HISTORY", color: "#008000" },
  {
    id: "PA - CERT OF SLVG-LEMON LAW REPURCH",
    label: "PA - CERT OF SLVG-LEMON LAW REPURCH",
    color: "#008000",
  },
  {
    id: "Salvage Title (Hawaii)",
    label: "Salvage Title (Hawaii)",
    color: "#008000",
  },
  {
    id: "WI - SALVAGE - MULTIPLE BRANDS",
    label: "WI - SALVAGE - MULTIPLE BRANDS",
    color: "#008000",
  },
  {
    id: "ND - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "ND - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "IA - SALVAGE W/SALVAGE HISTORY",
    label: "IA - SALVAGE W/SALVAGE HISTORY",
    color: "#008000",
  },
  { id: "OR - SALVAGE TITLE", label: "OR - SALVAGE TITLE", color: "#008000" },
  {
    id: "OR - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "OR - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "GA - CERT OF TTL-SLVG MANUFCTR BYBK",
    label: "GA - CERT OF TTL-SLVG MANUFCTR BYBK",
    color: "#008000",
  },
  {
    id: "Enterprise Vehicles Salvage Only (Texas)",
    label: "Enterprise Vehicles Salvage Only (Texas)",
    color: "#008000",
  },
  {
    id: "NC - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "NC - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "SALVAGE  -  LESS THAN 75% - MD",
    label: "SALVAGE  -  LESS THAN 75% - MD",
    color: "#008000",
  },
  {
    id: "PA - CERT OF SALVAGE-A=ANTIQUE VEH",
    label: "PA - CERT OF SALVAGE-A=ANTIQUE VEH",
    color: "#008000",
  },
  { id: "Salvage (Wyoming)", label: "Salvage (Wyoming)", color: "#008000" },
  { id: "SALVAGE - DC", label: "SALVAGE - DC", color: "#008000" },
  {
    id: "ENTERPRISE VEHICLES SALVAGE ONLY - NY",
    label: "ENTERPRISE VEHICLES SALVAGE ONLY - NY",
    color: "#008000",
  },
  {
    id: "GA - CERT OF TITLE-SALVAGE COURT OR",
    label: "GA - CERT OF TITLE-SALVAGE COURT OR",
    color: "#008000",
  },
  {
    id: "TX - BONDED TITLE - SALVAGE",
    label: "TX - BONDED TITLE - SALVAGE",
    color: "#008000",
  },
  {
    id: "Nw-Salvage (Northwest Territories)",
    label: "Nw-Salvage (Northwest Territories)",
    color: "#008000",
  },
  { id: "PE - SALVAGE TITLE", label: "PE - SALVAGE TITLE", color: "#008000" },
  { id: "Rebuildable", label: "Rebuildable", color: "#008000" },
  {
    id: "Salvage (New Hampshire)",
    label: "Salvage (New Hampshire)",
    color: "#008000",
  },
  { id: "Salvage", label: "Salvage", color: "#008000" },
  {
    id: "LA - DEALER ONLY SALVAGE TITLE",
    label: "LA - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "Enterprise Vehicles Salvage Only (Alabama)",
    label: "Enterprise Vehicles Salvage Only (Alabama)",
    color: "#008000",
  },
  {
    id: "AZ - CERT OF TITLE-RESTORED SALVAGE",
    label: "AZ - CERT OF TITLE-RESTORED SALVAGE",
    color: "#008000",
  },
  {
    id: "AK - CERT OF TITLE W/SALVAGE HISTOR",
    label: "AK - CERT OF TITLE W/SALVAGE HISTOR",
    color: "#008000",
  },
  {
    id: "Salvage Reassignment (Iowa)",
    label: "Salvage Reassignment (Iowa)",
    color: "#008000",
  },
  {
    id: "Salvage - Dealer Only (Kansas)",
    label: "Salvage - Dealer Only (Kansas)",
    color: "#008000",
  },
  {
    id: "FL - DLR ONLY SALVAGE/REBUILDABLE",
    label: "FL - DLR ONLY SALVAGE/REBUILDABLE",
    color: "#008000",
  },
  {
    id: "GA - DLR ONLY CERT OF TITLE-SALVAGE",
    label: "GA - DLR ONLY CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "MN - DEALER ONLY SALVAGE TITLE",
    label: "MN - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "CA - ACQ BOS - POST SALE - SALVAGE",
    label: "CA - ACQ BOS - POST SALE - SALVAGE",
    color: "#008000",
  },
  {
    id: "CA - DEALER ONLY SALVAGE TITLE",
    label: "CA - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "Salvage Non-Reb (South Carolina)",
    label: "Salvage Non-Reb (South Carolina)",
    color: "#FF0000",
  },
  {
    id: "IN - DEALER ONLY SALVAGE TITLE",
    label: "IN - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "OK - CERT OF TITLE-SALVAGE REC THFT",
    label: "OK - CERT OF TITLE-SALVAGE REC THFT",
    color: "#008000",
  },
  {
    id: "WY - CERT OF TITLE-SALVAGE",
    label: "WY - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "AZ - DEALER ONLY SALVAGE TITLE",
    label: "AZ - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "AZ - CERT OF TITLE-PREVIOUS SALVAGE",
    label: "AZ - CERT OF TITLE-PREVIOUS SALVAGE",
    color: "#008000",
  },
  {
    id: "FL - CERT OF TITLE-SALVAGE TTL THFT",
    label: "FL - CERT OF TITLE-SALVAGE TTL THFT",
    color: "#008000",
  },
  {
    id: "Salvage - Dealer Only (Ohio)",
    label: "Salvage - Dealer Only (Ohio)",
    color: "#008000",
  },
  {
    id: "PA - CERT OF SALVAGE-F=OUT OF CNTRY",
    label: "PA - CERT OF SALVAGE-F=OUT OF CNTRY",
    color: "#008000",
  },
  {
    id: "OK - DEALER ONLY SALVAGE TITLE",
    label: "OK - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "WV - SALVAGE CERTIFICATE",
    label: "WV - SALVAGE CERTIFICATE",
    color: "#008000",
  },
  {
    id: "WI - CERT OF TITLE-SALVAGE VEHICLE",
    label: "WI - CERT OF TITLE-SALVAGE VEHICLE",
    color: "#008000",
  },
  {
    id: "TX - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "TX - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "SC - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "SC - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "UT - DEALER ONLY SALVAGE TITLE",
    label: "UT - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "ME - CERT OF SALVAGE - WATER DAMAGE",
    label: "ME - CERT OF SALVAGE - WATER DAMAGE",
    color: "#008000",
  },
  {
    id: "WY - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "WY - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "GA - DEALER ONLY SALVAGE TITLE",
    label: "GA - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "Mb-Salvageable (Manitoba)",
    label: "Mb-Salvageable (Manitoba)",
    color: "#008000",
  },
  {
    id: "TN - DLR ONLY CERT OF TITLE-SALVAGE",
    label: "TN - DLR ONLY CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "CO - CERT OF TITLE-SALVAGE HISTORY",
    label: "CO - CERT OF TITLE-SALVAGE HISTORY",
    color: "#008000",
  },
  {
    id: "CA - SALVAGE CERT-LEMON LAW BUYBACK",
    label: "CA - SALVAGE CERT-LEMON LAW BUYBACK",
    color: "#008000",
  },
  {
    id: "MI - DLR ONLY SALVAGE TITLE",
    label: "MI - DLR ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "Salvage (West Virginia)",
    label: "Salvage (West Virginia)",
    color: "#008000",
  },
  { id: "Salvage (California)", label: "Salvage (California)", color: "#008000" },
  { id: "Salvage (Texas)", label: "Salvage (Texas)", color: "#008000" },
  {
    id: "Salvage Retention (Alaska)",
    label: "Salvage Retention (Alaska)",
    color: "#008000",
  },
  {
    id: "Salvage - Less Than 75% (Maryland)",
    label: "Salvage - Less Than 75% (Maryland)",
    color: "#008000",
  },
  {
    id: "Salvage (Connecticut)",
    label: "Salvage (Connecticut)",
    color: "#008000",
  },
  { id: "Salvage (Iowa)", label: "Salvage (Iowa)", color: "#008000" },
  {
    id: "NC - DEALER ONLY SALVAGE TITLE",
    label: "NC - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  { id: "Salvage (Washington)", label: "Salvage (Washington)", color: "#008000" },
  { id: "Salvage (New York)", label: "Salvage (New York)", color: "#008000" },
  {
    id: "Us-Salvage (Michigan)",
    label: "Us-Salvage (Michigan)",
    color: "#008000",
  },
  {
    id: "ND - SALVAGE PREVIOUSLY BRANDED",
    label: "ND - SALVAGE PREVIOUSLY BRANDED",
    color: "#008000",
  },
  { id: "AB - BOS - SALVAGE", label: "AB - BOS - SALVAGE", color: "#008000" },
  {
    id: "MD - CERT OF SALVAGE-ABANDONED",
    label: "MD - CERT OF SALVAGE-ABANDONED",
    color: "#008000",
  },
  {
    id: "LA - PERMIT TO SELL-SALVAGE VEHICLE",
    label: "LA - PERMIT TO SELL-SALVAGE VEHICLE",
    color: "#008000",
  },
  { id: "Salvage (Hawaii)", label: "Salvage (Hawaii)", color: "#008000" },
  { id: "Yk-Salvage (Yukon)", label: "Yk-Salvage (Yukon)", color: "#008000" },
  {
    id: "AB - RIV IMPORT SALVAGE",
    label: "AB - RIV IMPORT SALVAGE",
    color: "#008000",
  },
  {
    id: "Nf-Salvage (Newfoundland And Labrador)",
    label: "Nf-Salvage (Newfoundland And Labrador)",
    color: "#008000",
  },
  {
    id: "SD - CERT OF TITLE-SALVAGE",
    label: "SD - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "KY - DEALER ONLY SALVAGE TITLE",
    label: "KY - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "NE - CERT OF TITLE-SALVAGE",
    label: "NE - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "GA - CERT OF TITLE-SALVAGE HISTORY",
    label: "GA - CERT OF TITLE-SALVAGE HISTORY",
    color: "#008000",
  },
  {
    id: "TX - SALVAGE TITLE W/REASSIGNED VIN",
    label: "TX - SALVAGE TITLE W/REASSIGNED VIN",
    color: "#008000",
  },
  {
    id: "VA - SALVAGE CERTIFICATE",
    label: "VA - SALVAGE CERTIFICATE",
    color: "#008000",
  },
  {
    id: "Previous Salvage (Michigan)",
    label: "Previous Salvage (Michigan)",
    color: "#008000",
  },
  {
    id: "NE - CERT OF TITLE W/SALVAGE HISTOR",
    label: "NE - CERT OF TITLE W/SALVAGE HISTOR",
    color: "#008000",
  },
  {
    id: "SALVAGE RETENTION - TX",
    label: "SALVAGE RETENTION - TX",
    color: "#008000",
  },
  {
    id: "WV - DLR ONLY SALVAGE CERT",
    label: "WV - DLR ONLY SALVAGE CERT",
    color: "#008000",
  },
  {
    id: "NY - DEALER ONLY SALVAGE TITLE",
    label: "NY - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "MS - CERT OF TITLE-UNREC THEFT SLVG",
    label: "MS - CERT OF TITLE-UNREC THEFT SLVG",
    color: "#008000",
  },
  { id: "SALVAGE - VA", label: "SALVAGE - VA", color: "#008000" },
  {
    id: "PREVIOUS SALVAGE - MI",
    label: "PREVIOUS SALVAGE - MI",
    color: "#008000",
  },
  { id: "SALVAGE - AZ", label: "SALVAGE - AZ", color: "#008000" },
  { id: "SALVAGE - FL", label: "SALVAGE - FL", color: "#008000" },
  { id: "SALVAGE - LA", label: "SALVAGE - LA", color: "#008000" },
  {
    id: "GU - SALVAGE CERTIFICATE",
    label: "GU - SALVAGE CERTIFICATE",
    color: "#008000",
  },
  { id: "SALVAGE - TN", label: "SALVAGE - TN", color: "#008000" },
  {
    id: "MO - CERT OF TITLE-PRIOR SALVAGE",
    label: "MO - CERT OF TITLE-PRIOR SALVAGE",
    color: "#008000",
  },
  { id: "SALVAGE - OR", label: "SALVAGE - OR", color: "#008000" },
  { id: "SALVAGE - MA", label: "SALVAGE - MA", color: "#008000" },
  { id: "SALVAGE - SC", label: "SALVAGE - SC", color: "#008000" },
  { id: "SALVAGE - NH", label: "SALVAGE - NH", color: "#008000" },
  {
    id: "MT - CERT OF TITLE W/SALVAGE HISTOR",
    label: "MT - CERT OF TITLE W/SALVAGE HISTOR",
    color: "#008000",
  },
  { id: "SALVAGE - CO", label: "SALVAGE - CO", color: "#008000" },
  { id: "SALVAGE - IL", label: "SALVAGE - IL", color: "#008000" },
  {
    id: "Salvage Title (New York)",
    label: "Salvage Title (New York)",
    color: "#008000",
  },
  {
    id: "MS - DEALER ONLY SALVAGE TITLE",
    label: "MS - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "NV - CERT OF TITLE-OHV SALVAGE",
    label: "NV - CERT OF TITLE-OHV SALVAGE",
    color: "#008000",
  },
  {
    id: "SALVAGE CERTIFICATE - TX",
    label: "SALVAGE CERTIFICATE - TX",
    color: "#008000",
  },
  {
    id: "PA - BOAT CERT OF TITLE-SALVAGE",
    label: "PA - BOAT CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  { id: "PRIOR SALVAGE - MN", label: "PRIOR SALVAGE - MN", color: "#008000" },
  {
    id: "IN - CERT OF TITLE-SALVAGE HISTORY",
    label: "IN - CERT OF TITLE-SALVAGE HISTORY",
    color: "#008000",
  },
  {
    id: "SALVAGE - DEALER ONLY - OH",
    label: "SALVAGE - DEALER ONLY - OH",
    color: "#008000",
  },
  { id: "SALVAGE - NE", label: "SALVAGE - NE", color: "#008000" },
  {
    id: "Forfeiture - Salvage (California)",
    label: "Forfeiture - Salvage (California)",
    color: "#008000",
  },
  {
    id: "Enterprise Vehicles Salvage Only (New Mexico)",
    label: "Enterprise Vehicles Salvage Only (New Mexico)",
    color: "#008000",
  },
  {
    id: "PA - CERT OF SALVAGE-R=RECONSTRUCTE",
    label: "PA - CERT OF SALVAGE-R=RECONSTRUCTE",
    color: "#008000",
  },
  {
    id: "TN - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "TN - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "FL - CERT OF TITLE-REBUILDABLE SLVG",
    label: "FL - CERT OF TITLE-REBUILDABLE SLVG",
    color: "#008000",
  },
  { id: "VI - SALVAGE TITLE", label: "VI - SALVAGE TITLE", color: "#008000" },
  {
    id: "SALVAGE - GREATER THAN 75% - MD",
    label: "SALVAGE - GREATER THAN 75% - MD",
    color: "#008000",
  },
  { id: "SALVAGE TITLE - TX", label: "SALVAGE TITLE - TX", color: "#008000" },
  { id: "SALVAGE - OK", label: "SALVAGE - OK", color: "#008000" },
  {
    id: "TN - CERT TO OBTAIN SALVAGE TITLE",
    label: "TN - CERT TO OBTAIN SALVAGE TITLE",
    color: "#008000",
  },
  { id: "SALVAGE - IN", label: "SALVAGE - IN", color: "#008000" },
  { id: "SALVAGE - GA", label: "SALVAGE - GA", color: "#008000" },
  { id: "SALVAGE - OH", label: "SALVAGE - OH", color: "#008000" },
  {
    id: "SALVAGE CERTIFICATE - CA",
    label: "SALVAGE CERTIFICATE - CA",
    color: "#008000",
  },
  { id: "SALVAGE - NC", label: "SALVAGE - NC", color: "#008000" },
  { id: "SALVAGE - PA", label: "SALVAGE - PA", color: "#008000" },
  {
    id: "PA - DEALER ONLY SALVAGE TITLE",
    label: "PA - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  { id: "Ab-Salvage (Alberta)", label: "Ab-Salvage (Alberta)", color: "#008000" },
  {
    id: "SALVAGE TITLE - DEALER - CA",
    label: "SALVAGE TITLE - DEALER - CA",
    color: "#008000",
  },
  { id: "SALVAGE TITLE - CA", label: "SALVAGE TITLE - CA", color: "#008000" },
  {
    id: "Ns-Salvage (Nova Scotia)",
    label: "Ns-Salvage (Nova Scotia)",
    color: "#008000",
  },
  { id: "SALVAGE - AR", label: "SALVAGE - AR", color: "#008000" },
  { id: "REBUILDABLE - FL", label: "REBUILDABLE - FL", color: "#008000" },
  { id: "On-Salvage (Ontario)", label: "On-Salvage (Ontario)", color: "#008000" },
  {
    id: "IA - CERT OF TITLE-PRIOR SALVAGE",
    label: "IA - CERT OF TITLE-PRIOR SALVAGE",
    color: "#008000",
  },
  {
    id: "VA - CERT OF TITLE-SALVAGE WATER",
    label: "VA - CERT OF TITLE-SALVAGE WATER",
    color: "#008000",
  },
  {
    id: "FL - CERT OF TITLE-POLICE SLVG RBLD",
    label: "FL - CERT OF TITLE-POLICE SLVG RBLD",
    color: "#008000",
  },
  { id: "SALVAGE - MI", label: "SALVAGE - MI", color: "#008000" },
  { id: "SALVAGE TITLE - IA", label: "SALVAGE TITLE - IA", color: "#008000" },
  {
    id: "WA - VEH CERT OF OWNERSHIP-SALVAGE",
    label: "WA - VEH CERT OF OWNERSHIP-SALVAGE",
    color: "#008000",
  },
  { id: "SALVAGE - VT", label: "SALVAGE - VT", color: "#008000" },
  {
    id: "LA - CERT OF TITLE-SALVAGE WATER",
    label: "LA - CERT OF TITLE-SALVAGE WATER",
    color: "#008000",
  },
  {
    id: "OH - CERT OF TITLE-SALVAGE-DESTRUCT",
    label: "OH - CERT OF TITLE-SALVAGE-DESTRUCT",
    color: "#FF0000",
  },
  {
    id: "KY - HAIL SALVAGE BRAND",
    label: "KY - HAIL SALVAGE BRAND",
    color: "#008000",
  },
  {
    id: "Canadian Certificate Of Salvage (Virginia)",
    label: "Canadian Certificate Of Salvage (Virginia)",
    color: "#008000",
  },
  {
    id: "MA - CERT OF TITLE-SLVG REPAIR THFT",
    label: "MA - CERT OF TITLE-SLVG REPAIR THFT",
    color: "#008000",
  },
  { id: "SALVAGE - UT", label: "SALVAGE - UT", color: "#008000" },
  { id: "SALVAGE - NV", label: "SALVAGE - NV", color: "#008000" },
  { id: "SALVAGE TITLE - NY", label: "SALVAGE TITLE - NY", color: "#008000" },
  { id: "SALVAGE - KY", label: "SALVAGE - KY", color: "#008000" },
  {
    id: "MO - CERT OF TITLE-REPOSSESSED",
    label: "MO - CERT OF TITLE-REPOSSESSED",
    color: "#008000",
  },
  {
    id: "Salvage Retention (Arkansas)",
    label: "Salvage Retention (Arkansas)",
    color: "#008000",
  },
  {
    id: "UT - CERT OF TITLE W/SALVAGE HISTOR",
    label: "UT - CERT OF TITLE W/SALVAGE HISTOR",
    color: "#008000",
  },
  {
    id: "TX - DLR ONLY SALVAGE TITLE",
    label: "TX - DLR ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "TX - CERT OF TITLE W/SALVAGE HISTOR",
    label: "TX - CERT OF TITLE W/SALVAGE HISTOR",
    color: "#008000",
  },
  {
    id: "MD - DEALER ONLY SALVAGE TITLE",
    label: "MD - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "FL - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "FL - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "MN - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "MN - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "MN - CERT OF TITLE-SALVAGE HISTORY",
    label: "MN - CERT OF TITLE-SALVAGE HISTORY",
    color: "#008000",
  },
  { id: "NS - SALVAGE TITLE", label: "NS - SALVAGE TITLE", color: "#008000" },
  {
    id: "CO - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "CO - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "SALVAGE  -  75% OR LESS - MD",
    label: "SALVAGE  -  75% OR LESS - MD",
    color: "#008000",
  },
  {
    id: "IA - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "IA - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "MA - CERTIFICATE TO OBTAIN SALVAGE",
    label: "MA - CERTIFICATE TO OBTAIN SALVAGE",
    color: "#008000",
  },
  {
    id: "REGULAR  -  SALVAGE - SD",
    label: "REGULAR  -  SALVAGE - SD",
    color: "#008000",
  },
  {
    id: "VA - CERT OF TITLE-SALVAGE HISTORY",
    label: "VA - CERT OF TITLE-SALVAGE HISTORY",
    color: "#008000",
  },
  { id: "SALVAGE - RI", label: "SALVAGE - RI", color: "#008000" },
  { id: "SALVAGE - DE", label: "SALVAGE - DE", color: "#008000" },
  {
    id: "NC - CERT OF TITLE W/SALVAGE HISTOR",
    label: "NC - CERT OF TITLE W/SALVAGE HISTOR",
    color: "#008000",
  },
  { id: "SALVAGE TITLE - HI", label: "SALVAGE TITLE - HI", color: "#008000" },
  {
    id: "OH - CERT OF TTL-SALVAGE UNCLMD AFF",
    label: "OH - CERT OF TTL-SALVAGE UNCLMD AFF",
    color: "#008000",
  },
  {
    id: "Salvage Title (California)",
    label: "Salvage Title (California)",
    color: "#008000",
  },
  {
    id: "SALVAGE NON - REB - SC",
    label: "SALVAGE NON - REB - SC",
    color: "#FF0000",
  },
  {
    id: "FL - CERT OF TITLE-SALVAGE THEFT",
    label: "FL - CERT OF TITLE-SALVAGE THEFT",
    color: "#008000",
  },
  {
    id: "MS - CERT OF TITLE - HAIL SALVAGE",
    label: "MS - CERT OF TITLE - HAIL SALVAGE",
    color: "#008000",
  },
  {
    id: "MI - CERT OF TITLE-SALVAGE HISTORY",
    label: "MI - CERT OF TITLE-SALVAGE HISTORY",
    color: "#008000",
  },
  {
    id: "NY - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "NY - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  { id: "SALVAGE - AL", label: "SALVAGE - AL", color: "#008000" },
  {
    id: "CA - DIS/DLR/EXP ONLY SALVAGE CERT",
    label: "CA - DIS/DLR/EXP ONLY SALVAGE CERT",
    color: "#008000",
  },
  { id: "SALVAGE - ME", label: "SALVAGE - ME", color: "#008000" },
  {
    id: "MS - CERT OF TITLE W/SALVAGE HISTOR",
    label: "MS - CERT OF TITLE W/SALVAGE HISTOR",
    color: "#008000",
  },
  {
    id: "VA - DEALER ONLY SALVAGE TITLE",
    label: "VA - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "SALVAGE CERTIFICATE - HI",
    label: "SALVAGE CERTIFICATE - HI",
    color: "#008000",
  },
  {
    id: "OK - CERT OF TITLE-SALVAGE HISTORY",
    label: "OK - CERT OF TITLE-SALVAGE HISTORY",
    color: "#008000",
  },
  {
    id: "MO - DEALER ONLY SALVAGE TITLE",
    label: "MO - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "PA - CERT OF SALVAGE-THEFT",
    label: "PA - CERT OF SALVAGE-THEFT",
    color: "#008000",
  },
  { id: "SALVAGE - MT", label: "SALVAGE - MT", color: "#008000" },
  {
    id: "SALVAGE CERTIFICATE - WV",
    label: "SALVAGE CERTIFICATE - WV",
    color: "#008000",
  },
  {
    id: "NC - DLR ONLY SALVAGE CERTIFICATE",
    label: "NC - DLR ONLY SALVAGE CERTIFICATE",
    color: "#008000",
  },
  {
    id: "DC - CERT OF TITLE-SALVAGE",
    label: "DC - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  { id: "IL - SALVAGE TITLE", label: "IL - SALVAGE TITLE", color: "#008000" },
  { id: "SALVAGE - MO", label: "SALVAGE - MO", color: "#008000" },
  { id: "SALVAGE - NJ", label: "SALVAGE - NJ", color: "#008000" },
  { id: "SALVAGE - CT", label: "SALVAGE - CT", color: "#008000" },
  { id: "SALVAGE - MN", label: "SALVAGE - MN", color: "#008000" },
  {
    id: "IL - DEALER ONLY SALVAGE TITLE",
    label: "IL - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "SC - CERT OF TITLE-SALVAGE NON-REM",
    label: "SC - CERT OF TITLE-SALVAGE NON-REM",
    color: "#008000",
  },
  { id: "SALVAGE - MS", label: "SALVAGE - MS", color: "#008000" },
  {
    id: "AZ - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "AZ - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "NJ - CERT OF TITLE-SLVG LEMON LAW",
    label: "NJ - CERT OF TITLE-SLVG LEMON LAW",
    color: "#008000",
  },
  { id: "SALVAGE - WI", label: "SALVAGE - WI", color: "#008000" },
  { id: "SALVAGE - KS", label: "SALVAGE - KS", color: "#008000" },
  { id: "SALVAGE - ID", label: "SALVAGE - ID", color: "#008000" },
  { id: "SALVAGE - ND", label: "SALVAGE - ND", color: "#008000" },
  { id: "SALVAGE - MD", label: "SALVAGE - MD", color: "#008000" },
  {
    id: "PA - CERT OF TTL-SLVG ALL-TERRAIN V",
    label: "PA - CERT OF TTL-SLVG ALL-TERRAIN V",
    color: "#008000",
  },
  {
    id: "Salvage Repossession (Iowa)",
    label: "Salvage Repossession (Iowa)",
    color: "#008000",
  },
  { id: "SALVAGE - NM", label: "SALVAGE - NM", color: "#008000" },
  {
    id: "CA - APP FOR DUP SALVAGE OR AC",
    label: "CA - APP FOR DUP SALVAGE OR AC",
    color: "#008000",
  },
  {
    id: "FL - DEALER ONLY SALVAGE TITLE",
    label: "FL - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  { id: "Salvage (Florida)", label: "Salvage (Florida)", color: "#008000" },
  {
    id: "WI - CERT OF TITLE W/SALVAGE HISTOR",
    label: "WI - CERT OF TITLE W/SALVAGE HISTOR",
    color: "#008000",
  },
  {
    id: "MS - CERT OF TITLE-SALVAGED",
    label: "MS - CERT OF TITLE-SALVAGED",
    color: "#008000",
  },
  {
    id: "IN - CERT OF TITLE-SALVAGE TITLE",
    label: "IN - CERT OF TITLE-SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "NV - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "NV - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "NJ - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "NJ - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "AZ - CERT OF TITLE - SALVAGE",
    label: "AZ - CERT OF TITLE - SALVAGE",
    color: "#008000",
  },
  {
    id: "CA - DLR/DIS/EXP ONLY SALVAGE TITLE",
    label: "CA - DLR/DIS/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  { id: "Salvage (Idaho)", label: "Salvage (Idaho)", color: "#008000" },
  {
    id: "CT - CERT OF TITLE-SALVAGE",
    label: "CT - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  { id: "Salvage (Oklahoma)", label: "Salvage (Oklahoma)", color: "#008000" },
  {
    id: "Salvage - 75% Or Less (Maryland)",
    label: "Salvage - 75% Or Less (Maryland)",
    color: "#008000",
  },
  {
    id: "OR - SALVAGE TITLE CERTIFICATE",
    label: "OR - SALVAGE TITLE CERTIFICATE",
    color: "#008000",
  },
  {
    id: "CA - SALVAGE CERTIFICATE",
    label: "CA - SALVAGE CERTIFICATE",
    color: "#008000",
  },
  {
    id: "TX - SALVAGE CERTIFICATE",
    label: "TX - SALVAGE CERTIFICATE",
    color: "#008000",
  },
  {
    id: "Salvage Title (Texas)",
    label: "Salvage Title (Texas)",
    color: "#008000",
  },
  {
    id: "VA - CERT OF TITLE - SALVAGE",
    label: "VA - CERT OF TITLE - SALVAGE",
    color: "#008000",
  },
  { id: "Salvage (Montana)", label: "Salvage (Montana)", color: "#008000" },
  {
    id: "GA - COURT ORDER PREVIOUS SALVAGE",
    label: "GA - COURT ORDER PREVIOUS SALVAGE",
    color: "#008000",
  },
  { id: "Salvage (Colorado)", label: "Salvage (Colorado)", color: "#008000" },
  {
    id: "KY - CERT OF TTL-SLVG W/NONREPAIR H",
    label: "KY - CERT OF TTL-SLVG W/NONREPAIR H",
    color: "#FF0000",
  },
  {
    id: "Salvage (North Carolina)",
    label: "Salvage (North Carolina)",
    color: "#008000",
  },
  {
    id: "MA - DEALER ONLY SALVAGE TITLE",
    label: "MA - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "AL - CERT OF TITLE-SALVAGE TITLE",
    label: "AL - CERT OF TITLE-SALVAGE TITLE",
    color: "#008000",
  },
  { id: "Salvage (Ohio)", label: "Salvage (Ohio)", color: "#008000" },
  {
    id: "NY - MV-907A SALVAGE CERTIFICATE",
    label: "NY - MV-907A SALVAGE CERTIFICATE",
    color: "#008000",
  },
  {
    id: "MN - CERT OF TITLE-SALVAGE",
    label: "MN - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  { id: "Salvage (Maine)", label: "Salvage (Maine)", color: "#008000" },
  {
    id: "Salvage Certificate (Hawaii)",
    label: "Salvage Certificate (Hawaii)",
    color: "#008000",
  },
  {
    id: "Salvage Certificate (Texas)",
    label: "Salvage Certificate (Texas)",
    color: "#008000",
  },
  { id: "Salvage (Oregon)", label: "Salvage (Oregon)", color: "#008000" },
  {
    id: "GA - CERT OF TITLE-SALVAGE",
    label: "GA - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "CANADIAN CERTIFICATE OF SALVAGE - MA",
    label: "CANADIAN CERTIFICATE OF SALVAGE - MA",
    color: "#008000",
  },
  {
    id: "FL - CERT OF TITLE SLVG REBUILDABLE",
    label: "FL - CERT OF TITLE SLVG REBUILDABLE",
    color: "#008000",
  },
  {
    id: "NH - CERT OF TITLE-SALVAGE",
    label: "NH - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "UT - SALVAGE CERTIFICATE",
    label: "UT - SALVAGE CERTIFICATE",
    color: "#008000",
  },
  {
    id: "Canadian Certificate Of Salvage (Illinois)",
    label: "Canadian Certificate Of Salvage (Illinois)",
    color: "#008000",
  },
  { id: "CO - SALVAGE TITLE", label: "CO - SALVAGE TITLE", color: "#008000" },
  {
    id: "FL - CERT OF TITLE W/SLVG HISTORY",
    label: "FL - CERT OF TITLE W/SLVG HISTORY",
    color: "#008000",
  },
  {
    id: "TN - SALVAGE CERTIFICATE",
    label: "TN - SALVAGE CERTIFICATE",
    color: "#008000",
  },
  {
    id: "ID - DEALER ONLY SALVAGE TITLE",
    label: "ID - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  { id: "NV - SALVAGE TITLE", label: "NV - SALVAGE TITLE", color: "#008000" },
  {
    id: "AR - CERT OF TITLE-SALVAGE",
    label: "AR - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "NJ - SALVAGE W/ NY REASSIGNMENT",
    label: "NJ - SALVAGE W/ NY REASSIGNMENT",
    color: "#008000",
  },
  {
    id: "NJ - CERT OF TITLE W/SALVAGE HISTOR",
    label: "NJ - CERT OF TITLE W/SALVAGE HISTOR",
    color: "#008000",
  },
  { id: "Salvage Title", label: "Salvage Title", color: "#008000" },
  {
    id: "TX - SALVAGE VEHICLE TITLE",
    label: "TX - SALVAGE VEHICLE TITLE",
    color: "#008000",
  },
  {
    id: "MS - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "MS - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "CA - SALVAGE ACQUISITION BILLOFSALE",
    label: "CA - SALVAGE ACQUISITION BILLOFSALE",
    color: "#008000",
  },
  {
    id: "SC - CERT OF TITLE-SALVAGE",
    label: "SC - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "IA - CERT OF TITLE-SALVAGE TITLE",
    label: "IA - CERT OF TITLE-SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "OH - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "OH - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  { id: "Salvage (Minnesota)", label: "Salvage (Minnesota)", color: "#008000" },
  {
    id: "IL - SALVAGE CERTIFICATE",
    label: "IL - SALVAGE CERTIFICATE",
    color: "#008000",
  },
  {
    id: "MD - CERT OF SALVAGE > 75% DAMAGE",
    label: "MD - CERT OF SALVAGE > 75% DAMAGE",
    color: "#008000",
  },
  { id: "Salvage Title (Iowa)", label: "Salvage Title (Iowa)", color: "#008000" },
  {
    id: "NM - CERT OF TITLE-SALVAGE",
    label: "NM - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "ME - CERT OF TITLE-SALVAGE COLLISIO",
    label: "ME - CERT OF TITLE-SALVAGE COLLISIO",
    color: "#008000",
  },
  {
    id: "PA - CERT OF TITLE W/SALVAGE HISTOR",
    label: "PA - CERT OF TITLE W/SALVAGE HISTOR",
    color: "#008000",
  },
  {
    id: "MT - BONDED SALVAGE TITLE",
    label: "MT - BONDED SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "MT - SALVAGE CERTIFICATE OF A VEHIC",
    label: "MT - SALVAGE CERTIFICATE OF A VEHIC",
    color: "#008000",
  },
  {
    id: "KS - CERT OF TITLE-SALVAGE",
    label: "KS - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "MT - DEALER ONLY SALVAGE TITLE",
    label: "MT - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "MD - CERT OF SALVAGE < 75% DAMAGE",
    label: "MD - CERT OF SALVAGE < 75% DAMAGE",
    color: "#008000",
  },
  {
    id: "Salvage - Greater Than 75% (Maryland)",
    label: "Salvage - Greater Than 75% (Maryland)",
    color: "#008000",
  },
  { id: "Salvage (Georgia)", label: "Salvage (Georgia)", color: "#008000" },
  {
    id: "TX - DEALER ONLY SALVAGE TITLE",
    label: "TX - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "PA - CERTIFICATE OF SALVAGE",
    label: "PA - CERTIFICATE OF SALVAGE",
    color: "#008000",
  },
  {
    id: "MD - DLR ONLY CERT OF SALVAGE",
    label: "MD - DLR ONLY CERT OF SALVAGE",
    color: "#008000",
  },
  {
    id: "OR - DEALER ONLY SALVAGE TITLE",
    label: "OR - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "NE - DEALER ONLY SALVAGE TITLE",
    label: "NE - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "CO - DEALER ONLY SALVAGE TITLE",
    label: "CO - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "MI - CERT OF TITLE-SALVAGE VEHICLE",
    label: "MI - CERT OF TITLE-SALVAGE VEHICLE",
    color: "#008000",
  },
  {
    id: "PA - CERT OF SALVAGE-FORMERLY ABAND",
    label: "PA - CERT OF SALVAGE-FORMERLY ABAND",
    color: "#008000",
  },
  {
    id: "Salvage-Business Only (Colorado)",
    label: "Salvage-Business Only (Colorado)",
    color: "#008000",
  },
  {
    id: "MA - CERT OF TITLE-SALVAGE",
    label: "MA - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "LA - CERT OF TITLE-SALVAGE",
    label: "LA - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "OR - LIEN PAPERS SALVAGE",
    label: "OR - LIEN PAPERS SALVAGE",
    color: "#008000",
  },
  {
    id: "KY - RED SALVAGE - WATER UNREBUILD",
    label: "KY - RED SALVAGE - WATER UNREBUILD",
    color: "#008000",
  },
  {
    id: "CO - PUBLIC - SALVAGE TITLE",
    label: "CO - PUBLIC - SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "Rebuildable (Florida)",
    label: "Rebuildable (Florida)",
    color: "#008000",
  },
  {
    id: "OK - CERT OF TITLE-SALVAGE",
    label: "OK - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "CANADIAN CERTIFICATE OF SALVAGE - KS",
    label: "CANADIAN CERTIFICATE OF SALVAGE - KS",
    color: "#008000",
  },
  { id: "Salvage (Kansas)", label: "Salvage (Kansas)", color: "#008000" },
  { id: "Salvage (Arkansas)", label: "Salvage (Arkansas)", color: "#008000" },
  { id: "Salvage (Kentucky)", label: "Salvage (Kentucky)", color: "#008000" },
  { id: "ON - PERMIT SALVAGE", label: "ON - PERMIT SALVAGE", color: "#008000" },
  {
    id: "Salvage Certificate (California)",
    label: "Salvage Certificate (California)",
    color: "#008000",
  },
  {
    id: "Regular - Salvage (South Dakota)",
    label: "Regular - Salvage (South Dakota)",
    color: "#008000",
  },
  {
    id: "Cosmetic Total Loss Salvage (West Virginia)",
    label: "Cosmetic Total Loss Salvage (West Virginia)",
    color: "#008000",
  },
  {
    id: "Salvage (Massachusetts)",
    label: "Salvage (Massachusetts)",
    color: "#008000",
  },
  {
    id: "Enterprise Vehicles Salvage Only (Wyoming)",
    label: "Enterprise Vehicles Salvage Only (Wyoming)",
    color: "#008000",
  },
  { id: "Salvage (Maryland)", label: "Salvage (Maryland)", color: "#008000" },
  { id: "Salvage (Delaware)", label: "Salvage (Delaware)", color: "#008000" },
  {
    id: "MN - CERT OF TITLE-PRIOR SALVAGE",
    label: "MN - CERT OF TITLE-PRIOR SALVAGE",
    color: "#008000",
  },
  {
    id: "IL - DLR ONLY SALVAGE TITLE",
    label: "IL - DLR ONLY SALVAGE TITLE",
    color: "#008000",
  },
  { id: "Salvage (Missouri)", label: "Salvage (Missouri)", color: "#008000" },
  {
    id: "SC - CERT OF TITLE-SALVAGE WATER",
    label: "SC - CERT OF TITLE-SALVAGE WATER",
    color: "#008000",
  },
  { id: "Salvage (New Jersey)", label: "Salvage (New Jersey)", color: "#008000" },
  { id: "Salvage (Tennessee)", label: "Salvage (Tennessee)", color: "#008000" },
  {
    id: "AZ - SALVAGE TTL W/TITLE ATTACHED",
    label: "AZ - SALVAGE TTL W/TITLE ATTACHED",
    color: "#008000",
  },
  { id: "Salvage (Illinois)", label: "Salvage (Illinois)", color: "#008000" },
  {
    id: "Salvage Certificate (West Virginia)",
    label: "Salvage Certificate (West Virginia)",
    color: "#008000",
  },
  { id: "Salvage (Indiana)", label: "Salvage (Indiana)", color: "#008000" },
  {
    id: "OH - CERT OF TITLE-SALVAGE",
    label: "OH - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "IL - CERT OF TITLE W/SALVAGE HISTOR",
    label: "IL - CERT OF TITLE W/SALVAGE HISTOR",
    color: "#008000",
  },
  { id: "Salvage (Utah)", label: "Salvage (Utah)", color: "#008000" },
  {
    id: "VT - CERT OF TITLE-SALVAGE VEHICLE",
    label: "VT - CERT OF TITLE-SALVAGE VEHICLE",
    color: "#008000",
  },
  { id: "Salvage (Virginia)", label: "Salvage (Virginia)", color: "#008000" },
  {
    id: "TX - AUCTION SALES RECEIPT -SALVAGE",
    label: "TX - AUCTION SALES RECEIPT -SALVAGE",
    color: "#008000",
  },
  {
    id: "Salvage (Mississippi)",
    label: "Salvage (Mississippi)",
    color: "#008000",
  },
  {
    id: "Salvage (North Dakota)",
    label: "Salvage (North Dakota)",
    color: "#008000",
  },
  {
    id: "NJ - SALVAGE CERT-POLICE",
    label: "NJ - SALVAGE CERT-POLICE",
    color: "#008000",
  },
  { id: "Salvage (Nevada)", label: "Salvage (Nevada)", color: "#008000" },
  {
    id: "ENTERPRISE VEHICLES SALVAGE ONLY - TN",
    label: "ENTERPRISE VEHICLES SALVAGE ONLY - TN",
    color: "#008000",
  },
  { id: "Salvage (Vermont)", label: "Salvage (Vermont)", color: "#008000" },
  { id: "Salvage (Nebraska)", label: "Salvage (Nebraska)", color: "#008000" },
  { id: "Salvage (Wisconsin)", label: "Salvage (Wisconsin)", color: "#008000" },
  {
    id: "Salvage (Rhode Island)",
    label: "Salvage (Rhode Island)",
    color: "#008000",
  },
  {
    id: "DE - SALVAGE CERTIFICATE",
    label: "DE - SALVAGE CERTIFICATE",
    color: "#008000",
  },
  {
    id: "DC - GOVERNMENT SALVAGE",
    label: "DC - GOVERNMENT SALVAGE",
    color: "#008000",
  },
  {
    id: "NJ - DEALER ONLY SALVAGE TITLE",
    label: "NJ - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "DCAS  -  SALVAGE - NY",
    label: "DCAS  -  SALVAGE - NY",
    color: "#008000",
  },
  {
    id: "NM - DEALER ONLY SALVAGE TITLE",
    label: "NM - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "NJ - CERT OF TITLE-SALVAGE",
    label: "NJ - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "HI - CERTIFICATE OF SALVAGE",
    label: "HI - CERTIFICATE OF SALVAGE",
    color: "#008000",
  },
  {
    id: "TX - SALVAGE TITLE-EXPORT ONLY",
    label: "TX - SALVAGE TITLE-EXPORT ONLY",
    color: "#008000",
  },
  {
    id: "Enterprise Vehicles Salvage Only (Tennessee)",
    label: "Enterprise Vehicles Salvage Only (Tennessee)",
    color: "#008000",
  },
  {
    id: "KY - CERT OF TITLE-SALVAGE",
    label: "KY - CERT OF TITLE-SALVAGE",
    color: "#008000",
  },
  {
    id: "SC - DEALER ONLY SALVAGE TITLE",
    label: "SC - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  { id: "CN - SALVAGE", label: "CN - SALVAGE", color: "#008000" },
  {
    id: "ND - CERT OF TITLE - SALVAGE VEHICL",
    label: "ND - CERT OF TITLE - SALVAGE VEHICL",
    color: "#008000",
  },
  {
    id: "VT - DEALER ONLY SALVAGE TITLE",
    label: "VT - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "Salvage Title - Dealer (California)",
    label: "Salvage Title - Dealer (California)",
    color: "#008000",
  },
  { id: "Salvage (New Mexico)", label: "Salvage (New Mexico)", color: "#008000" },
  {
    id: "Enterprise Vehicles Salvage Only (Colorado)",
    label: "Enterprise Vehicles Salvage Only (Colorado)",
    color: "#008000",
  },
  {
    id: "Enterprise Vehicles Salvage Only (Delaware)",
    label: "Enterprise Vehicles Salvage Only (Delaware)",
    color: "#008000",
  },
  {
    id: "TX - SALVAGE W/LEMON LAW HISTORTY",
    label: "TX - SALVAGE W/LEMON LAW HISTORTY",
    color: "#008000",
  },
  { id: "Salvage (Michigan)", label: "Salvage (Michigan)", color: "#008000" },
  {
    id: "Salvage Retention (Texas)",
    label: "Salvage Retention (Texas)",
    color: "#008000",
  },
  {
    id: "Enterprise Vehicles Salvage (Arizona)",
    label: "Enterprise Vehicles Salvage (Arizona)",
    color: "#008000",
  },
  {
    id: "TN - DEALER ONLY SALVAGE TITLE",
    label: "TN - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "CA - CERT OF TITLE OR SALVAGE ACQ",
    label: "CA - CERT OF TITLE OR SALVAGE ACQ",
    color: "#008000",
  },
  {
    id: "WA - DEALER ONLY SALVAGE TITLE",
    label: "WA - DEALER ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "Salvage (South Carolina)",
    label: "Salvage (South Carolina)",
    color: "#008000",
  },
  {
    id: "GA - DIS/DLR/EXP ONLY SALVAGE TITLE",
    label: "GA - DIS/DLR/EXP ONLY SALVAGE TITLE",
    color: "#008000",
  },
  {
    id: "Prior Salvage (Minnesota)",
    label: "Prior Salvage (Minnesota)",
    color: "#008000",
  },
  {
    id: "Nb-Salvage (New Brunswick)",
    label: "Nb-Salvage (New Brunswick)",
    color: "#008000",
  },
  {
    id: "Salvage (Pennsylvania)",
    label: "Salvage (Pennsylvania)",
    color: "#008000",
  },
  { id: "Salvage (Louisiana)", label: "Salvage (Louisiana)", color: "#008000" },
  { id: "Salvage (Arizona)", label: "Salvage (Arizona)", color: "#008000" },
  { id: "Salvage (Alabama)", label: "Salvage (Alabama)", color: "#008000" },
  {
    id: "Canadian Certificate Of Salvage (Pennsylvania)",
    label: "Canadian Certificate Of Salvage (Pennsylvania)",
    color: "#008000",
  },
  {
    id: "FL - TAXI REBUILDABLE",
    label: "FL - TAXI REBUILDABLE",
    color: "#008000",
  },
  {
    id: "DC - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "DC - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "LA - DEALER ONLY CLEAN TITLE (P)",
    label: "LA - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "WI - CERT OF TITLE-REBUILT",
    label: "WI - CERT OF TITLE-REBUILT",
    color: "#FF681F",
  },
  {
    id: "NY - DEALER ONLY CLEAN TITLE (P)",
    label: "NY - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "OR - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "OR - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "MI - WATERCRAFT CERT OF TITLE (P)",
    label: "MI - WATERCRAFT CERT OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "TX - BONDED REBUILT FLOOD SALVAGE",
    label: "TX - BONDED REBUILT FLOOD SALVAGE",
    color: "#FF681F",
  },
  {
    id: "ID - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    label: "ID - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "Rebuilt (South Carolina)",
    label: "Rebuilt (South Carolina)",
    color: "#FF681F",
  },
  {
    id: "CT - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "CT - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "SC - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "SC - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "AB - RIV IMPORT CLEAN",
    label: "AB - RIV IMPORT CLEAN",
    color: "#FF681F",
  },
  {
    id: "UT - DEALER ONLY NON-REPAIRABLE",
    label: "UT - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "OR - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    label: "OR - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "WI - NON PUBLIC CLEAN TITLE",
    label: "WI - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "UT - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    label: "UT - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "MD - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    label: "MD - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "CO - DEALER ONLY NON-REPAIRABLE (P)",
    label: "CO - DEALER ONLY NON-REPAIRABLE (P)",
    color: "#FF0000",
  },
  {
    id: "TX - BONDED REBUILT CLEAN",
    label: "TX - BONDED REBUILT CLEAN",
    color: "#FF681F",
  },
  {
    id: "OK - DEALER ONLY CLEAN TITLE (P)",
    label: "OK - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "TX - DEALER ONLY CLEAN TITLE (P)",
    label: "TX - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "CO - DEALER ONLY SALVAGE TITLE (P)",
    label: "CO - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "SD - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "SD - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "NY - CT CLEAN TITLE PUBLIC ELIG.",
    label: "NY - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "OH - CERTIFICATE OF ORIGIN",
    label: "OH - CERTIFICATE OF ORIGIN",
    color: "#FF681F",
  },
  {
    id: "NY - NON PUBLIC CLEAN TITLE",
    label: "NY - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "NV - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "NV - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "OR - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "OR - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "OK - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "OK - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "MO - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    label: "MO - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "NV - DEALER ONLY CLEAN TITLE",
    label: "NV - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  { id: "AL - SALVAGE FLOOD", label: "AL - SALVAGE FLOOD", color: "#FF681F" },
  {
    id: "IN - DEALER ONLY NON-REPAIRABLE",
    label: "IN - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "AZ - NON PUBLIC CLEAN TITLE",
    label: "AZ - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "MI - DEALER ONLY WATERCRAFT TITLE (P)",
    label: "MI - DEALER ONLY WATERCRAFT TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "AB - OOP - NONREPAIRABLE",
    label: "AB - OOP - NONREPAIRABLE",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (Colorado)",
    label: "Certificate Of Origin (Colorado)",
    color: "#FF681F",
  },
  {
    id: "KS - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "KS - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "NH - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "NH - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "OK - CT CLEAN TITLE PUBLIC ELIG.",
    label: "OK - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "AL - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "AL - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "NE - CT CLEAN TITLE PUBLIC ELIG.",
    label: "NE - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "MN - DLR ONLY CERTIFICATE OF TITLE",
    label: "MN - DLR ONLY CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "AZ - DEALER ONLY DISMANTLE",
    label: "AZ - DEALER ONLY DISMANTLE",
    color: "#FF681F",
  },
  {
    id: "WV - CERT OF TITLE-RECONSTRUCTED",
    label: "WV - CERT OF TITLE-RECONSTRUCTED",
    color: "#FF681F",
  },
  {
    id: "OK - CERT OF TITLE-FLOOD DAMAGED (P)",
    label: "OK - CERT OF TITLE-FLOOD DAMAGED (P)",
    color: "#FF681F",
  },
  {
    id: "LA - DEALER ONLY CLEAN TITLE",
    label: "LA - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "GA - CLEAN TITLE WITH THEFT HISTORY (P)",
    label: "GA - CLEAN TITLE WITH THEFT HISTORY (P)",
    color: "#FF681F",
  },
  {
    id: "MA - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "MA - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "LA - PERMIT TO SELL - RECONSTRUCTED",
    label: "LA - PERMIT TO SELL - RECONSTRUCTED",
    color: "#FF681F",
  },
  {
    id: "LA - CT CLEAN TITLE PUBLIC ELIG.",
    label: "LA - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "ID - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "ID - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (Tennessee)",
    label: "Certificate Of Origin (Tennessee)",
    color: "#FF681F",
  },
  {
    id: "Rebuilt/Restored (Wyoming)",
    label: "Rebuilt/Restored (Wyoming)",
    color: "#FF681F",
  },
  {
    id: "AZ - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "AZ - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "MI - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    label: "MI - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (West Virginia)",
    label: "Certificate Of Origin (West Virginia)",
    color: "#FF681F",
  },
  {
    id: "VA - NON PUBLIC CLEAN TITLE",
    label: "VA - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "LA - CERT OF TITLE-RECONSTRCT WATER",
    label: "LA - CERT OF TITLE-RECONSTRCT WATER",
    color: "#FF681F",
  },
  {
    id: "UT - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "UT - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "IA - NON PUBLIC CLEAN TITLE",
    label: "IA - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (North Carolina)",
    label: "Certificate Of Origin (North Carolina)",
    color: "#FF681F",
  },
  {
    id: "SC - CERT OF TITLE-REBUILT WATER SA",
    label: "SC - CERT OF TITLE-REBUILT WATER SA",
    color: "#FF681F",
  },
  {
    id: "KY - DEALER ONLY CLEAN TITLE (P)",
    label: "KY - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "OK - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "OK - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "NH - DEALER ONLY CLEAN TITLE (P)",
    label: "NH - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "CA - DEALER ONLY NON-REPAIRABLE (P)",
    label: "CA - DEALER ONLY NON-REPAIRABLE (P)",
    color: "#FF0000",
  },
  {
    id: "RI - CERT OF TITLE-RECONSTRUCTED SA (P)",
    label: "RI - CERT OF TITLE-RECONSTRUCTED SA (P)",
    color: "#FF681F",
  },
  {
    id: "WV - NON PUBLIC CLEAN TITLE",
    label: "WV - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "IL - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "IL - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "TN - NON-REPAIRABLE CERTIFICATE (P)",
    label: "TN - NON-REPAIRABLE CERTIFICATE (P)",
    color: "#FF0000",
  },
  {
    id: "Regular - Rebuilt (South Dakota)",
    label: "Regular - Rebuilt (South Dakota)",
    color: "#FF681F",
  },
  {
    id: "MT - DEALER ONLY NON-REPAIRABLE",
    label: "MT - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "FL - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "FL - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "NY - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "NY - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  { id: "PR - CLEAN TITLE", label: "PR - CLEAN TITLE", color: "#FF681F" },
  {
    id: "DE - BOAT REGISTRATION CERTIFICATE",
    label: "DE - BOAT REGISTRATION CERTIFICATE",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Minnesota)",
    label: "Enterprise Vehicles Clear Only (Minnesota)",
    color: "#FF681F",
  },
  {
    id: "NH - CERT OF TITLE-REBUILT VEHICLE",
    label: "NH - CERT OF TITLE-REBUILT VEHICLE",
    color: "#FF681F",
  },
  {
    id: "WI - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    label: "WI - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "GA - CERT OF TITLE-REBUILT (P)",
    label: "GA - CERT OF TITLE-REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "MT - CERTIFICATE OF TITLE HAIL",
    label: "MT - CERTIFICATE OF TITLE HAIL",
    color: "#FF681F",
  },
  {
    id: "CT - DEALER ONLY CLEAN TITLE (P)",
    label: "CT - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "OH - CERT OF TITLE-FLOOD VEHICLE (P)",
    label: "OH - CERT OF TITLE-FLOOD VEHICLE (P)",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (Ohio)",
    label: "Certificate Of Origin (Ohio)",
    color: "#FF681F",
  },
  {
    id: "ND - NON PUBLIC CLEAN TITLE",
    label: "ND - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "NJ - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "NJ - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "IA - DEALER ONLY CLEAN TITLE",
    label: "IA - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "UT - DEALER ONLY CLEAN TITLE",
    label: "UT - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "MN - DLR ONLY CERTIFICATE OF TITLE (P)",
    label: "MN - DLR ONLY CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "VA - DLR ONLY CLEAN OVER 25%",
    label: "VA - DLR ONLY CLEAN OVER 25%",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Oregon)",
    label: "Enterprise Vehicles Clear Only (Oregon)",
    color: "#FF681F",
  },
  {
    id: "MD - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "MD - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "NV - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "NV - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "AR - DEALER ONLY CLEAN TITLE (P)",
    label: "AR - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "NE - DEALER ONLY CLEAN TITLE (P)",
    label: "NE - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "NE - CERT OF TITLE-REBUILT SALVAGE (P)",
    label: "NE - CERT OF TITLE-REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "TX - CERT OF TITLE-REBLT SLVG FLOOD (P)",
    label: "TX - CERT OF TITLE-REBLT SLVG FLOOD (P)",
    color: "#FF681F",
  },
  {
    id: "SD - DEALER ONLY CLEAN TITLE",
    label: "SD - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "MI - DLR ONLY CERT OF TITLE W/FLOOD",
    label: "MI - DLR ONLY CERT OF TITLE W/FLOOD",
    color: "#FF681F",
  },
  {
    id: "NE - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "NE - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "WY - NON PUBLIC CLEAN TITLE",
    label: "WY - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "NH - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "NH - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "TX - CERTIFICATE OF ORIGIN (P)",
    label: "TX - CERTIFICATE OF ORIGIN (P)",
    color: "#FF681F",
  },
  {
    id: "TX - CERT OF TITLE - FLOOD",
    label: "TX - CERT OF TITLE - FLOOD",
    color: "#FF681F",
  },
  {
    id: "MN - CERT OF TITLE-SALVAGE FLOOD (P)",
    label: "MN - CERT OF TITLE-SALVAGE FLOOD (P)",
    color: "#FF681F",
  },
  { id: "AB - BOS - REBUILT", label: "AB - BOS - REBUILT", color: "#FF681F" },
  {
    id: "VA - CERT OF TITLE-SALVAGE REBUILT (P)",
    label: "VA - CERT OF TITLE-SALVAGE REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "WY - CERTIFICATE OF TITLE (P)",
    label: "WY - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "MO - NON PUBLIC CLEAN TITLE",
    label: "MO - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "FL - CERT OF TITLE-FLOOD DAMAGED",
    label: "FL - CERT OF TITLE-FLOOD DAMAGED",
    color: "#FF681F",
  },
  {
    id: "AR - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    label: "AR - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "CO - CERT OF TITLE-REBUILT SALVAGE (P)",
    label: "CO - CERT OF TITLE-REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "PA - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    label: "PA - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "TX - BONDED REBUILT CLEAN (P)",
    label: "TX - BONDED REBUILT CLEAN (P)",
    color: "#FF681F",
  },
  {
    id: "MS - CERT OF TITLE-BONDED TITLE",
    label: "MS - CERT OF TITLE-BONDED TITLE",
    color: "#FF681F",
  },
  {
    id: "GA - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "GA - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "ME - DEALER ONLY CLEAN TITLE",
    label: "ME - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "PA - CERT OF TITLE-W&R=FLOOD&RECNST",
    label: "PA - CERT OF TITLE-W&R=FLOOD&RECNST",
    color: "#FF681F",
  },
  {
    id: "MI - CERT OF TITLE-REBUILT SALVAGE (P)",
    label: "MI - CERT OF TITLE-REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "LA - CERTIFICATE OF ORIGIN (P)",
    label: "LA - CERTIFICATE OF ORIGIN (P)",
    color: "#FF681F",
  },
  {
    id: "SC - DEALER ONLY NON-REPAIRABLE",
    label: "SC - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "Certificate Of Origin (New Mexico)",
    label: "Certificate Of Origin (New Mexico)",
    color: "#FF681F",
  },
  {
    id: "MN - CERTIFICATE OF ORIGIN/MSO",
    label: "MN - CERTIFICATE OF ORIGIN/MSO",
    color: "#FF681F",
  },
  {
    id: "MS - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "MS - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "KY - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "KY - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "AL - CT CLEAN TITLE PUBLIC ELIG.",
    label: "AL - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "ON - PERMIT REBUILT - UNFIT (P)",
    label: "ON - PERMIT REBUILT - UNFIT (P)",
    color: "#FF681F",
  },
  {
    id: "NJ - DEALER ONLY SALVAGE TITLE (P)",
    label: "NJ - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "CO - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    label: "CO - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "Nb-Non-Repairable (New Brunswick)",
    label: "Nb-Non-Repairable (New Brunswick)",
    color: "#FF0000",
  },
  {
    id: "AK - CERT OF VEH TITLE-RECONSTRUCTE (P)",
    label: "AK - CERT OF VEH TITLE-RECONSTRUCTE (P)",
    color: "#FF681F",
  },
  {
    id: "TN - SALVAGE CERT-REBUILT VEHICLE",
    label: "TN - SALVAGE CERT-REBUILT VEHICLE",
    color: "#FF681F",
  },
  {
    id: "WI - CERT OF TITLE-FLOOD DAMAGED",
    label: "WI - CERT OF TITLE-FLOOD DAMAGED",
    color: "#FF681F",
  },
  {
    id: "IL - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    label: "IL - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "GA - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "GA - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "IA - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "IA - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "KY - RED REBUILT FLOOD (P)",
    label: "KY - RED REBUILT FLOOD (P)",
    color: "#FF681F",
  },
  {
    id: "TN - SALVAGE CERT-REBUILT VEHICLE (P)",
    label: "TN - SALVAGE CERT-REBUILT VEHICLE (P)",
    color: "#FF681F",
  },
  {
    id: "TX - BONDED FLOOD SALVAGE",
    label: "TX - BONDED FLOOD SALVAGE",
    color: "#FF681F",
  },
  {
    id: "KY - CERT OF TITLE-SALVAGE WATER (P)",
    label: "KY - CERT OF TITLE-SALVAGE WATER (P)",
    color: "#FF681F",
  },
  {
    id: "ON - PERMIT REBUILT - FIT (P)",
    label: "ON - PERMIT REBUILT - FIT (P)",
    color: "#FF681F",
  },
  {
    id: "TX - DEALER ONLY NON-REPAIRABLE (P)",
    label: "TX - DEALER ONLY NON-REPAIRABLE (P)",
    color: "#FF0000",
  },
  {
    id: "CO - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "CO - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "RI - CERT OF TITLE-RECONSTRUCTED SA",
    label: "RI - CERT OF TITLE-RECONSTRUCTED SA",
    color: "#FF681F",
  },
  {
    id: "CO - DLR ONLY CLEAN TITLE",
    label: "CO - DLR ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "SC - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "SC - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "UT - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "UT - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "NY - DIS/DLR/EXP CLEAN TITLE",
    label: "NY - DIS/DLR/EXP CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "HI - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "HI - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "ME - CERT OF TITLE-SALVAGE REBUILT",
    label: "ME - CERT OF TITLE-SALVAGE REBUILT",
    color: "#FF681F",
  },
  {
    id: "TX - CERTIFICATE OF ORIGIN",
    label: "TX - CERTIFICATE OF ORIGIN",
    color: "#FF681F",
  },
  {
    id: "Clear-Dealer Only (Indiana)",
    label: "Clear-Dealer Only (Indiana)",
    color: "#008000",
  },
  {
    id: "Canadian Non-Repairable (Alabama)",
    label: "Canadian Non-Repairable (Alabama)",
    color: "#FF0000",
  },
  {
    id: "MO - CLEAN TITLE W/SALVAGE HISTORY",
    label: "MO - CLEAN TITLE W/SALVAGE HISTORY",
    color: "#FF681F",
  },
  {
    id: "AL - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "AL - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "OH - DLR ONLY CLEAN TITLE",
    label: "OH - DLR ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "VA - CERT OF TITLE-RECONSTRUCTED",
    label: "VA - CERT OF TITLE-RECONSTRUCTED",
    color: "#FF681F",
  },
  {
    id: "Clear-Dealer Only (Iowa)",
    label: "Clear-Dealer Only (Iowa)",
    color: "#008000",
  },
  {
    id: "NB - CLEAN TITLE (P)",
    label: "NB - CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (Florida)",
    label: "Certificate Of Origin (Florida)",
    color: "#FF681F",
  },
  {
    id: "RI - DEALER ONLY CLEAN TITLE",
    label: "RI - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "VA - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "VA - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "CO - NON PUBLIC CLEAN TITLE",
    label: "CO - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "MT - DEALER ONLY CLEAN TITLE (P)",
    label: "MT - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "Sk-Rebuilt (Saskatchewan)",
    label: "Sk-Rebuilt (Saskatchewan)",
    color: "#FF681F",
  },
  {
    id: "CA - CERTIFICATE OF ORIGIN",
    label: "CA - CERTIFICATE OF ORIGIN",
    color: "#FF681F",
  },
  {
    id: "IN - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "IN - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "Massdealer (Massachusetts)",
    label: "Massdealer (Massachusetts)",
    color: "#FF681F",
  },
  {
    id: "AZ - DEALER ONLY SALVAGE (P)",
    label: "AZ - DEALER ONLY SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "ME - DEALER ONLY CLEAN TITLE (P)",
    label: "ME - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "WI - DEALER ONLY CLEAN TITLE",
    label: "WI - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "Clear-Dealer Only-Endorsement (Minnesota)",
    label: "Clear-Dealer Only-Endorsement (Minnesota)",
    color: "#FF681F",
  },
  {
    id: "PA - CERT OF SALV-R=RECONSTRUCTED (P)",
    label: "PA - CERT OF SALV-R=RECONSTRUCTED (P)",
    color: "#FF681F",
  },
  {
    id: "KS - CERT OF TITLE-REBUILT SALVAGE (P)",
    label: "KS - CERT OF TITLE-REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (New York)",
    label: "Certificate Of Origin (New York)",
    color: "#FF681F",
  },
  {
    id: "RI - CERT OF TITLE-SALVAGE FLOOD",
    label: "RI - CERT OF TITLE-SALVAGE FLOOD",
    color: "#FF681F",
  },
  {
    id: "MS - CERT OF TITLE-REBUILT (P)",
    label: "MS - CERT OF TITLE-REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (Texas)",
    label: "Certificate Of Origin (Texas)",
    color: "#FF681F",
  },
  {
    id: "AL - CERT OF TITLE-FLOOD SALVAGE (P)",
    label: "AL - CERT OF TITLE-FLOOD SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Nebraska)",
    label: "Enterprise Vehicles Clear Only (Nebraska)",
    color: "#FF681F",
  },
  {
    id: "MN - DEALER ONLY CLEAN TITLE (P)",
    label: "MN - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "OR - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "OR - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "UT - DEALER ONLY CLEAN TITLE (P)",
    label: "UT - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "Clear-Dealer Only (Kentucky)",
    label: "Clear-Dealer Only (Kentucky)",
    color: "#008000",
  },
  {
    id: "ON - PERMIT REBUILT - FIT",
    label: "ON - PERMIT REBUILT - FIT",
    color: "#FF681F",
  },
  {
    id: "LA - CERT OF TITLE-RECONSTRUCTED (P)",
    label: "LA - CERT OF TITLE-RECONSTRUCTED (P)",
    color: "#FF681F",
  },
  {
    id: "MS - DLR ONLY CERTIFICATE OF TITLE",
    label: "MS - DLR ONLY CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "NV - DEALER ONLY CLEAN TITLE (P)",
    label: "NV - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "Rebuilt (Washington)",
    label: "Rebuilt (Washington)",
    color: "#FF681F",
  },
  {
    id: "LA - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    label: "LA - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "AR - DEALER ONLY CLEAN TITLE",
    label: "AR - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "SD - CERTIFICATE OF TITLE (P)",
    label: "SD - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "WI - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "WI - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "OK - CERT OF TITLE-FLOOD DAMAGED",
    label: "OK - CERT OF TITLE-FLOOD DAMAGED",
    color: "#FF681F",
  },
  {
    id: "NC - DEALER ONLY NON-REPAIRABLE",
    label: "NC - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "Clear-Dealer Only (Wisconsin)",
    label: "Clear-Dealer Only (Wisconsin)",
    color: "#008000",
  },
  {
    id: "Rebuilt - Public Restricted (Oklahoma)",
    label: "Rebuilt - Public Restricted (Oklahoma)",
    color: "#FF681F",
  },
  {
    id: "TX - BONDED REBUILT SALVAGE (P)",
    label: "TX - BONDED REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "TX - CT REBUILT SALVAGE PUBLIC ELIG",
    label: "TX - CT REBUILT SALVAGE PUBLIC ELIG",
    color: "#FF681F",
  },
  {
    id: "AL - DEALER ONLY CLEAN TITLE",
    label: "AL - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "AL - CERT OF TITLE-REBUILT SALVAGE (P)",
    label: "AL - CERT OF TITLE-REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "Pe-Non-Repairable (Prince Edward Island)",
    label: "Pe-Non-Repairable (Prince Edward Island)",
    color: "#FF0000",
  },
  {
    id: "OH - CERT OF TITLE-REBUILT SALVAGE (P)",
    label: "OH - CERT OF TITLE-REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "UT - CERT OF TITLE-FLOOD/RESTORED",
    label: "UT - CERT OF TITLE-FLOOD/RESTORED",
    color: "#FF681F",
  },
  {
    id: "MN - CERT OF TITLE-FLOOD",
    label: "MN - CERT OF TITLE-FLOOD",
    color: "#FF681F",
  },
  {
    id: "NV - CERT OF TITLE-REBUILT TOTAL LO (P)",
    label: "NV - CERT OF TITLE-REBUILT TOTAL LO (P)",
    color: "#FF681F",
  },
  {
    id: "MN - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "MN - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "Ab-Rebuilt (Alberta)",
    label: "Ab-Rebuilt (Alberta)",
    color: "#FF681F",
  },
  {
    id: "NC - NC DLR ONLY SLVG REBUILT",
    label: "NC - NC DLR ONLY SLVG REBUILT",
    color: "#FF681F",
  },
  {
    id: "MA - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "MA - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "NY - CLEAN TITLE W/SALVAGE HISTORY",
    label: "NY - CLEAN TITLE W/SALVAGE HISTORY",
    color: "#FF681F",
  },
  {
    id: "WI - CERT OF TITLE-REBUILT SALVAGE",
    label: "WI - CERT OF TITLE-REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "HI - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "HI - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "OK - DEALER ONLY SALVAGE TITLE (P)",
    label: "OK - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "ME - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "ME - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "ND - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "ND - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "OH - CERT OF TITLE-FLOOD VEHICLE",
    label: "OH - CERT OF TITLE-FLOOD VEHICLE",
    color: "#FF681F",
  },
  {
    id: "CT - SALVAGE CERTIFICATE OF ORIGIN",
    label: "CT - SALVAGE CERTIFICATE OF ORIGIN",
    color: "#008000",
  },
  {
    id: "Enterprise Vehicles Clear Only (Iowa)",
    label: "Enterprise Vehicles Clear Only (Iowa)",
    color: "#FF681F",
  },
  {
    id: "FL - DEALER ONLY SALVAGE TITLE (P)",
    label: "FL - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "Enterprise Vehicles Clear Only (Alabama)",
    label: "Enterprise Vehicles Clear Only (Alabama)",
    color: "#FF681F",
  },
  {
    id: "NJ - NON PUBLIC CLEAN TITLE",
    label: "NJ - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "MO - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "MO - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "VA - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    label: "VA - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "TX - CT CLEAN TITLE PUBLIC ELIG.",
    label: "TX - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "OK - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "OK - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  { id: "PE - CLEAN TITLE", label: "PE - CLEAN TITLE", color: "#FF681F" },
  {
    id: "MD - DEALER ONLY CLEAN TITLE (P)",
    label: "MD - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "MT - CT CLEAN TITLE PUBLIC ELIG.",
    label: "MT - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "NC - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "NC - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "WV - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "WV - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "RI - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "RI - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "WA - CT CLEAN TITLE PUBLIC ELIG. (P)",
    label: "WA - CT CLEAN TITLE PUBLIC ELIG. (P)",
    color: "#FF681F",
  },
  {
    id: "UT - NON-REPAIRABLE CERTIFICATE (P)",
    label: "UT - NON-REPAIRABLE CERTIFICATE (P)",
    color: "#FF0000",
  },
  {
    id: "MA - DEALER ONLY CLEAN TITLE (P)",
    label: "MA - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "AK - DEALER ONLY CLEAN TITLE",
    label: "AK - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "NY - DEALER ONLY NON-REPAIRABLE (P)",
    label: "NY - DEALER ONLY NON-REPAIRABLE (P)",
    color: "#FF0000",
  },
  {
    id: "Certificate Of Origin (North Dakota)",
    label: "Certificate Of Origin (North Dakota)",
    color: "#FF681F",
  },
  {
    id: "MA - DEALER ONLY CLEAN TITLE",
    label: "MA - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "Flood/Restored (Utah)",
    label: "Flood/Restored (Utah)",
    color: "#FF681F",
  },
  {
    id: "KY - CERT OF TITLE - REBUILT - RED",
    label: "KY - CERT OF TITLE - REBUILT - RED",
    color: "#FF681F",
  },
  {
    id: "MI - SCRAP CERT OF TITLE-FLOOD VEH (P)",
    label: "MI - SCRAP CERT OF TITLE-FLOOD VEH (P)",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (New Jersey)",
    label: "Certificate Of Origin (New Jersey)",
    color: "#FF681F",
  },
  {
    id: "GA - CERT OF TITLE-COURT ORDER (P)",
    label: "GA - CERT OF TITLE-COURT ORDER (P)",
    color: "#FF681F",
  },
  {
    id: "GA - DEALER ONLY SALVAGE TITLE (P)",
    label: "GA - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "IL - DEALER ONLY NON-REPAIRABLE (P)",
    label: "IL - DEALER ONLY NON-REPAIRABLE (P)",
    color: "#FF0000",
  },
  {
    id: "VA - CERT OF TITLE-SALVAGE REBUILT",
    label: "VA - CERT OF TITLE-SALVAGE REBUILT",
    color: "#FF681F",
  },
  {
    id: "Clear-Dealer Only (Maryland)",
    label: "Clear-Dealer Only (Maryland)",
    color: "#008000",
  },
  {
    id: "GA - CERT OF TITLE-FLOOD SALVAGE (P)",
    label: "GA - CERT OF TITLE-FLOOD SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "CA - LIEN PAPERS-CLEAN OR AC (P)",
    label: "CA - LIEN PAPERS-CLEAN OR AC (P)",
    color: "#FF681F",
  },
  {
    id: "AL - CERT OF TITLE-FLOOD VEHICLE",
    label: "AL - CERT OF TITLE-FLOOD VEHICLE",
    color: "#FF681F",
  },
  {
    id: "IA - CT CLEAN TITLE PUBLIC ELIG.",
    label: "IA - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (Alabama)",
    label: "Certificate Of Origin (Alabama)",
    color: "#FF681F",
  },
  {
    id: "MI - SCRAP CERTIFICATE OF TITLE (P)",
    label: "MI - SCRAP CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "IN - CERT OF TITLE-SALVAGE FLOOD (P)",
    label: "IN - CERT OF TITLE-SALVAGE FLOOD (P)",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Tennessee)",
    label: "Enterprise Vehicles Clear Only (Tennessee)",
    color: "#FF681F",
  },
  {
    id: "NY - FLOOD SALVAGE (P)",
    label: "NY - FLOOD SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "KY - CLEAN TITLE W/SALVAGE HISTORY",
    label: "KY - CLEAN TITLE W/SALVAGE HISTORY",
    color: "#FF681F",
  },
  {
    id: "PA - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "PA - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "MO - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "MO - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "KY - CLEAN RED REBUILT BRANDED (P)",
    label: "KY - CLEAN RED REBUILT BRANDED (P)",
    color: "#FF681F",
  },
  {
    id: "VA - DEALER ONLY SALVAGE TITLE (P)",
    label: "VA - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "CA - NON PUBLIC CLEAN TITLE",
    label: "CA - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "LA - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "LA - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "VA - DEALER ONLY NON-REPAIRABLE (P)",
    label: "VA - DEALER ONLY NON-REPAIRABLE (P)",
    color: "#FF0000",
  },
  {
    id: "KY - RED REBUILT HAIL SALVAGE",
    label: "KY - RED REBUILT HAIL SALVAGE",
    color: "#FF681F",
  },
  {
    id: "ON - RIV IMPORT CLEAN",
    label: "ON - RIV IMPORT CLEAN",
    color: "#FF681F",
  },
  {
    id: "ME - CERT OF TITLE-REBUILT VEHICLE",
    label: "ME - CERT OF TITLE-REBUILT VEHICLE",
    color: "#FF681F",
  },
  {
    id: "MO - CT CLEAN TITLE PUBLIC ELIG.",
    label: "MO - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "OH - NON PUBLIC CLEAN TITLE",
    label: "OH - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "AR - CERT OF TITLE-REBUILT (P)",
    label: "AR - CERT OF TITLE-REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "KY - CERT OF TITLE-REBUILT VEHICLE (P)",
    label: "KY - CERT OF TITLE-REBUILT VEHICLE (P)",
    color: "#FF681F",
  },
  {
    id: "NE - SALVAGE TITLE/FLOOD",
    label: "NE - SALVAGE TITLE/FLOOD",
    color: "#FF681F",
  },
  {
    id: "NC - SALVAGE CERT-WATER/FLOOD DAMAG (P)",
    label: "NC - SALVAGE CERT-WATER/FLOOD DAMAG (P)",
    color: "#FF681F",
  },
  {
    id: "NY - CERT OF TITLE-REBUILT SALVAGE (P)",
    label: "NY - CERT OF TITLE-REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "WY - CERTIFICATE OF TITLE - REBUILT",
    label: "WY - CERTIFICATE OF TITLE - REBUILT",
    color: "#FF681F",
  },
  {
    id: "CA - DEALER ONLY NON-REPAIRABLE",
    label: "CA - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "MI - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "MI - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "GA - CERTIFICATE OF TITLE-BONDED",
    label: "GA - CERTIFICATE OF TITLE-BONDED",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Mississippi)",
    label: "Enterprise Vehicles Clear Only (Mississippi)",
    color: "#FF681F",
  },
  {
    id: "PA - CERT OF TTL-W=FLOOD&SLVG HISTO (P)",
    label: "PA - CERT OF TTL-W=FLOOD&SLVG HISTO (P)",
    color: "#FF681F",
  },
  {
    id: "TN - SALVAGE CERT-WATER DAMAGE (P)",
    label: "TN - SALVAGE CERT-WATER DAMAGE (P)",
    color: "#FF681F",
  },
  {
    id: "CA - DEALER ONLY SALVAGE TITLE (P)",
    label: "CA - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "NH - DEALER ONLY CLEAN TITLE",
    label: "NH - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "Non-Repairable (District Of Columbia)",
    label: "Non-Repairable (District Of Columbia)",
    color: "#FF0000",
  },
  {
    id: "HI - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "HI - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "PA - DEALER ONLY CLEAN TITLE (P)",
    label: "PA - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "AZ - DEALER ONLY SALVAGE TITLE (P)",
    label: "AZ - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "MI - CT CLEAN TITLE PUBLIC ELIG.",
    label: "MI - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (Alaska)",
    label: "Certificate Of Origin (Alaska)",
    color: "#FF681F",
  },
  {
    id: "IL - DLR ONLY CLEAN TITLE",
    label: "IL - DLR ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "KY - RED REBUILT CLEAN",
    label: "KY - RED REBUILT CLEAN",
    color: "#FF681F",
  },
  {
    id: "MS - DEALER ONLY CLEAN TITLE (P)",
    label: "MS - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "MT - CERT OF TITLE-REBUILT SALVAGE",
    label: "MT - CERT OF TITLE-REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "SC - DEALER ONLY SALVAGE TITLE (P)",
    label: "SC - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "NV - SALVAGE TITLE-FLOOD DAMAGE (P)",
    label: "NV - SALVAGE TITLE-FLOOD DAMAGE (P)",
    color: "#FF681F",
  },
  {
    id: "FL - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    label: "FL - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "WV - DEALER ONLY CLEAN TITLE",
    label: "WV - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "CT - CERT OF TITLE-REBUILT",
    label: "CT - CERT OF TITLE-REBUILT",
    color: "#FF681F",
  },
  {
    id: "IN - DEALER ONLY SALVAGE TITLE (P)",
    label: "IN - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "MT - NON PUBLIC CLEAN TITLE",
    label: "MT - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "DC - CERTIFICATE OF TITLE (P)",
    label: "DC - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "GA - DLR ONLY CLEAN TTL/EXCEEDS 25% (P)",
    label: "GA - DLR ONLY CLEAN TTL/EXCEEDS 25% (P)",
    color: "#FF681F",
  },
  {
    id: "MA - CERT OF TITLE-RECONSTRCTD FLD (P)",
    label: "MA - CERT OF TITLE-RECONSTRCTD FLD (P)",
    color: "#FF681F",
  },
  {
    id: "CA - DEALER ONLY CLEAN TITLE",
    label: "CA - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "NY - DEALER ONLY CLEAN TITLE",
    label: "NY - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "GA - CERT OF TITLE-REBUILT SALVAGE (P)",
    label: "GA - CERT OF TITLE-REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "IL - CERT OF TITLE-FLOOD/REBUILT (P)",
    label: "IL - CERT OF TITLE-FLOOD/REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "MI - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "MI - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "AZ - CERT OF TITLE-RECONST",
    label: "AZ - CERT OF TITLE-RECONST",
    color: "#FF681F",
  },
  {
    id: "MO - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "MO - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "GA - DLR ONLY CLEAN TTL/EXCEEDS 25%",
    label: "GA - DLR ONLY CLEAN TTL/EXCEEDS 25%",
    color: "#FF681F",
  },
  { id: "NY - CLEAN TITLE", label: "NY - CLEAN TITLE", color: "#FF681F" },
  {
    id: "DE - CERT OF TITLE-FLOOD-VEH",
    label: "DE - CERT OF TITLE-FLOOD-VEH",
    color: "#FF681F",
  },
  {
    id: "Clear-Dealer Only (North Carolina)",
    label: "Clear-Dealer Only (North Carolina)",
    color: "#008000",
  },
  {
    id: "NY - CERT OF TITLE-REBUILT (P)",
    label: "NY - CERT OF TITLE-REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "MD - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "MD - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "MS - CERT OF TITLE - FLOOD SALVAGE (P)",
    label: "MS - CERT OF TITLE - FLOOD SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "CT - CERTIFICATE OF ORIGIN (P)",
    label: "CT - CERTIFICATE OF ORIGIN (P)",
    color: "#FF681F",
  },
  {
    id: "VA - CLEAN TITLE OVER 25% DAMAGE",
    label: "VA - CLEAN TITLE OVER 25% DAMAGE",
    color: "#FF681F",
  },
  {
    id: "TN - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "TN - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "RI - CERTIFICATE OF TITLE",
    label: "RI - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "MI - DEALER ONLY SALVAGE TITLE (P)",
    label: "MI - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  { id: "Original", label: "Original", color: "#FF681F" },
  {
    id: "HI - CERT OF TITLE-REBUILT SALVAGED",
    label: "HI - CERT OF TITLE-REBUILT SALVAGED",
    color: "#FF681F",
  },
  {
    id: "TX - CERT OF TITLE TO A BOAT (P)",
    label: "TX - CERT OF TITLE TO A BOAT (P)",
    color: "#FF681F",
  },
  {
    id: "KY - RED REBUILT SALVAGE (P)",
    label: "KY - RED REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "KY - RED REBUILT SALVAGE BRANDED (P)",
    label: "KY - RED REBUILT SALVAGE BRANDED (P)",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF ORIGIN - NE",
    label: "CERTIFICATE OF ORIGIN - NE",
    color: "#FF681F",
  },
  {
    id: "CLEAR  -  DEALER ONLY - KS",
    label: "CLEAR  -  DEALER ONLY - KS",
    color: "#008000",
  },
  {
    id: "MI - CERTIFICATE OF ORIGIN",
    label: "MI - CERTIFICATE OF ORIGIN",
    color: "#FF681F",
  },
  {
    id: "AL - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "AL - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "IN - CERT OF TITLE - REBUILT FLOOD (P)",
    label: "IN - CERT OF TITLE - REBUILT FLOOD (P)",
    color: "#FF681F",
  },
  {
    id: "FL - CERT OF TITLE-POLICE (P)",
    label: "FL - CERT OF TITLE-POLICE (P)",
    color: "#FF681F",
  },
  {
    id: "UT - CERT OF TITLE-FLOOD/RESTORED (P)",
    label: "UT - CERT OF TITLE-FLOOD/RESTORED (P)",
    color: "#FF681F",
  },
  {
    id: "VT - FLOOD SALVAGE (P)",
    label: "VT - FLOOD SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "NY - DLR ONLY CLEAN TTL/EXCEEDS 25%",
    label: "NY - DLR ONLY CLEAN TTL/EXCEEDS 25%",
    color: "#FF681F",
  },
  {
    id: "IN - DEALER ONLY NON-REPAIRABLE (P)",
    label: "IN - DEALER ONLY NON-REPAIRABLE (P)",
    color: "#FF0000",
  },
  {
    id: "MI - CERT OF TITLE-SALVAGE FLOOD (P)",
    label: "MI - CERT OF TITLE-SALVAGE FLOOD (P)",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF VESSEL - NC",
    label: "CERTIFICATE OF VESSEL - NC",
    color: "#FF681F",
  },
  {
    id: "OR - DEALER ONLY CLEAN TITLE",
    label: "OR - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "PA - DEALER ONLY SALVAGE TITLE (P)",
    label: "PA - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "CO - REBUILT SALVAGE - DEALER ONLY",
    label: "CO - REBUILT SALVAGE - DEALER ONLY",
    color: "#FF681F",
  },
  {
    id: "CLEAR - DEALER ONLY - AR",
    label: "CLEAR - DEALER ONLY - AR",
    color: "#008000",
  },
  {
    id: "VA - DEALER ONLY NON-REPAIRABLE",
    label: "VA - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "NC - VESSEL-CERTIFICATE OF TITLE (P)",
    label: "NC - VESSEL-CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "IN - CLEAN TITLE - MANUFCTR BUYBACK (P)",
    label: "IN - CLEAN TITLE - MANUFCTR BUYBACK (P)",
    color: "#FF681F",
  },
  {
    id: "TN - NON PUBLIC CLEAN TITLE",
    label: "TN - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "AR - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "AR - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "IN - CERTIFICATE OF ORIGIN",
    label: "IN - CERTIFICATE OF ORIGIN",
    color: "#FF681F",
  },
  {
    id: "MN - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    label: "MN - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "TX - CLEAN TITLE EXPORT ONLY",
    label: "TX - CLEAN TITLE EXPORT ONLY",
    color: "#FF681F",
  },
  {
    id: "REGULAR  -  REBUILT - SD",
    label: "REGULAR  -  REBUILT - SD",
    color: "#FF681F",
  },
  {
    id: "OK - DLR ONLY CLEAN TITLE",
    label: "OK - DLR ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "IL - CERTIFICATE OF ORIGIN",
    label: "IL - CERTIFICATE OF ORIGIN",
    color: "#FF681F",
  },
  { id: "Original (New York)", label: "Original (New York)", color: "#FF681F" },
  {
    id: "VT - CT CLEAN TITLE PUBLIC ELIG. (P)",
    label: "VT - CT CLEAN TITLE PUBLIC ELIG. (P)",
    color: "#FF681F",
  },
  {
    id: "Non-Repairable (Mississippi)",
    label: "Non-Repairable (Mississippi)",
    color: "#FF0000",
  },
  {
    id: "NC - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "NC - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "AZ - CLEAN TITLE BRANDED FLOOD (P)",
    label: "AZ - CLEAN TITLE BRANDED FLOOD (P)",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Wyoming)",
    label: "Enterprise Vehicles Clear Only (Wyoming)",
    color: "#FF681F",
  },
  {
    id: "TN - CERTIFICATE OF ORIGIN (P)",
    label: "TN - CERTIFICATE OF ORIGIN (P)",
    color: "#FF681F",
  },
  {
    id: "ME - CERT OF TITLE-SALVAGE REBUILT (P)",
    label: "ME - CERT OF TITLE-SALVAGE REBUILT (P)",
    color: "#FF681F",
  },
  { id: "Original (Maryland)", label: "Original (Maryland)", color: "#FF681F" },
  {
    id: "OR - DEALER ONLY SALVAGE TITLE (P)",
    label: "OR - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "TN - CERT OF TITLE-FLOOD VEHICLE (P)",
    label: "TN - CERT OF TITLE-FLOOD VEHICLE (P)",
    color: "#FF681F",
  },
  { id: "REBUILT - SC", label: "REBUILT - SC", color: "#FF681F" },
  { id: "Repairable (SK)", label: "Repairable (SK)", color: "#FF681F" },
  {
    id: "UT - CERT OF SALE - REBUILT/RESTORE (P)",
    label: "UT - CERT OF SALE - REBUILT/RESTORE (P)",
    color: "#FF681F",
  },
  {
    id: "VA - CERT OF TITLE TO A VESSEL (P)",
    label: "VA - CERT OF TITLE TO A VESSEL (P)",
    color: "#FF681F",
  },
  {
    id: "NH - CERT OF TTL-FLOOD SALVAGE (P)",
    label: "NH - CERT OF TTL-FLOOD SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "NV - NON PUBLIC CLEAN TITLE",
    label: "NV - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "AZ - CT CLEAN TITLE PUBLIC ELIG.",
    label: "AZ - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "PA - CERT OF TITLE-W=FLOOD VEHICLE",
    label: "PA - CERT OF TITLE-W=FLOOD VEHICLE",
    color: "#FF681F",
  },
  { id: "Repairable (BC)", label: "Repairable (BC)", color: "#FF681F" },
  {
    id: "WI - CERT OF TITLE-CLAIM PAID (P)",
    label: "WI - CERT OF TITLE-CLAIM PAID (P)",
    color: "#FF681F",
  },
  {
    id: "DE - NON PUBLIC CLEAN TITLE",
    label: "DE - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  { id: "Repairable (MB)", label: "Repairable (MB)", color: "#FF681F" },
  {
    id: "Certificate Of Origin (Nebraska)",
    label: "Certificate Of Origin (Nebraska)",
    color: "#FF681F",
  },
  { id: "Repairable (ON)", label: "Repairable (ON)", color: "#FF681F" },
  {
    id: "NJ - CERT OF TITLE - FLOOD (P)",
    label: "NJ - CERT OF TITLE - FLOOD (P)",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Maine)",
    label: "Enterprise Vehicles Clear Only (Maine)",
    color: "#FF681F",
  },
  { id: "Clear (Kentucky)", label: "Clear (Kentucky)", color: "#FF681F" },
  {
    id: "KY - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "KY - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  { id: "Original (Florida)", label: "Original (Florida)", color: "#FF681F" },
  { id: "Clear (Maine)", label: "Clear (Maine)", color: "#FF681F" },
  { id: "Clear (Iowa)", label: "Clear (Iowa)", color: "#FF681F" },
  {
    id: "Original (New Jersey)",
    label: "Original (New Jersey)",
    color: "#FF681F",
  },
  {
    id: "KS - DLR ONLY CERTIFICATE OF TITLE",
    label: "KS - DLR ONLY CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "KY - CT CLEAN TITLE PUBLIC ELIG.",
    label: "KY - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "PA - DLR ONLY CLEAN TITLE",
    label: "PA - DLR ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "ME - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "ME - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "VT - DEALER ONLY CLEAN TITLE",
    label: "VT - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "MI - CERT OF TITLE-FLOOD VEHICLE (P)",
    label: "MI - CERT OF TITLE-FLOOD VEHICLE (P)",
    color: "#FF681F",
  },
  {
    id: "NJ - DEALER ONLY NON-REPAIRABLE",
    label: "NJ - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "Certificate Of Origin (Arkansas)",
    label: "Certificate Of Origin (Arkansas)",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Utah)",
    label: "Enterprise Vehicles Clear Only (Utah)",
    color: "#FF681F",
  },
  {
    id: "Clear Flood (Nebraska)",
    label: "Clear Flood (Nebraska)",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Oklahoma)",
    label: "Enterprise Vehicles Clear Only (Oklahoma)",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (Massachusetts)",
    label: "Certificate Of Origin (Massachusetts)",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (South Dakota)",
    label: "Enterprise Vehicles Clear Only (South Dakota)",
    color: "#FF681F",
  },
  {
    id: "CLEAR - DEALER ONLY - OK",
    label: "CLEAR - DEALER ONLY - OK",
    color: "#008000",
  },
  { id: "SALVAGE/FLOOD - UT", label: "SALVAGE/FLOOD - UT", color: "#FF681F" },
  {
    id: "FL - CERTIFICATE OF ORIGIN",
    label: "FL - CERTIFICATE OF ORIGIN",
    color: "#FF681F",
  },
  {
    id: "SC - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "SC - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "MO - DEALER ONLY NON-REPAIRABLE (P)",
    label: "MO - DEALER ONLY NON-REPAIRABLE (P)",
    color: "#FF0000",
  },
  { id: "Original (Georgia)", label: "Original (Georgia)", color: "#FF681F" },
  {
    id: "WI - CERTIFICATE OF ORIGIN",
    label: "WI - CERTIFICATE OF ORIGIN",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (Louisiana)",
    label: "Certificate Of Origin (Louisiana)",
    color: "#FF681F",
  },
  {
    id: "WY - CERT OF TITLE-REBUILT SALVAGE",
    label: "WY - CERT OF TITLE-REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "Manufacturer Buyback (Utah)",
    label: "Manufacturer Buyback (Utah)",
    color: "#FF681F",
  },
  { id: "Repairable (NB)", label: "Repairable (NB)", color: "#FF681F" },
  {
    id: "ME - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    label: "ME - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    color: "#FF681F",
  },
  { id: "TX - CLEAN TITLE", label: "TX - CLEAN TITLE", color: "#FF681F" },
  { id: "Repairable (QC)", label: "Repairable (QC)", color: "#FF681F" },
  {
    id: "Enterprise Vehicles Clear Only (Colorado)",
    label: "Enterprise Vehicles Clear Only (Colorado)",
    color: "#FF681F",
  },
  {
    id: "FL - CERTIFICATE OF TITLE - BONDED",
    label: "FL - CERTIFICATE OF TITLE - BONDED",
    color: "#FF681F",
  },
  {
    id: "LA - DEALER ONLY SALVAGE TITLE (P)",
    label: "LA - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "NM - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "NM - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "PA - CERT OF TITLE-W&R=FLOOD&RECNST (P)",
    label: "PA - CERT OF TITLE-W&R=FLOOD&RECNST (P)",
    color: "#FF681F",
  },
  { id: "Clear (Nebraska)", label: "Clear (Nebraska)", color: "#FF681F" },
  {
    id: "ME - NON PUBLIC CLEAN TITLE",
    label: "ME - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  { id: "Repairable (AB)", label: "Repairable (AB)", color: "#FF681F" },
  { id: "Clear (Ohio)", label: "Clear (Ohio)", color: "#FF681F" },
  { id: "Original (Colorado)", label: "Original (Colorado)", color: "#FF681F" },
  {
    id: "Non-Repairable (Arkansas)",
    label: "Non-Repairable (Arkansas)",
    color: "#FF0000",
  },
  {
    id: "IN - DLR ONLY CLEAN TITLE",
    label: "IN - DLR ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "ENTERPRISE VEHICLES CLEAR ONLY - AL",
    label: "ENTERPRISE VEHICLES CLEAR ONLY - AL",
    color: "#FF681F",
  },
  { id: "FLOOD - MS", label: "FLOOD - MS", color: "#FF681F" },
  {
    id: "AZ - CERT OF TITLE-SALVAGE FLOOD (P)",
    label: "AZ - CERT OF TITLE-SALVAGE FLOOD (P)",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF ORIGIN - LA",
    label: "CERTIFICATE OF ORIGIN - LA",
    color: "#FF681F",
  },
  {
    id: "Original (Pennsylvania)",
    label: "Original (Pennsylvania)",
    color: "#FF681F",
  },
  {
    id: "VI - CLEAN TITLE (P)",
    label: "VI - CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "CLEAR  -  LESS THAN 75% - MD",
    label: "CLEAR  -  LESS THAN 75% - MD",
    color: "#FF681F",
  },
  {
    id: "BOAT CERTIFICATE OF TITLE - WI",
    label: "BOAT CERTIFICATE OF TITLE - WI",
    color: "#FF681F",
  },
  {
    id: "CLEAR - DEALER ONLY - IN",
    label: "CLEAR - DEALER ONLY - IN",
    color: "#008000",
  },
  {
    id: "CONSTABLE SEIZED VEHICLES MA DEALERS - MA",
    label: "CONSTABLE SEIZED VEHICLES MA DEALERS - MA",
    color: "#FF681F",
  },
  {
    id: "PE - CLEAN TITLE (P)",
    label: "PE - CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "ENTERPRISE VEHICLES CLEAR ONLY - UT",
    label: "ENTERPRISE VEHICLES CLEAR ONLY - UT",
    color: "#FF681F",
  },
  {
    id: "Constable Seized Vehicles Ma Dealers (Massachusetts)",
    label: "Constable Seized Vehicles Ma Dealers (Massachusetts)",
    color: "#FF681F",
  },
  {
    id: "NY - CLEAN TITLE (P)",
    label: "NY - CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "CT - CERT OF TITLE-FLOOD SALVAGE (P)",
    label: "CT - CERT OF TITLE-FLOOD SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "TN - DEALER ONLY SALVAGE TITLE (P)",
    label: "TN - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "TX - BONDED NONREPAIRABLE FLOOD",
    label: "TX - BONDED NONREPAIRABLE FLOOD",
    color: "#FF681F",
  },
  {
    id: "WY - DEALER ONLY CLEAN TITLE (P)",
    label: "WY - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "MN - DEALER ONLY NON-REPAIRABLE (P)",
    label: "MN - DEALER ONLY NON-REPAIRABLE (P)",
    color: "#FF0000",
  },
  {
    id: "MS - CT CLEAN TITLE PUBLIC ELIG.",
    label: "MS - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "MN - CT CLEAN TITLE PUBLIC ELIG.",
    label: "MN - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  { id: "FLOOD - MN", label: "FLOOD - MN", color: "#FF681F" },
  {
    id: "DE - DEALER ONLY CLEAN TITLE (P)",
    label: "DE - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "Enterprise Vehicles Clear Only (Idaho)",
    label: "Enterprise Vehicles Clear Only (Idaho)",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF TITLE - CA",
    label: "CERTIFICATE OF TITLE - CA",
    color: "#FF681F",
  },
  {
    id: "OR - CERTIFICATE OF ORIGIN (P)",
    label: "OR - CERTIFICATE OF ORIGIN (P)",
    color: "#FF681F",
  },
  {
    id: "MA - CT CLEAN TITLE PUBLIC ELIG.",
    label: "MA - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "ENTERPRISE VEHICLES CLEAR ONLY - MA",
    label: "ENTERPRISE VEHICLES CLEAR ONLY - MA",
    color: "#FF681F",
  },
  {
    id: "LIEN PAPERS  -  CLEAR - TX",
    label: "LIEN PAPERS  -  CLEAR - TX",
    color: "#FF681F",
  },
  {
    id: "ENTERPRISE VEHICLES CLEAR ONLY - VA",
    label: "ENTERPRISE VEHICLES CLEAR ONLY - VA",
    color: "#FF681F",
  },
  {
    id: "Lien Papers - Clear (Texas)",
    label: "Lien Papers - Clear (Texas)",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (New Jersey)",
    label: "Enterprise Vehicles Clear Only (New Jersey)",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Title (California)",
    label: "Certificate Of Title (California)",
    color: "#FF681F",
  },
  {
    id: "MT - CLEAN TITLE - RECOVERED THEFT",
    label: "MT - CLEAN TITLE - RECOVERED THEFT",
    color: "#FF681F",
  },
  {
    id: "WV - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "WV - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "WV - DEALER ONLY NON-REPAIRABLE",
    label: "WV - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "TX - CLEAN TITLE (P)",
    label: "TX - CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "NJ - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "NJ - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "ND - CT CLEAN TITLE PUBLIC ELIG.",
    label: "ND - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "KY - NON PUBLIC CLEAN TITLE",
    label: "KY - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "OH - CERT OF TITLE-SALVAGE FLOOD (P)",
    label: "OH - CERT OF TITLE-SALVAGE FLOOD (P)",
    color: "#FF681F",
  },
  {
    id: "MI - CERT OF TITLE-POLICE (P)",
    label: "MI - CERT OF TITLE-POLICE (P)",
    color: "#FF681F",
  },
  {
    id: "MS - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "MS - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  { id: "non_repairable", label: "non_repairable", color: "#FF681F" },
  {
    id: "TX - CERT OF TITLE - FLOOD (P)",
    label: "TX - CERT OF TITLE - FLOOD (P)",
    color: "#FF681F",
  },


  { id: "OH - CERT OF TTL-REBLT SLVG, FLOOD", label: "OH - CERT OF TTL-REBLT SLVG, FLOOD",  color: "#FF681F" },
  { id: "OH - CERT OF TTL-REBLT SLVG, FLOOD (P)", label: "OH - CERT OF TTL-REBLT SLVG, FLOOD (P)", color: "#FF681F" },
  { id: "WI - CERT OF TITLE-FLOOD DAMAGED,CL", label: "WI - CERT OF TITLE-FLOOD DAMAGED,CL", color: "#FF681F" },
  { id: "NV - LIEN PAPERS, CLEAN TITLE", label: "NV - LIEN PAPERS, CLEAN TITLE", color: "#FF681F" },
  { id: "DC - CERT OF TITLE-CLEAR,SLVG HISTO", label: "DC - CERT OF TITLE-CLEAR,SLVG HISTO", color: "#FF681F" },
  { id: "NC - DLR ONLY, CLEAN W/ SALV HIST", label: "NC - DLR ONLY, CLEAN W/ SALV HIST", color: "#FF681F"  },
  { id: "CO - SALVAGE, FLOOD", label: "CO - SALVAGE, FLOOD", color: "#FF681F"  },
  { id: "Sk-Parts Only, Vehicle Is Non Repairable (Saskatchewan)", label: "Sk-Parts Only, Vehicle Is Non Repairable (Saskatchewan)", color: "#FF0000"  },
  { id: "Sk-Mechanical Inspection Required, Not Branded (Saskatchewan)", label: "Sk-Mechanical Inspection Required, Not Branded (Saskatchewan)", color: "#0000FF"  },



  {
    id: "OR - CT CLEAN TITLE PUBLIC ELIG.",
    label: "OR - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "Canadian Non-Repairable Certificate (South Carolina)",
    label: "Canadian Non-Repairable Certificate (South Carolina)",
    color: "#FF0000",
  },
  {
    id: "GA - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    label: "GA - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "MA - CT CLEAN TITLE PUBLIC ELIG. (P)",
    label: "MA - CT CLEAN TITLE PUBLIC ELIG. (P)",
    color: "#FF681F",
  },
  {
    id: "IL - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "IL - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "HI - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    label: "HI - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "NE - DEALER ONLY NON-REPAIRABLE",
    label: "NE - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "IL - NON PUBLIC CLEAN TITLE",
    label: "IL - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "WV - DEALER ONLY CLEAN TITLE (P)",
    label: "WV - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  { id: "Clean", label: "Clean", color: "#FF681F" },
  {
    id: "Enterprise Vehicles Clear Only (California)",
    label: "Enterprise Vehicles Clear Only (California)",
    color: "#FF681F",
  },
  {
    id: "CT - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "CT - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "WI - CERT OF TITLE-REBUILT SAL/FLOD",
    label: "WI - CERT OF TITLE-REBUILT SAL/FLOD",
    color: "#FF681F",
  },
  {
    id: "ID - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "ID - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "MT - CERT OF TITLE-REBUILT SALVAGE (P)",
    label: "MT - CERT OF TITLE-REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "DC - CERT OF DOCUMENTATION-VESSEL",
    label: "DC - CERT OF DOCUMENTATION-VESSEL",
    color: "#FF681F",
  },
  {
    id: "GA - REBUILT WITH THEFT HISTORY",
    label: "GA - REBUILT WITH THEFT HISTORY",
    color: "#FF681F",
  },
  {
    id: "PA - NONREPAIRABLE VEHICLE CERT (P)",
    label: "PA - NONREPAIRABLE VEHICLE CERT (P)",
    color: "#FF681F",
  },
  {
    id: "LA - CT CLEAN TITLE PUBLIC ELIG. (P)",
    label: "LA - CT CLEAN TITLE PUBLIC ELIG. (P)",
    color: "#FF681F",
  },
  { id: "CT - CLEAN TITLE", label: "CT - CLEAN TITLE", color: "#FF681F" },
  {
    id: "IL - DEALER ONLY SALVAGE TITLE (P)",
    label: "IL - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "Clear - Dealer Only (Kansas)",
    label: "Clear - Dealer Only (Kansas)",
    color: "#008000",
  },
  {
    id: "WI - CERT OF TITLE-SALVAGE & FLOOD",
    label: "WI - CERT OF TITLE-SALVAGE & FLOOD",
    color: "#FF681F",
  },
  {
    id: "VA - CERT OF TITLE-RECONSTRUCTED (P)",
    label: "VA - CERT OF TITLE-RECONSTRUCTED (P)",
    color: "#FF681F",
  },
  {
    id: "DC - DEALER ONLY CLEAN TITLE",
    label: "DC - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "WY - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "WY - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "TX - BONDED TITLE - SALVAGE (P)",
    label: "TX - BONDED TITLE - SALVAGE (P)",
    color: "#FF681F",
  },
  { id: "Clear", label: "Clear", color: "#FF681F" },
  {
    id: "FL - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "FL - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "Original (Washington)",
    label: "Original (Washington)",
    color: "#FF681F",
  },
  {
    id: "FL - CLEAN TITLE/TITLE ATTACHED",
    label: "FL - CLEAN TITLE/TITLE ATTACHED",
    color: "#FF681F",
  },
  {
    id: "TN - DEALER ONLY NON-REPAIRABLE",
    label: "TN - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "NJ - CERTIFICATE OF ORIGIN",
    label: "NJ - CERTIFICATE OF ORIGIN",
    color: "#FF681F",
  },
  {
    id: "NM - NON-REPAIRABLE VEHICLE CERT (P)",
    label: "NM - NON-REPAIRABLE VEHICLE CERT (P)",
    color: "#FF0000",
  },
  {
    id: "SC - CERT OF TITLE-REBUILT WATER SA (P)",
    label: "SC - CERT OF TITLE-REBUILT WATER SA (P)",
    color: "#FF681F",
  },
  {
    id: "WA - CLEAN TITLE EXPORT ONLY",
    label: "WA - CLEAN TITLE EXPORT ONLY",
    color: "#FF681F",
  },
  {
    id: "IL - DEALER ONLY NON-REPAIRABLE",
    label: "IL - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "WI - DEALER ONLY CLEAN TITLE (P)",
    label: "WI - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "NJ - CERT OF TTL W/FLD SLVG HISTORY (P)",
    label: "NJ - CERT OF TTL W/FLD SLVG HISTORY (P)",
    color: "#FF681F",
  },
  { id: "GU - CLEAN TITLE", label: "GU - CLEAN TITLE", color: "#FF681F" },
  {
    id: "AZ - DEALER ONLY REBUILT SALVAGE (P)",
    label: "AZ - DEALER ONLY REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "WY - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "WY - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "GA - CT CLEAN TITLE PUBLIC ELIG.",
    label: "GA - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF ORIGIN - OR",
    label: "CERTIFICATE OF ORIGIN - OR",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF ORIGIN - PA",
    label: "CERTIFICATE OF ORIGIN - PA",
    color: "#FF681F",
  },
  {
    id: "CA - CT CLEAN TITLE PUBLIC ELIG. (P)",
    label: "CA - CT CLEAN TITLE PUBLIC ELIG. (P)",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Virginia)",
    label: "Enterprise Vehicles Clear Only (Virginia)",
    color: "#FF681F",
  },
  { id: "Flood (Minnesota)", label: "Flood (Minnesota)", color: "#FF681F" },
  {
    id: "AL - CERT OF TITLE-FLOOD REBUILT (P)",
    label: "AL - CERT OF TITLE-FLOOD REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "VA - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "VA - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "AK - DEALER ONLY SALVAGE TITLE (P)",
    label: "AK - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "MS - CERT OF TITLE-FLOOD DAMAGED (P)",
    label: "MS - CERT OF TITLE-FLOOD DAMAGED (P)",
    color: "#FF681F",
  },
  {
    id: "WV - NON-REPAIRABLE CERTIFICATE (P)",
    label: "WV - NON-REPAIRABLE CERTIFICATE (P)",
    color: "#FF0000",
  },
  {
    id: "CT - CERT OF TITLE-REBUILT (P)",
    label: "CT - CERT OF TITLE-REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (Arizona)",
    label: "Certificate Of Origin (Arizona)",
    color: "#FF681F",
  },
  {
    id: "AK - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "AK - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "NE - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "NE - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "NV - BONDED REBUILT CERTIFICATE",
    label: "NV - BONDED REBUILT CERTIFICATE",
    color: "#FF681F",
  },
  {
    id: "AZ - DEALER ONLY NON-REPAIRABLE (P)",
    label: "AZ - DEALER ONLY NON-REPAIRABLE (P)",
    color: "#FF0000",
  },
  {
    id: "IN - CLEAN TITLE - MANUFCTR BUYBACK",
    label: "IN - CLEAN TITLE - MANUFCTR BUYBACK",
    color: "#FF681F",
  },
  {
    id: "MN - CERT OF TITLE-PR SALV FLOOD (P)",
    label: "MN - CERT OF TITLE-PR SALV FLOOD (P)",
    color: "#FF681F",
  },
  {
    id: "OH - DEALER ONLY SALVAGE TITLE (P)",
    label: "OH - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "ORIGINAL - ENDORSEMENT - TX",
    label: "ORIGINAL - ENDORSEMENT - TX",
    color: "#FF681F",
  },
  {
    id: "CLEAR - DEALER ONLY - WI",
    label: "CLEAR - DEALER ONLY - WI",
    color: "#008000",
  },
  {
    id: "UT - FLOOD/SALVAGE CERT. OF TITLE (P)",
    label: "UT - FLOOD/SALVAGE CERT. OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "IN - DLR ONLY CLEAN TITLE (P)",
    label: "IN - DLR ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  { id: "REGULAR - NM", label: "REGULAR - NM", color: "#FF681F" },
  {
    id: "NY - FLOOD W/UNSATISFIED LIEN",
    label: "NY - FLOOD W/UNSATISFIED LIEN",
    color: "#FF681F",
  },
  {
    id: "Original-Endorsement (Ohio)",
    label: "Original-Endorsement (Ohio)",
    color: "#FF681F",
  },
  {
    id: "ORIGINAL - ENDORSEMENT - OH",
    label: "ORIGINAL - ENDORSEMENT - OH",
    color: "#FF681F",
  },
  {
    id: "GA - CERT OF TITLE - REBUILT FIRE",
    label: "GA - CERT OF TITLE - REBUILT FIRE",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Pennsylvania)",
    label: "Enterprise Vehicles Clear Only (Pennsylvania)",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF ORIGIN - MN",
    label: "CERTIFICATE OF ORIGIN - MN",
    color: "#FF681F",
  },
  {
    id: "CO - REBUILT SALVAGE - DEALER ONLY (P)",
    label: "CO - REBUILT SALVAGE - DEALER ONLY (P)",
    color: "#FF681F",
  },
  {
    id: "PRIOR SALVAGE  -  REBUILT - MN",
    label: "PRIOR SALVAGE  -  REBUILT - MN",
    color: "#FF681F",
  },
  {
    id: "OK - REBUILT TTL W/FLOOD BRANDING (P)",
    label: "OK - REBUILT TTL W/FLOOD BRANDING (P)",
    color: "#FF681F",
  },
  { id: "CLEAR - PR", label: "CLEAR - PR", color: "#FF681F" },
  { id: "REBUILT - OK", label: "REBUILT - OK", color: "#FF681F" },
  {
    id: "APP FOR DUP SALV TITLE  -  DEALER - CA",
    label: "APP FOR DUP SALV TITLE  -  DEALER - CA",
    color: "#FF681F",
  },
  { id: "CLEAR - NH", label: "CLEAR - NH", color: "#FF681F" },
  { id: "ORIGINAL - ME", label: "ORIGINAL - ME", color: "#FF681F" },
  {
    id: "Regular Tbo (South Dakota)",
    label: "Regular Tbo (South Dakota)",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF TITLE - MT",
    label: "CERTIFICATE OF TITLE - MT",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF ORIGIN - NM",
    label: "CERTIFICATE OF ORIGIN - NM",
    color: "#FF681F",
  },
  {
    id: "NON - REPAIRABLE CERTIFICATE - WV",
    label: "NON - REPAIRABLE CERTIFICATE - WV",
    color: "#FF681F",
  },
  {
    id: "REGULAR CERTIFICATE - IA",
    label: "REGULAR CERTIFICATE - IA",
    color: "#FF681F",
  },
  { id: "CLEAR - OK", label: "CLEAR - OK", color: "#FF681F" },
  {
    id: "NON - REPAIRABLE - VA",
    label: "NON - REPAIRABLE - VA",
    color: "#FF681F",
  },
  {
    id: "CLEAR - DEALER ONLY - MT",
    label: "CLEAR - DEALER ONLY - MT",
    color: "#008000",
  },
  {
    id: "CLEAR - DEALER ONLY - OR",
    label: "CLEAR - DEALER ONLY - OR",
    color: "#008000",
  },
  {
    id: "NON - REPAIRABLE - AZ",
    label: "NON - REPAIRABLE - AZ",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF ORIGIN - TN",
    label: "CERTIFICATE OF ORIGIN - TN",
    color: "#FF681F",
  },
  {
    id: "CLEAR - DEALER ONLY - WA",
    label: "CLEAR - DEALER ONLY - WA",
    color: "#008000",
  },
  { id: "CLEAR - KS", label: "CLEAR - KS", color: "#FF681F" },
  { id: "CLEAR - HI", label: "CLEAR - HI", color: "#FF681F" },
  { id: "CLEAR - WI", label: "CLEAR - WI", color: "#FF681F" },
  { id: "CLEAR - MO", label: "CLEAR - MO", color: "#FF681F" },
  { id: "ORIGINAL - WV", label: "ORIGINAL - WV", color: "#FF681F" },
  { id: "ORIGINAL - VT", label: "ORIGINAL - VT", color: "#FF681F" },
  {
    id: "NON - REPAIRABLE - NV",
    label: "NON - REPAIRABLE - NV",
    color: "#FF681F",
  },
  {
    id: "NON - REPAIRABLE - TX",
    label: "NON - REPAIRABLE - TX",
    color: "#FF681F",
  },
  { id: "RECONSTRUCTED - MA", label: "RECONSTRUCTED - MA", color: "#FF681F" },
  { id: "CLEAR - DC", label: "CLEAR - DC", color: "#FF681F" },
  {
    id: "NY - CERTIFICATE OF ORIGIN",
    label: "NY - CERTIFICATE OF ORIGIN",
    color: "#FF681F",
  },
  {
    id: "IL - SALVAGE CERT-FLOOD (P)",
    label: "IL - SALVAGE CERT-FLOOD (P)",
    color: "#FF681F",
  },
  {
    id: "TN - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    label: "TN - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "FL - NON PUBLIC CLEAN TITLE",
    label: "FL - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "KS - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "KS - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "AL - CERT OF TITLE-REBUILT (P)",
    label: "AL - CERT OF TITLE-REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "FL - DEALER ONLY NON-REPAIRABLE (P)",
    label: "FL - DEALER ONLY NON-REPAIRABLE (P)",
    color: "#FF0000",
  },
  {
    id: "Regular Reassignment (Iowa)",
    label: "Regular Reassignment (Iowa)",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (South Carolina)",
    label: "Certificate Of Origin (South Carolina)",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (Pennsylvania)",
    label: "Certificate Of Origin (Pennsylvania)",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (New York)",
    label: "Enterprise Vehicles Clear Only (New York)",
    color: "#FF681F",
  },
  {
    id: "NJ - CERT OF TITLE - FLOOD",
    label: "NJ - CERT OF TITLE - FLOOD",
    color: "#FF681F",
  },
  {
    id: "WI - DEALER ONLY NON-REPAIRABLE (P)",
    label: "WI - DEALER ONLY NON-REPAIRABLE (P)",
    color: "#FF0000",
  },
  {
    id: "WI - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "WI - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "GA - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "GA - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "MS - NON PUBLIC CLEAN TITLE",
    label: "MS - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "NM - NONPUBLIC CLEAN TITLE",
    label: "NM - NONPUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "WY - DEALER ONLY CLEAN TITLE",
    label: "WY - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "UT - RECONSTRUCTED TITLE",
    label: "UT - RECONSTRUCTED TITLE",
    color: "#FF681F",
  },
  {
    id: "AZ - REPO AFFIDAVIT-CLEAN (P)",
    label: "AZ - REPO AFFIDAVIT-CLEAN (P)",
    color: "#FF681F",
  },
  {
    id: "GA - CERT OF TITLE-FLOOD",
    label: "GA - CERT OF TITLE-FLOOD",
    color: "#FF681F",
  },
  {
    id: "VA - NON-REPAIRABLE CERTIFICATE (P)",
    label: "VA - NON-REPAIRABLE CERTIFICATE (P)",
    color: "#FF0000",
  },
  {
    id: "PA - CERT OF SALVAGE-W=FLOOD VEH (P)",
    label: "PA - CERT OF SALVAGE-W=FLOOD VEH (P)",
    color: "#FF681F",
  },
  {
    id: "VT - CERT OF TITLE-REBUILT VEHICLE (P)",
    label: "VT - CERT OF TITLE-REBUILT VEHICLE (P)",
    color: "#FF681F",
  },
  {
    id: "MO - CLEAN TITLE W/SALVAGE HISTORY (P)",
    label: "MO - CLEAN TITLE W/SALVAGE HISTORY (P)",
    color: "#FF681F",
  },
  {
    id: "AR - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "AR - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  { id: "CLEAR - ID", label: "CLEAR - ID", color: "#FF681F" },
  { id: "CLEAR - NC", label: "CLEAR - NC", color: "#FF681F" },
  { id: "CLEAR - MN", label: "CLEAR - MN", color: "#FF681F" },
  { id: "CLEAR - WA", label: "CLEAR - WA", color: "#FF681F" },
  { id: "CLEAR - GA", label: "CLEAR - GA", color: "#FF681F" },
  { id: "CLEAR - UT", label: "CLEAR - UT", color: "#FF681F" },
  { id: "CLEAR - NM", label: "CLEAR - NM", color: "#FF681F" },
  { id: "CLEAR - AR", label: "CLEAR - AR", color: "#FF681F" },
  { id: "CLEAR - IN", label: "CLEAR - IN", color: "#FF681F" },
  { id: "CLEAR - NJ", label: "CLEAR - NJ", color: "#FF681F" },
  { id: "CLEAR - FL", label: "CLEAR - FL", color: "#FF681F" },
  { id: "CLEAR - MD", label: "CLEAR - MD", color: "#FF681F" },
  { id: "CLEAR - MS", label: "CLEAR - MS", color: "#FF681F" },
  { id: "CLEAR - NY", label: "CLEAR - NY", color: "#FF681F" },
  { id: "CLEAR - WY", label: "CLEAR - WY", color: "#FF681F" },
  { id: "CLEAR - MA", label: "CLEAR - MA", color: "#FF681F" },
  { id: "CLEAR - VA", label: "CLEAR - VA", color: "#FF681F" },
  { id: "CLEAR - SC", label: "CLEAR - SC", color: "#FF681F" },
  { id: "REGULAR - NV", label: "REGULAR - NV", color: "#FF681F" },
  { id: "CLEAR - MI", label: "CLEAR - MI", color: "#FF681F" },
  {
    id: "CLEAR - DEALER ONLY - CA",
    label: "CLEAR - DEALER ONLY - CA",
    color: "#008000",
  },
  { id: "CLEAR - IL", label: "CLEAR - IL", color: "#FF681F" },
  {
    id: "CERTIFICATE OF TITLE - NE",
    label: "CERTIFICATE OF TITLE - NE",
    color: "#FF681F",
  },
  { id: "ORIGINAL - TX", label: "ORIGINAL - TX", color: "#FF681F" },
  { id: "CLEAR - CO", label: "CLEAR - CO", color: "#FF681F" },
  {
    id: "KY - CLEAN RED REBUILT BRANDED",
    label: "KY - CLEAN RED REBUILT BRANDED",
    color: "#FF681F",
  },
  {
    id: "TX - DEALER ONLY SALVAGE TITLE (P)",
    label: "TX - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  { id: "CLEAR - MT", label: "CLEAR - MT", color: "#FF681F" },
  {
    id: "CLEAR - DEALER ONLY - AZ",
    label: "CLEAR - DEALER ONLY - AZ",
    color: "#008000",
  },
  {
    id: "CLEAR - PUBLIC RESTRICTED - OK",
    label: "CLEAR - PUBLIC RESTRICTED - OK",
    color: "#FF681F",
  },
  {
    id: "CLEAR - DEALER ONLY - MD",
    label: "CLEAR - DEALER ONLY - MD",
    color: "#008000",
  },
  {
    id: "NON - REPAIRABLE - TN",
    label: "NON - REPAIRABLE - TN",
    color: "#FF681F",
  },
  { id: "ORIGINAL - RI", label: "ORIGINAL - RI", color: "#FF681F" },
  { id: "ORIGINAL - NH", label: "ORIGINAL - NH", color: "#FF681F" },
  { id: "REBUILT - IN", label: "REBUILT - IN", color: "#FF681F" },
  { id: "REGULAR - SD", label: "REGULAR - SD", color: "#FF681F" },
  { id: "CLEAR - AL", label: "CLEAR - AL", color: "#FF681F" },
  { id: "CLEAR - LA", label: "CLEAR - LA", color: "#FF681F" },
  {
    id: "NON - REPAIRABLE - CA",
    label: "NON - REPAIRABLE - CA",
    color: "#FF681F",
  },
  { id: "CLEAR - ND", label: "CLEAR - ND", color: "#FF681F" },
  { id: "CLEAR - AZ", label: "CLEAR - AZ", color: "#FF681F" },
  {
    id: "CLEAR - ENDORSEMENT - WI",
    label: "CLEAR - ENDORSEMENT - WI",
    color: "#FF681F",
  },
  {
    id: "NON - REPAIRABLE - CO",
    label: "NON - REPAIRABLE - CO",
    color: "#FF681F",
  },
  { id: "ORIGINAL - AK", label: "ORIGINAL - AK", color: "#FF681F" },
  {
    id: "REBUILT/RESTORED - UT",
    label: "REBUILT/RESTORED - UT",
    color: "#FF681F",
  },
  { id: "CLEAR - PA", label: "CLEAR - PA", color: "#FF681F" },
  {
    id: "APP FOR DUP CLEAR - CA",
    label: "APP FOR DUP CLEAR - CA",
    color: "#FF681F",
  },
  { id: "CLEAR - CT", label: "CLEAR - CT", color: "#FF681F" },
  {
    id: "CLEAR - DEALER ONLY - MN",
    label: "CLEAR - DEALER ONLY - MN",
    color: "#008000",
  },
  { id: "CLEAR - TX", label: "CLEAR - TX", color: "#FF681F" },
  {
    id: "CLEAR - PUBLIC RESTRICTED - OR",
    label: "CLEAR - PUBLIC RESTRICTED - OR",
    color: "#FF681F",
  },
  { id: "CLEAR - OR", label: "CLEAR - OR", color: "#FF681F" },
  { id: "CLEAR - CA", label: "CLEAR - CA", color: "#FF681F" },
  {
    id: "CLEAR - DEALER ONLY - WV",
    label: "CLEAR - DEALER ONLY - WV",
    color: "#008000",
  },
  { id: "CLEAR - TN", label: "CLEAR - TN", color: "#FF681F" },
  { id: "ORIGINAL - OH", label: "ORIGINAL - OH", color: "#FF681F" },
  {
    id: "MI - DEALER ONLY NON-REPAIRABLE (P)",
    label: "MI - DEALER ONLY NON-REPAIRABLE (P)",
    color: "#FF0000",
  },
  {
    id: "TX - BONDED NONREPAIRABLE",
    label: "TX - BONDED NONREPAIRABLE",
    color: "#FF681F",
  },
  {
    id: "ME - CERT OF TITLE-REBUILT VEHICLE (P)",
    label: "ME - CERT OF TITLE-REBUILT VEHICLE (P)",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (California)",
    label: "Certificate Of Origin (California)",
    color: "#FF681F",
  },
  {
    id: "MI - DLR ONLY CLEAN TITLE",
    label: "MI - DLR ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "OK - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    label: "OK - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "AB - BOS - REBUILT (P)",
    label: "AB - BOS - REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "KS - CT CLEAN TITLE PUBLIC ELIG.",
    label: "KS - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "CLEAR - DEALER ONLY - OH",
    label: "CLEAR - DEALER ONLY - OH",
    color: "#008000",
  },
  {
    id: "CLEAR - DEALER ONLY - ND",
    label: "CLEAR - DEALER ONLY - ND",
    color: "#008000",
  },
  {
    id: "NON - REPAIRABLE - DC",
    label: "NON - REPAIRABLE - DC",
    color: "#FF681F",
  },
  {
    id: "CLEAR - DEALER ONLY - KY",
    label: "CLEAR - DEALER ONLY - KY",
    color: "#008000",
  },
  {
    id: "MANUFACTURER BUYBACK - UT",
    label: "MANUFACTURER BUYBACK - UT",
    color: "#FF681F",
  },
  {
    id: "IL - CT CLEAN TITLE PUBLIC ELIG.",
    label: "IL - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "NV - BONDED CERTIFICATE OF TITLE",
    label: "NV - BONDED CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "CO - NON-REPAIRABLE CERT OF TITLE (P)",
    label: "CO - NON-REPAIRABLE CERT OF TITLE (P)",
    color: "#FF0000",
  },
  {
    id: "SD - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "SD - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "MO - MARINE CERTIFICATE OF TITLE (P)",
    label: "MO - MARINE CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "AL - NON PUBLIC CLEAN TITLE",
    label: "AL - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "MT - CERT OF TITLE - RECONSTRUCTED",
    label: "MT - CERT OF TITLE - RECONSTRUCTED",
    color: "#FF681F",
  },
  {
    id: "ORIGINAL  -  RECONSTRUCTED - AK",
    label: "ORIGINAL  -  RECONSTRUCTED - AK",
    color: "#FF681F",
  },
  {
    id: "TX - SALVAGE-FLOOD MANUFACTURER BUY",
    label: "TX - SALVAGE-FLOOD MANUFACTURER BUY",
    color: "#FF681F",
  },
  {
    id: "NON - REPAIRABLE CERTIFICATE - CA",
    label: "NON - REPAIRABLE CERTIFICATE - CA",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Illinois)",
    label: "Enterprise Vehicles Clear Only (Illinois)",
    color: "#FF681F",
  },
  {
    id: "CO - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "CO - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "Bc-Rebuilt (British Columbia)",
    label: "Bc-Rebuilt (British Columbia)",
    color: "#FF681F",
  },
  {
    id: "MA - NON PUBLIC CLEAN TITLE",
    label: "MA - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "NON - REPAIRABLE EXPORT ONLY - TX",
    label: "NON - REPAIRABLE EXPORT ONLY - TX",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF ORIGIN - CA",
    label: "CERTIFICATE OF ORIGIN - CA",
    color: "#FF681F",
  },
  {
    id: "CANADIAN NON - REPAIRABLE - AL",
    label: "CANADIAN NON - REPAIRABLE - AL",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF ORIGIN - NY",
    label: "CERTIFICATE OF ORIGIN - NY",
    color: "#FF681F",
  },
  {
    id: "TX - DEALER ONLY NON-REPAIRABLE",
    label: "TX - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "CERTIFICATE OF ORIGIN - MA",
    label: "CERTIFICATE OF ORIGIN - MA",
    color: "#FF681F",
  },
  {
    id: "ENTERPRISE VEHICLES CLEAR ONLY - TN",
    label: "ENTERPRISE VEHICLES CLEAR ONLY - TN",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF ORIGIN - MS",
    label: "CERTIFICATE OF ORIGIN - MS",
    color: "#FF681F",
  },
  {
    id: "TN - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "TN - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "ENTERPRISE VEHICLES CLEAR ONLY - DE",
    label: "ENTERPRISE VEHICLES CLEAR ONLY - DE",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF ORIGIN - FL",
    label: "CERTIFICATE OF ORIGIN - FL",
    color: "#FF681F",
  },
  {
    id: "LA - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "LA - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF ORIGIN - IN",
    label: "CERTIFICATE OF ORIGIN - IN",
    color: "#FF681F",
  },
  {
    id: "WI - BOAT CERTIFICATE OF TITLE (P)",
    label: "WI - BOAT CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "CLEAR - DEALER ONLY - MI",
    label: "CLEAR - DEALER ONLY - MI",
    color: "#008000",
  },
  {
    id: "FED GOV - CLEAR - NC",
    label: "FED GOV - CLEAR - NC",
    color: "#FF681F",
  },
  { id: "WATERCRAFT - MI", label: "WATERCRAFT - MI", color: "#FF681F" },
  {
    id: "ENTERPRISE VEHICLES CLEAR ONLY - FL",
    label: "ENTERPRISE VEHICLES CLEAR ONLY - FL",
    color: "#FF681F",
  },
  {
    id: "NON - REPAIRABLE - NM",
    label: "NON - REPAIRABLE - NM",
    color: "#FF681F",
  },
  {
    id: "CA - CERTIFICATE OF ORIGIN (P)",
    label: "CA - CERTIFICATE OF ORIGIN (P)",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Florida)",
    label: "Enterprise Vehicles Clear Only (Florida)",
    color: "#FF681F",
  },
  {
    id: "NM - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "NM - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "SC - CERT OF TITLE-SALVAGE REBUILT (P)",
    label: "SC - CERT OF TITLE-SALVAGE REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "VT - DEALER ONLY CLEAN TITLE (P)",
    label: "VT - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "CLEAR - DEALER ONLY - AK",
    label: "CLEAR - DEALER ONLY - AK",
    color: "#008000",
  },
  {
    id: "CLEAR - DEALER ONLY - NE",
    label: "CLEAR - DEALER ONLY - NE",
    color: "#008000",
  },
  {
    id: "IA - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "IA - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "MS - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "MS - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "AL - DEALER ONLY SALVAGE TITLE (P)",
    label: "AL - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "NE - DEALER ONLY SALVAGE TITLE (P)",
    label: "NE - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "MN - CERT OF TITLE TO A WATERCRAFT (P)",
    label: "MN - CERT OF TITLE TO A WATERCRAFT (P)",
    color: "#FF681F",
  },
  {
    id: "MA - CERT OF TITLE-FLOOD SALVAGE (P)",
    label: "MA - CERT OF TITLE-FLOOD SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "UT - CERT OF SALE - REBUILT/RESTORE",
    label: "UT - CERT OF SALE - REBUILT/RESTORE",
    color: "#FF681F",
  },
  {
    id: "AZ - CERT OF TITLE-SALVAGE FLOOD",
    label: "AZ - CERT OF TITLE-SALVAGE FLOOD",
    color: "#FF681F",
  },
  { id: "VI - CLEAN TITLE", label: "VI - CLEAN TITLE", color: "#FF681F" },
  {
    id: "Clear-Dealer Only (Nebraska)",
    label: "Clear-Dealer Only (Nebraska)",
    color: "#008000",
  },
  { id: "WATERCRAFT - MO", label: "WATERCRAFT - MO", color: "#FF681F" },
  {
    id: "CERTIFICATE OF ORIGIN - NJ",
    label: "CERTIFICATE OF ORIGIN - NJ",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF ORIGIN - SC",
    label: "CERTIFICATE OF ORIGIN - SC",
    color: "#FF681F",
  },
  {
    id: "CLEAR - DEALER ONLY - TX",
    label: "CLEAR - DEALER ONLY - TX",
    color: "#008000",
  },
  {
    id: "CLEAR - DEALER ONLY - ID",
    label: "CLEAR - DEALER ONLY - ID",
    color: "#008000",
  },
  {
    id: "TX - CT CLEAN TITLE PUBLIC ELIG. (P)",
    label: "TX - CT CLEAN TITLE PUBLIC ELIG. (P)",
    color: "#FF681F",
  },
  {
    id: "NV - NON-REPAIRABLE VEHICLE CERT (P)",
    label: "NV - NON-REPAIRABLE VEHICLE CERT (P)",
    color: "#FF0000",
  },
  {
    id: "GA - CERT OF TITLE-REBUILT FLOOD (P)",
    label: "GA - CERT OF TITLE-REBUILT FLOOD (P)",
    color: "#FF681F",
  },
  {
    id: "IL - CERTIFICATE OF ORIGIN (P)",
    label: "IL - CERTIFICATE OF ORIGIN (P)",
    color: "#FF681F",
  },
  {
    id: "NON - REPAIRABLE - MD",
    label: "NON - REPAIRABLE - MD",
    color: "#FF681F",
  },
  {
    id: "CLEAR  -  DEALER ONLY - HI",
    label: "CLEAR  -  DEALER ONLY - HI",
    color: "#008000",
  },
  { id: "RECONSTRUCTED - LA", label: "RECONSTRUCTED - LA", color: "#FF681F" },
  { id: "ORIGINAL - KY", label: "ORIGINAL - KY", color: "#FF681F" },
  { id: "REBUILT - WA", label: "REBUILT - WA", color: "#FF681F" },
  {
    id: "REBUILT  -   PUBLIC RESTRICTED - OK",
    label: "REBUILT  -   PUBLIC RESTRICTED - OK",
    color: "#FF681F",
  },
  { id: "VESSEL - FL", label: "VESSEL - FL", color: "#FF681F" },
  {
    id: "Enterprise Vehicles Clear Only (Washington)",
    label: "Enterprise Vehicles Clear Only (Washington)",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Origin (Indiana)",
    label: "Certificate Of Origin (Indiana)",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Connecticut)",
    label: "Enterprise Vehicles Clear Only (Connecticut)",
    color: "#FF681F",
  },
  {
    id: "KY - HAIL CLEAN BRAND",
    label: "KY - HAIL CLEAN BRAND",
    color: "#FF681F",
  },
  { id: "ORIGINAL TITLE - MS", label: "ORIGINAL TITLE - MS", color: "#FF681F" },
  { id: "CLEAR - RI", label: "CLEAR - RI", color: "#FF681F" },
  { id: "DEALER - IA", label: "DEALER - IA", color: "#FF681F" },
  {
    id: "CLEAR - DEALER ONLY - UT",
    label: "CLEAR - DEALER ONLY - UT",
    color: "#008000",
  },
  {
    id: "MN - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "MN - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "IA - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "IA - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "TX - AUCTION SALES RECEIPT - CLEAN",
    label: "TX - AUCTION SALES RECEIPT - CLEAN",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF ORIGIN - WV",
    label: "CERTIFICATE OF ORIGIN - WV",
    color: "#FF681F",
  },
  {
    id: "ENTERPRISE VEHICLES CLEAR ONLY - CT",
    label: "ENTERPRISE VEHICLES CLEAR ONLY - CT",
    color: "#FF681F",
  },
  { id: "ORIGINAL - OK", label: "ORIGINAL - OK", color: "#FF681F" },
  {
    id: "CLEAR  -  TO BE OBTAINED - WI",
    label: "CLEAR  -  TO BE OBTAINED - WI",
    color: "#FF681F",
  },
  {
    id: "VESSEL CERTIFICATE - VA",
    label: "VESSEL CERTIFICATE - VA",
    color: "#FF681F",
  },
  {
    id: "NON - REPAIRABLE - UT",
    label: "NON - REPAIRABLE - UT",
    color: "#FF681F",
  },
  {
    id: "Clear-Dealer Only (North Dakota)",
    label: "Clear-Dealer Only (North Dakota)",
    color: "#008000",
  },
  {
    id: "CT - DEALER ONLY CLEAN TITLE",
    label: "CT - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  { id: "CLEAR - NV", label: "CLEAR - NV", color: "#FF681F" },
  {
    id: "CLEAR - DEALER ONLY - GA",
    label: "CLEAR - DEALER ONLY - GA",
    color: "#008000",
  },
  {
    id: "CERTIFICATE OF ORIGIN - TX",
    label: "CERTIFICATE OF ORIGIN - TX",
    color: "#FF681F",
  },
  {
    id: "CLEAR - DEALER ONLY - NC",
    label: "CLEAR - DEALER ONLY - NC",
    color: "#008000",
  },
  {
    id: "NON - REPAIRABLE - KS",
    label: "NON - REPAIRABLE - KS",
    color: "#FF681F",
  },
  { id: "CLEAR  -  TBO - IN", label: "CLEAR  -  TBO - IN", color: "#FF681F" },
  {
    id: "REBUILT - NON - PUBLIC - WA",
    label: "REBUILT - NON - PUBLIC - WA",
    color: "#FF681F",
  },
  { id: "REBUILT - MS", label: "REBUILT - MS", color: "#FF681F" },
  {
    id: "CERTIFICATE OF ORIGIN - OH",
    label: "CERTIFICATE OF ORIGIN - OH",
    color: "#FF681F",
  },
  {
    id: "TX - AUCTION SALES RECEIPT - CLEAN (P)",
    label: "TX - AUCTION SALES RECEIPT - CLEAN (P)",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Kentucky)",
    label: "Enterprise Vehicles Clear Only (Kentucky)",
    color: "#FF681F",
  },
  {
    id: "ENTERPRISE VEHICLES CLEAR ONLY - NY",
    label: "ENTERPRISE VEHICLES CLEAR ONLY - NY",
    color: "#FF681F",
  },
  {
    id: "NON - REPAIRABLE - PA",
    label: "NON - REPAIRABLE - PA",
    color: "#FF681F",
  },
  {
    id: "CLEAR - DEALER ONLY - IA",
    label: "CLEAR - DEALER ONLY - IA",
    color: "#008000",
  },
  {
    id: "NM - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "NM - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  { id: "CLEAR - DE", label: "CLEAR - DE", color: "#FF681F" },
  {
    id: "AZ - DEALER ONLY CLEAN TITLE (P)",
    label: "AZ - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "PA - RECONSTRUCTED CLEAN",
    label: "PA - RECONSTRUCTED CLEAN",
    color: "#FF681F",
  },
  {
    id: "MD - CERT OF TITLE-REBUILT SALVAGE (P)",
    label: "MD - CERT OF TITLE-REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "Watercraft (Missouri)",
    label: "Watercraft (Missouri)",
    color: "#FF681F",
  },
  { id: "Original (Vermont)", label: "Original (Vermont)", color: "#FF681F" },
  {
    id: "OH - DEALER ONLY CLEAN TITLE",
    label: "OH - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "MD - CERTIFICATE OF TITLE",
    label: "MD - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "IN - CERT OF TITLE FOR A WATERCRAFT",
    label: "IN - CERT OF TITLE FOR A WATERCRAFT",
    color: "#FF681F",
  },
  {
    id: "Original  (Oklahoma)",
    label: "Original  (Oklahoma)",
    color: "#FF681F",
  },
  {
    id: "MN - CERT OF TITLE-PR SALV FLOOD",
    label: "MN - CERT OF TITLE-PR SALV FLOOD",
    color: "#FF681F",
  },
  { id: "Vessel (Florida)", label: "Vessel (Florida)", color: "#FF681F" },
  {
    id: "NC - VESSEL-CERTIFICATE OF TITLE",
    label: "NC - VESSEL-CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "LA - BOAT REGISTRATION CERTIFICATE",
    label: "LA - BOAT REGISTRATION CERTIFICATE",
    color: "#FF681F",
  },
  {
    id: "MI - WATERCRAFT CERT OF TITLE",
    label: "MI - WATERCRAFT CERT OF TITLE",
    color: "#FF681F",
  },
  { id: "NB - CLEAN TITLE", label: "NB - CLEAN TITLE", color: "#FF681F" },
  {
    id: "IN - CERT OF TITLE-SALVAGE FLOOD",
    label: "IN - CERT OF TITLE-SALVAGE FLOOD",
    color: "#FF681F",
  },
  {
    id: "CO - NON-REPAIRABLE CERT OF TITLE",
    label: "CO - NON-REPAIRABLE CERT OF TITLE",
    color: "#FF0000",
  },
  {
    id: "UT - FLOOD/SALVAGE CERT. OF TITLE",
    label: "UT - FLOOD/SALVAGE CERT. OF TITLE",
    color: "#FF681F",
  },
  {
    id: "TN - CERT OF TITLE-FLOOD VEHICLE",
    label: "TN - CERT OF TITLE-FLOOD VEHICLE",
    color: "#FF681F",
  },
  {
    id: "MT - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "MT - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "VA - CERT OF TITLE TO A VESSEL",
    label: "VA - CERT OF TITLE TO A VESSEL",
    color: "#FF681F",
  },
  {
    id: "KS - DEALER ONLY CLEAN TITLE (P)",
    label: "KS - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "AR - NON PUBLIC CLEAN TITLE",
    label: "AR - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Vessel (North Carolina)",
    label: "Certificate Of Vessel (North Carolina)",
    color: "#FF681F",
  },
  {
    id: "Watercraft (Michigan)",
    label: "Watercraft (Michigan)",
    color: "#FF681F",
  },
  {
    id: "NY - CERT OF TITLE-REBUILT SALVAGE",
    label: "NY - CERT OF TITLE-REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "OH - CERT OF TITLE-FLOOD HISTORY",
    label: "OH - CERT OF TITLE-FLOOD HISTORY",
    color: "#FF681F",
  },
  {
    id: "VA - CERT OF TITLE-REBUILT (P)",
    label: "VA - CERT OF TITLE-REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "OK - CERTIFICATE OF TITLE",
    label: "OK - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "TN - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "TN - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "MN - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "MN - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "MA - CERTIFICATE OF TITLE",
    label: "MA - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "OR - CERTIFICATE OF TITLE",
    label: "OR - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "MT - BONDED CERTIFICATE OF TITLE",
    label: "MT - BONDED CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "KS - FLOOD - SALVAGE",
    label: "KS - FLOOD - SALVAGE",
    color: "#FF681F",
  },
  {
    id: "TX - BONDED TITLE - CLEAN",
    label: "TX - BONDED TITLE - CLEAN",
    color: "#FF681F",
  },
  {
    id: "TN - CERT OF TITLE-REBUILT VEHICLE (P)",
    label: "TN - CERT OF TITLE-REBUILT VEHICLE (P)",
    color: "#FF681F",
  },
  {
    id: "SC - DEALER ONLY CLEAN TITLE",
    label: "SC - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "KY - CERT OF TITLE-REBUILT WATER",
    label: "KY - CERT OF TITLE-REBUILT WATER",
    color: "#FF681F",
  },
  {
    id: "LA - CERT OF TITLE-RECONSTRUCTED",
    label: "LA - CERT OF TITLE-RECONSTRUCTED",
    color: "#FF681F",
  },
  {
    id: "NV - NON-REPAIRABLE VEHICLE CERT",
    label: "NV - NON-REPAIRABLE VEHICLE CERT",
    color: "#FF0000",
  },
  {
    id: "MI - DEALER ONLY WATERCRAFT TITLE",
    label: "MI - DEALER ONLY WATERCRAFT TITLE",
    color: "#FF681F",
  },
  {
    id: "MD - CERT OF TITLE FOR A VESSEL",
    label: "MD - CERT OF TITLE FOR A VESSEL",
    color: "#FF681F",
  },
  {
    id: "Non-Repairable (California)",
    label: "Non-Repairable (California)",
    color: "#FF0000",
  },
  { id: "Clear (Georgia)", label: "Clear (Georgia)", color: "#FF681F" },
  { id: "Clear (Kansas)", label: "Clear (Kansas)", color: "#FF681F" },
  {
    id: "AR - CERTIFICATE OF TITLE (P)",
    label: "AR - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  { id: "Clear (Arizona)", label: "Clear (Arizona)", color: "#FF681F" },
  {
    id: "MO - SALVAGE CERTIFICATE OF TITLE (P)",
    label: "MO - SALVAGE CERTIFICATE OF TITLE (P)",
    color: "#008000",
  },
  {
    id: "OR - CERTIFICATE OF TITLE (P)",
    label: "OR - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "OR - CERT OF TITLE-RECONSTRUCTED",
    label: "OR - CERT OF TITLE-RECONSTRUCTED",
    color: "#FF681F",
  },
  {
    id: "Ns-Non-Repairable (Nova Scotia)",
    label: "Ns-Non-Repairable (Nova Scotia)",
    color: "#FF0000",
  },
  {
    id: "KY - CERT OF TITLE-REBUILT VEHICLE",
    label: "KY - CERT OF TITLE-REBUILT VEHICLE",
    color: "#FF681F",
  },
  { id: "Clear (Wyoming)", label: "Clear (Wyoming)", color: "#FF681F" },
  {
    id: "IN - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    label: "IN - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "MI - CERT OF TITLE-SALVAGE FLOOD",
    label: "MI - CERT OF TITLE-SALVAGE FLOOD",
    color: "#FF681F",
  },
  {
    id: "AR - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "AR - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  { id: "Clear (Michigan)", label: "Clear (Michigan)", color: "#FF681F" },
  {
    id: "NS - REBUILD VEHICLE",
    label: "NS - REBUILD VEHICLE",
    color: "#FF681F",
  },
  {
    id: "NY - CERTIFICATE OF TITLE",
    label: "NY - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "NC - CERTIFICATE OF TITLE",
    label: "NC - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "MN - CERT OF TITLE TO A WATERCRAFT",
    label: "MN - CERT OF TITLE TO A WATERCRAFT",
    color: "#FF681F",
  },
  {
    id: "AL - CERT OF TITLE-FLOOD SALVAGE",
    label: "AL - CERT OF TITLE-FLOOD SALVAGE",
    color: "#FF681F",
  },
  {
    id: "GA - NON PUBLIC CLEAN TITLE",
    label: "GA - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "LA - BOAT CERTIFICATE OF TITLE",
    label: "LA - BOAT CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "OH - CERT OF TITLE-WATERCRAFT",
    label: "OH - CERT OF TITLE-WATERCRAFT",
    color: "#FF681F",
  },
  {
    id: "KY - RED REBUILT SALVAGE FLOOD",
    label: "KY - RED REBUILT SALVAGE FLOOD",
    color: "#FF681F",
  },
  {
    id: "ID - CERTIFICATE OF TITLE (P)",
    label: "ID - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "IL - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "IL - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "CO - DEALER ONLY CLEAN TITLE (P)",
    label: "CO - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "LA - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "LA - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "IN - CERT OF TITLE - REBUILT VEHICL (P)",
    label: "IN - CERT OF TITLE - REBUILT VEHICL (P)",
    color: "#FF681F",
  },
  {
    id: "MD - CERT OF SALVAGE-FLOOD DAMAGE",
    label: "MD - CERT OF SALVAGE-FLOOD DAMAGE",
    color: "#FF681F",
  },
  {
    id: "NV - DLR/DIS/EXP-CT OTHERS- (P)",
    label: "NV - DLR/DIS/EXP-CT OTHERS- (P)",
    color: "#FF681F",
  },
  {
    id: "TX - BONDED TITLE - CLEAN (P)",
    label: "TX - BONDED TITLE - CLEAN (P)",
    color: "#FF681F",
  },
  {
    id: "NM - NON-REPAIRABLE VEHICLE CERT",
    label: "NM - NON-REPAIRABLE VEHICLE CERT",
    color: "#FF0000",
  },
  {
    id: "Clear-Dealer Only (Oklahoma)",
    label: "Clear-Dealer Only (Oklahoma)",
    color: "#008000",
  },
  {
    id: "MI - DEALER ONLY CLEAN TITLE (P)",
    label: "MI - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "OR - CERT OF TITLE-RECONSTRUCTED (P)",
    label: "OR - CERT OF TITLE-RECONSTRUCTED (P)",
    color: "#FF681F",
  },
  {
    id: "IN - CERT OF TITLE - REBUILT FLOOD",
    label: "IN - CERT OF TITLE - REBUILT FLOOD",
    color: "#FF681F",
  },
  {
    id: "CO - DEALER ONLY CLEAN TITLE",
    label: "CO - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "NH - CERT OF TITLE-REBUILT VEHICLE (P)",
    label: "NH - CERT OF TITLE-REBUILT VEHICLE (P)",
    color: "#FF681F",
  },
  {
    id: "FL - CERT OF TITLE-SLVG REBLD FLOOD",
    label: "FL - CERT OF TITLE-SLVG REBLD FLOOD",
    color: "#FF681F",
  },
  {
    id: "Non-Repairable (Pennsylvania)",
    label: "Non-Repairable (Pennsylvania)",
    color: "#FF0000",
  },
  {
    id: "VA - DEALER ONLY CLEAN TITLE (P)",
    label: "VA - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "IN - CERT OF TITLE - REBUILT VEHICL",
    label: "IN - CERT OF TITLE - REBUILT VEHICL",
    color: "#FF681F",
  },
  { id: "Clear (Hawaii)", label: "Clear (Hawaii)", color: "#FF681F" },
  {
    id: "WV - NON-REPAIRABLE CERTIFICATE",
    label: "WV - NON-REPAIRABLE CERTIFICATE",
    color: "#FF0000",
  },
  {
    id: "TX - CERT OF TITLE-REBUILT SALVAGE (P)",
    label: "TX - CERT OF TITLE-REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "MT - CERTIFICATE OF TITLE (P)",
    label: "MT - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "AL - CERT OF TITLE-REBUILT",
    label: "AL - CERT OF TITLE-REBUILT",
    color: "#FF681F",
  },
  {
    id: "WI - CLEAN TTL-MANUFACTURER BUYBACK",
    label: "WI - CLEAN TTL-MANUFACTURER BUYBACK",
    color: "#FF681F",
  },
  {
    id: "Non-Repairable (Virginia)",
    label: "Non-Repairable (Virginia)",
    color: "#FF0000",
  },
  { id: "Rebuilt (Oklahoma)", label: "Rebuilt (Oklahoma)", color: "#FF681F" },
  {
    id: "IN - CERTIFICATE OF TITLE (P)",
    label: "IN - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "VA - CERTIFICATE OF TITLE (P)",
    label: "VA - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Arizona)",
    label: "Enterprise Vehicles Clear Only (Arizona)",
    color: "#FF681F",
  },
  {
    id: "TX - NONREPAIRABLE TITLE (P)",
    label: "TX - NONREPAIRABLE TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "Non-Repairable Export Only (Texas)",
    label: "Non-Repairable Export Only (Texas)",
    color: "#FF0000",
  },
  {
    id: "CA - NON-REPAIRABLE VEHICLE CERT",
    label: "CA - NON-REPAIRABLE VEHICLE CERT",
    color: "#FF0000",
  },
  {
    id: "OK - CERT OF TITLE-REBUILT",
    label: "OK - CERT OF TITLE-REBUILT",
    color: "#FF681F",
  },
  {
    id: "MS - CERT OF TITLE-REBUILT",
    label: "MS - CERT OF TITLE-REBUILT",
    color: "#FF681F",
  },
  {
    id: "MO - CERTIFICATE OF TITLE (P)",
    label: "MO - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "NE - CERTIFICATE OF TITLE",
    label: "NE - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "KY - RED REBUILT FLOOD",
    label: "KY - RED REBUILT FLOOD",
    color: "#FF681F",
  },
  {
    id: "Non-Repairable Certificate (California)",
    label: "Non-Repairable Certificate (California)",
    color: "#FF0000",
  },
  {
    id: "MD - CERTIFICATE OF TITLE (P)",
    label: "MD - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "CT - CERTIFICATE OF TITLE (P)",
    label: "CT - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "MI - FLOOD-MUNICIPAL",
    label: "MI - FLOOD-MUNICIPAL",
    color: "#FF681F",
  },
  {
    id: "MI - CERT OF TITLE-POLICE",
    label: "MI - CERT OF TITLE-POLICE",
    color: "#FF681F",
  },
  {
    id: "MI - DEALER ONLY CLEAN TITLE",
    label: "MI - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "IL - CERT OF TITLE-FLOOD/REBUILT",
    label: "IL - CERT OF TITLE-FLOOD/REBUILT",
    color: "#FF681F",
  },
  {
    id: "IL - CERTIFICATE OF TITLE (P)",
    label: "IL - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "FL - CERT OF TITLE-REBUILT",
    label: "FL - CERT OF TITLE-REBUILT",
    color: "#FF681F",
  },
  {
    id: "WA - CERT OF OWNERSHIP-REBUILT (P)",
    label: "WA - CERT OF OWNERSHIP-REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "Clear - Less Than 75% (Maryland)",
    label: "Clear - Less Than 75% (Maryland)",
    color: "#FF681F",
  },
  { id: "Clear (New Mexico)", label: "Clear (New Mexico)", color: "#FF681F" },
  {
    id: "KS - NON-REPAIRABLE VEHICLE CERTIFI",
    label: "KS - NON-REPAIRABLE VEHICLE CERTIFI",
    color: "#FF0000",
  },
  {
    id: "MA - CERT OF TITLE-FLOOD SALVAGE",
    label: "MA - CERT OF TITLE-FLOOD SALVAGE",
    color: "#FF681F",
  },
  {
    id: "MI - SCRAP CERT OF TITLE-FLOOD VEH",
    label: "MI - SCRAP CERT OF TITLE-FLOOD VEH",
    color: "#FF681F",
  },
  {
    id: "NC - DEALER ONLY CLEAN TITLE (P)",
    label: "NC - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "Original (New Hampshire)",
    label: "Original (New Hampshire)",
    color: "#FF681F",
  },
  { id: "Clear (Montana)", label: "Clear (Montana)", color: "#FF681F" },
  {
    id: "SC - CERTIFICATE OF TITLE (P)",
    label: "SC - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "PA - RECONSTRUCTED CLEAN (P)",
    label: "PA - RECONSTRUCTED CLEAN (P)",
    color: "#FF681F",
  },
  { id: "Clear (California)", label: "Clear (California)", color: "#FF681F" },
  {
    id: "Non-Repairable (Maryland)",
    label: "Non-Repairable (Maryland)",
    color: "#FF0000",
  },
  {
    id: "Enterprise Vehicles Clear Only (Alaska)",
    label: "Enterprise Vehicles Clear Only (Alaska)",
    color: "#FF681F",
  },
  { id: "Clear (Oklahoma)", label: "Clear (Oklahoma)", color: "#FF681F" },
  {
    id: "NJ - CERTIFICATE OF TITLE (P)",
    label: "NJ - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "WA - CT CLEAN TITLE PUBLIC ELIG.",
    label: "WA - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "AL - CERTIFICATE OF TITLE (P)",
    label: "AL - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "SD - CERTIFICATE OF TITLE",
    label: "SD - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "MD - CERT OF TITLE-REBUILT SALVAGE",
    label: "MD - CERT OF TITLE-REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "Clear - Dealer Only (California)",
    label: "Clear - Dealer Only (California)",
    color: "#008000",
  },
  {
    id: "Clear-Dealer Only (Georgia)",
    label: "Clear-Dealer Only (Georgia)",
    color: "#008000",
  },
  {
    id: "Clear-Dealer Only (Arizona)",
    label: "Clear-Dealer Only (Arizona)",
    color: "#008000",
  },
  { id: "Clear (Arkansas)", label: "Clear (Arkansas)", color: "#FF681F" },
  { id: "Clear (Maryland)", label: "Clear (Maryland)", color: "#FF681F" },
  { id: "Original (Kentucky)", label: "Original (Kentucky)", color: "#FF681F" },
  { id: "Clear (Washington)", label: "Clear (Washington)", color: "#FF681F" },
  {
    id: "MO - DEALER ONLY CLEAN TITLE (P)",
    label: "MO - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "WA - VEHICLE CERT OF OWNERSHIP-TITL (P)",
    label: "WA - VEHICLE CERT OF OWNERSHIP-TITL (P)",
    color: "#FF681F",
  },
  {
    id: "AZ - CERTIFICATE OF TITLE (P)",
    label: "AZ - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "DE - FLOOD SALVAGE TITLE",
    label: "DE - FLOOD SALVAGE TITLE",
    color: "#FF681F",
  },
  {
    id: "MI - DEALER ONLY-REBUILT SALVAGE",
    label: "MI - DEALER ONLY-REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "CA - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "CA - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "NC - SALVAGE CERT-REBUILT (P)",
    label: "NC - SALVAGE CERT-REBUILT (P)",
    color: "#FF681F",
  },
  { id: "Clear (Delaware)", label: "Clear (Delaware)", color: "#FF681F" },
  {
    id: "AZ - DEALER ONLY NON-REPAIRABLE",
    label: "AZ - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "ME - CERTIFICATE OF TITLE",
    label: "ME - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "NJ - CT CLEAN TITLE PUBLIC ELIG.",
    label: "NJ - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "MA - CERT OF TITLE-RECONSTRCTD FLD",
    label: "MA - CERT OF TITLE-RECONSTRCTD FLD",
    color: "#FF681F",
  },
  {
    id: "WA - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    label: "WA - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "IL - CERT OF TITLE-FLOOD",
    label: "IL - CERT OF TITLE-FLOOD",
    color: "#FF681F",
  },
  {
    id: "Reconstructed (Massachusetts)",
    label: "Reconstructed (Massachusetts)",
    color: "#FF681F",
  },
  {
    id: "NC - CERTIFICATE OF TITLE (P)",
    label: "NC - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "KY - CERTIFICATE OF TITLE (P)",
    label: "KY - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "KY - RED REBUILT SALVAGE",
    label: "KY - RED REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "VA - CERT OF TITLE-FLOOD",
    label: "VA - CERT OF TITLE-FLOOD",
    color: "#FF681F",
  },
  {
    id: "MI - CERT OF TITLE-FLOOD REBLT SALV",
    label: "MI - CERT OF TITLE-FLOOD REBLT SALV",
    color: "#FF681F",
  },
  {
    id: "MD - CERT OF TITLE-FLOOD DAMAGE",
    label: "MD - CERT OF TITLE-FLOOD DAMAGE",
    color: "#FF681F",
  },
  {
    id: "Non-Repairable (Colorado)",
    label: "Non-Repairable (Colorado)",
    color: "#FF0000",
  },
  {
    id: "TN - CT CLEAN TITLE PUBLIC ELIG.",
    label: "TN - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "OR - CLEAN TITLE APP FOR DUPLICATE",
    label: "OR - CLEAN TITLE APP FOR DUPLICATE",
    color: "#FF681F",
  },
  {
    id: "Non-Repairable Certificate (West Virginia)",
    label: "Non-Repairable Certificate (West Virginia)",
    color: "#FF0000",
  },
  {
    id: "CA - DIS/DLR/EXP NONREPAIRABLE CERT",
    label: "CA - DIS/DLR/EXP NONREPAIRABLE CERT",
    color: "#FF681F",
  },
  {
    id: "MI - CERTIFICATE OF TITLE (P)",
    label: "MI - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Title (Nebraska)",
    label: "Certificate Of Title (Nebraska)",
    color: "#FF681F",
  },
  {
    id: "Ab-Non-Repairable (Alberta)",
    label: "Ab-Non-Repairable (Alberta)",
    color: "#FF0000",
  },
  {
    id: "NM - CERTIFICATE OF TITLE (P)",
    label: "NM - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "VT - CERTIFICATE OF TITLE",
    label: "VT - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "MT - DEALER ONLY CLEAN TITLE",
    label: "MT - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "Clear-Dealer Only (West Virginia)",
    label: "Clear-Dealer Only (West Virginia)",
    color: "#008000",
  },
  { id: "Clear (Louisiana)", label: "Clear (Louisiana)", color: "#FF681F" },
  {
    id: "PA - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "PA - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "MD - NON PUBLIC CLEAN TITLE",
    label: "MD - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "Clear-Dealer Only (Utah)",
    label: "Clear-Dealer Only (Utah)",
    color: "#008000",
  },
  {
    id: "WI - CERT OF TITLE-CLAIM PAID",
    label: "WI - CERT OF TITLE-CLAIM PAID",
    color: "#FF681F",
  },
  {
    id: "ID - CERTIFICATE OF TITLE",
    label: "ID - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Ohio)",
    label: "Enterprise Vehicles Clear Only (Ohio)",
    color: "#FF681F",
  },
  { id: "Clear (Puerto Rico)", label: "Clear (Puerto Rico)", color: "#FF681F" },
  { id: "Non-Repairable (Utah)", label: "Non-Repairable (Utah)", color: "#FF0000" },
  {
    id: "WA - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "WA - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "FL - CERT OF TTL-REBUILT&SLVG RBLD",
    label: "FL - CERT OF TTL-REBUILT&SLVG RBLD",
    color: "#008000",
  },
  {
    id: "CA - CERTIFICATE OF TITLE",
    label: "CA - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "VA - NON-REPAIRABLE CERTIFICATE",
    label: "VA - NON-REPAIRABLE CERTIFICATE",
    color: "#FF0000",
  },
  {
    id: "IN - DEALER ONLY CLEAN TITLE (P)",
    label: "IN - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "MT - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    label: "MT - DLR/DIS/EXP-CT OTHERS-CA ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "FL - DEALER ONLY CLEAN TITLE (P)",
    label: "FL - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "NC - DLR ONLY-CLEAN/OVER 25% DAMAGE",
    label: "NC - DLR ONLY-CLEAN/OVER 25% DAMAGE",
    color: "#FF681F",
  },
  {
    id: "AB - BOS - NONREPAIRABLE",
    label: "AB - BOS - NONREPAIRABLE",
    color: "#FF681F",
  },
  {
    id: "MI - DEALER ONLY-REBUILT SALVAGE (P)",
    label: "MI - DEALER ONLY-REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "Rebuilt-Non-Public (Washington)",
    label: "Rebuilt-Non-Public (Washington)",
    color: "#FF681F",
  },
  {
    id: "TX - CERT OF TITLE-REBLT SLVG FLOOD",
    label: "TX - CERT OF TITLE-REBLT SLVG FLOOD",
    color: "#FF681F",
  },
  {
    id: "AZ - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "AZ - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "HI - CERTIFICATE OF TITLE",
    label: "HI - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "IN - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "IN - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "TX - NON PUBLIC CLEAN TITLE",
    label: "TX - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "NC - SALVAGE CERT-WATER/FLOOD DAMAG",
    label: "NC - SALVAGE CERT-WATER/FLOOD DAMAG",
    color: "#FF681F",
  },
  { id: "CN - CLEAN TITLE", label: "CN - CLEAN TITLE", color: "#FF681F" },
  {
    id: "RI - CERTIFICATE OF TITLE (P)",
    label: "RI - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "VA - CERT OF TITLE-REBUILT",
    label: "VA - CERT OF TITLE-REBUILT",
    color: "#FF681F",
  },
  {
    id: "TX - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    label: "TX - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "OH - CERT OF TITLE-REBUILT SALVAGE",
    label: "OH - CERT OF TITLE-REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "OH - CERTIFICATE OF TITLE (P)",
    label: "OH - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "Clear-Dealer Only (Oregon)",
    label: "Clear-Dealer Only (Oregon)",
    color: "#008000",
  },
  {
    id: "Prior Salvage - Rebuilt (Minnesota)",
    label: "Prior Salvage - Rebuilt (Minnesota)",
    color: "#FF681F",
  },
  {
    id: "Rebuilt/Restored (Utah)",
    label: "Rebuilt/Restored (Utah)",
    color: "#FF681F",
  },
  {
    id: "VT - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "VT - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "CO - PUBLIC - NONREPAIRABLE",
    label: "CO - PUBLIC - NONREPAIRABLE",
    color: "#FF681F",
  },
  {
    id: "WI - BOAT CERTIFICATE OF TITLE",
    label: "WI - BOAT CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "ND - DEALER ONLY CLEAN TITLE",
    label: "ND - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "MO - CERTIFICATE OF TITLE",
    label: "MO - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "AL - RECOVERED THEFT - CLEAN",
    label: "AL - RECOVERED THEFT - CLEAN",
    color: "#FF681F",
  },
  {
    id: "KS - CLEAN TITLE W/SALVAGE HISTORY",
    label: "KS - CLEAN TITLE W/SALVAGE HISTORY",
    color: "#FF681F",
  },
  {
    id: "MO - DEALER ONLY CLEAN TITLE",
    label: "MO - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "Reconstructed (Louisiana)",
    label: "Reconstructed (Louisiana)",
    color: "#FF681F",
  },
  {
    id: "IL - DEALER ONLY CLEAN TITLE",
    label: "IL - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "IL - CERTIFICATE OF TITLE",
    label: "IL - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "ND - CERTIFICATE OF TITLE FOR A VEH",
    label: "ND - CERTIFICATE OF TITLE FOR A VEH",
    color: "#FF681F",
  },
  {
    id: "MT - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "MT - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "GA - CERT OF TITLE-REBUILT",
    label: "GA - CERT OF TITLE-REBUILT",
    color: "#FF681F",
  },
  {
    id: "MI - CERT OF TITLE-FLOOD VEHICLE",
    label: "MI - CERT OF TITLE-FLOOD VEHICLE",
    color: "#FF681F",
  },
  {
    id: "VT - CERT OF TITLE-REBUILT VEHICLE",
    label: "VT - CERT OF TITLE-REBUILT VEHICLE",
    color: "#FF681F",
  },
  {
    id: "IN - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "IN - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "OH - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "OH - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "TN - CERT OF TITLE-REBUILT VEHICLE",
    label: "TN - CERT OF TITLE-REBUILT VEHICLE",
    color: "#FF681F",
  },
  {
    id: "NV - DLR/DIS/EXP-CT OTHERS-",
    label: "NV - DLR/DIS/EXP-CT OTHERS-",
    color: "#FF681F",
  },
  {
    id: "NH - CERT OF TTL-FLOOD SALVAGE",
    label: "NH - CERT OF TTL-FLOOD SALVAGE",
    color: "#FF681F",
  },
  {
    id: "IA - CERTIFICATE OF TITLE (P)",
    label: "IA - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "Non-Repairable (Tennessee)",
    label: "Non-Repairable (Tennessee)",
    color: "#FF0000",
  },
  {
    id: "GA - DEALER ONLY CLEAN TITLE (P)",
    label: "GA - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "KY - RED REBUILT SALVAGE BRANDED",
    label: "KY - RED REBUILT SALVAGE BRANDED",
    color: "#FF681F",
  },
  {
    id: "MT - CERTIFICATE OF TITLE TOTALED",
    label: "MT - CERTIFICATE OF TITLE TOTALED",
    color: "#FF681F",
  },
  {
    id: "PA - CERT OF SALV-R=RECONSTRUCTED",
    label: "PA - CERT OF SALV-R=RECONSTRUCTED",
    color: "#FF681F",
  },
  {
    id: "VA - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "VA - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "NC - SALVAGE CERTIFICATE OF TITLE (P)",
    label: "NC - SALVAGE CERTIFICATE OF TITLE (P)",
    color: "#008000",
  },
  {
    id: "SC - DEALER ONLY CLEAN TITLE (P)",
    label: "SC - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "TN - DEALER ONLY CLEAN TITLE (P)",
    label: "TN - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "MD - DEALER ONLY SALVAGE TITLE (P)",
    label: "MD - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "KS - CERT OF TITLE-NON HIGHWAY",
    label: "KS - CERT OF TITLE-NON HIGHWAY",
    color: "#FF681F",
  },
  {
    id: "FL - CERT OF TITLE-FLOOD DAMAGED (P)",
    label: "FL - CERT OF TITLE-FLOOD DAMAGED (P)",
    color: "#FF681F",
  },
  {
    id: "KY - DEALER ONLY CLEAN TITLE",
    label: "KY - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "TX - CERT OF TITLE TO A BOAT",
    label: "TX - CERT OF TITLE TO A BOAT",
    color: "#FF681F",
  },
  {
    id: "MO - MARINE CERTIFICATE OF TITLE",
    label: "MO - MARINE CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "GA - CERTIFICATE OF TITLE",
    label: "GA - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "TX - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "TX - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "OH - CERT OF TITLE-SALVAGE FLOOD",
    label: "OH - CERT OF TITLE-SALVAGE FLOOD",
    color: "#FF681F",
  },
  {
    id: "WA - CERT OF OWNERSHIP-REBUILT",
    label: "WA - CERT OF OWNERSHIP-REBUILT",
    color: "#FF681F",
  },
  {
    id: "PA - CERT OF SALVAGE-W=FLOOD VEH",
    label: "PA - CERT OF SALVAGE-W=FLOOD VEH",
    color: "#FF681F",
  },
  {
    id: "WA - DEALER ONLY CLEAN TITLE",
    label: "WA - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "TN - DEALER ONLY CLEAN TITLE",
    label: "TN - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "WA - DEALER ONLY CLEAN TITLE (P)",
    label: "WA - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "Original - Reconstructed (Alaska)",
    label: "Original - Reconstructed (Alaska)",
    color: "#FF681F",
  },
  {
    id: "NC - DLR ONLY-CLEAN/OVER 25% DAMAGE (P)",
    label: "NC - DLR ONLY-CLEAN/OVER 25% DAMAGE (P)",
    color: "#FF681F",
  },
  {
    id: "IN - DEALER ONLY CLEAN TITLE",
    label: "IN - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "GA - CERT OF TITLE-COURT ORDER",
    label: "GA - CERT OF TITLE-COURT ORDER",
    color: "#FF681F",
  },
  {
    id: "VA - DEALER ONLY CLEAN TITLE",
    label: "VA - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "Clear-Dealer Only (Idaho)",
    label: "Clear-Dealer Only (Idaho)",
    color: "#008000",
  },
  {
    id: "NC - SALVAGE CERT-REBUILT",
    label: "NC - SALVAGE CERT-REBUILT",
    color: "#FF681F",
  },
  {
    id: "LA - CERTIFICATE OF TITLE (P)",
    label: "LA - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "NC - DEALER ONLY SALVAGE TITLE (P)",
    label: "NC - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "AR - CERT OF TITLE-REBUILT",
    label: "AR - CERT OF TITLE-REBUILT",
    color: "#FF681F",
  },
  {
    id: "Non-Repairable (Arizona)",
    label: "Non-Repairable (Arizona)",
    color: "#FF0000",
  },
  {
    id: "Original (Rhode Island)",
    label: "Original (Rhode Island)",
    color: "#FF681F",
  },
  {
    id: "TX - DEALER ONLY CLEAN TITLE",
    label: "TX - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "Clear - Public Restricted (Oregon)",
    label: "Clear - Public Restricted (Oregon)",
    color: "#FF681F",
  },
  { id: "Original (Maine)", label: "Original (Maine)", color: "#FF681F" },
  {
    id: "Clear-Dealer Only (Washington)",
    label: "Clear-Dealer Only (Washington)",
    color: "#008000",
  },
  {
    id: "LA - CERTIFICATE OF TITLE",
    label: "LA - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "ME - CERTIFICATE OF TITLE (P)",
    label: "ME - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "UT - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "UT - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "WI - CERTIFICATE OF TITLE",
    label: "WI - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "Clear (North Carolina)",
    label: "Clear (North Carolina)",
    color: "#FF681F",
  },
  {
    id: "Clear (New Hampshire)",
    label: "Clear (New Hampshire)",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (Montana)",
    label: "Enterprise Vehicles Clear Only (Montana)",
    color: "#FF681F",
  },
  { id: "Dealer (Iowa)", label: "Dealer (Iowa)", color: "#FF681F" },
  {
    id: "MI - NON PUBLIC CLEAN TITLE",
    label: "MI - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  { id: "Clear (Utah)", label: "Clear (Utah)", color: "#FF681F" },
  {
    id: "MN - CERTIFICATE OF TITLE (P)",
    label: "MN - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "Non-Repairable (Texas)",
    label: "Non-Repairable (Texas)",
    color: "#FF0000",
  },
  {
    id: "MS - CERTIFICATE OF TITLE (P)",
    label: "MS - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "Regular (South Dakota)",
    label: "Regular (South Dakota)",
    color: "#FF681F",
  },
  {
    id: "KS - CERTIFICATE OF TITLE (P)",
    label: "KS - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "WY - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "WY - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "AL - CERT OF TITLE-FLOOD REBUILT",
    label: "AL - CERT OF TITLE-FLOOD REBUILT",
    color: "#FF681F",
  },
  {
    id: "Clear-Endorsement (Wisconsin)",
    label: "Clear-Endorsement (Wisconsin)",
    color: "#FF681F",
  },
  {
    id: "FL - CERT OF TITLE-FLOOD & REBUILT (P)",
    label: "FL - CERT OF TITLE-FLOOD & REBUILT (P)",
    color: "#FF681F",
  },
  { id: "Original (Alaska)", label: "Original (Alaska)", color: "#FF681F" },
  {
    id: "IL - CERT OF TITLE-REBUILT",
    label: "IL - CERT OF TITLE-REBUILT",
    color: "#FF681F",
  },
  {
    id: "DE - CERTIFICATE OF TITLE",
    label: "DE - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "MA - CERT OF TITLE-RECONSTRCTD COLL (P)",
    label: "MA - CERT OF TITLE-RECONSTRCTD COLL (P)",
    color: "#FF681F",
  },
  {
    id: "WA - VEHICLE CERT OF OWNERSHIP-TITL",
    label: "WA - VEHICLE CERT OF OWNERSHIP-TITL",
    color: "#FF681F",
  },
  {
    id: "NE - CERT OF TITLE-REBUILT SALVAGE",
    label: "NE - CERT OF TITLE-REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "Clear (North Dakota)",
    label: "Clear (North Dakota)",
    color: "#FF681F",
  },
  {
    id: "AL - CERT OF TITLE-REBUILT SALVAGE",
    label: "AL - CERT OF TITLE-REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "FL - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "FL - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "NC - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "NC - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "TX - SALVAGE TITLE-FLOOD DAMAGE",
    label: "TX - SALVAGE TITLE-FLOOD DAMAGE",
    color: "#FF681F",
  },
  {
    id: "OH - DEALER ONLY CLEAN TITLE (P)",
    label: "OH - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "MD - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "MD - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "FL - CERT OF TITLE-POLICE",
    label: "FL - CERT OF TITLE-POLICE",
    color: "#FF681F",
  },
  {
    id: "OH - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "OH - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "MN - NON PUBLIC CLEAN TITLE",
    label: "MN - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "NV - CERT OF TITLE-REBUILT TOTAL LO",
    label: "NV - CERT OF TITLE-REBUILT TOTAL LO",
    color: "#FF681F",
  },
  {
    id: "NC - CLEAN TITLE-OVER 25% DAMAGE",
    label: "NC - CLEAN TITLE-OVER 25% DAMAGE",
    color: "#FF681F",
  },
  {
    id: "KS - DEALER ONLY CLEAN TITLE",
    label: "KS - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "Clear-Dealer Only (Texas)",
    label: "Clear-Dealer Only (Texas)",
    color: "#008000",
  },
  {
    id: "NM - DEALER ONLY CLEAN TITLE",
    label: "NM - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "App For Dup Clear (California)",
    label: "App For Dup Clear (California)",
    color: "#FF681F",
  },
  { id: "Clear (Idaho)", label: "Clear (Idaho)", color: "#FF681F" },
  {
    id: "TX - SALVAGE TITLE-FLOOD DAMAGE (P)",
    label: "TX - SALVAGE TITLE-FLOOD DAMAGE (P)",
    color: "#FF681F",
  },
  {
    id: "TX - BONDED REBUILT SALVAGE",
    label: "TX - BONDED REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "WA - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "WA - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "NV - CERTIFICATE OF TITLE (P)",
    label: "NV - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "NJ - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    label: "NJ - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "MS - CERT OF TITLE-FLOOD DAMAGED",
    label: "MS - CERT OF TITLE-FLOOD DAMAGED",
    color: "#FF681F",
  },
  {
    id: "DE - CERTIFICATE OF TITLE (P)",
    label: "DE - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "CO - CERTIFICATE OF TITLE",
    label: "CO - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "NY - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    label: "NY - DLR/DIS/EXP-CT OTHERS-ACQ (P)",
    color: "#FF681F",
  },
  {
    id: "FL - CERT OF TITLE-REBUILT (P)",
    label: "FL - CERT OF TITLE-REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "WA - NON PUBLIC CLEAN TITLE",
    label: "WA - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  { id: "Clear (Wisconsin)", label: "Clear (Wisconsin)", color: "#FF681F" },
  {
    id: "CA - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "CA - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "OK - CERT OF TITLE-SALVAGE FLOOD",
    label: "OK - CERT OF TITLE-SALVAGE FLOOD",
    color: "#FF681F",
  },
  { id: "Regular (Nevada)", label: "Regular (Nevada)", color: "#FF681F" },
  {
    id: "NC - NC DLR ONLY SLVG REBUILT (P)",
    label: "NC - NC DLR ONLY SLVG REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "CA - CLEAN TITLE W/SALVAGE HISTORY (P)",
    label: "CA - CLEAN TITLE W/SALVAGE HISTORY (P)",
    color: "#FF681F",
  },
  {
    id: "Clear-Dealer Only (Michigan)",
    label: "Clear-Dealer Only (Michigan)",
    color: "#008000",
  },
  {
    id: "Clear (Rhode Island)",
    label: "Clear (Rhode Island)",
    color: "#FF681F",
  },
  {
    id: "Clear - Dealer Only (Hawaii)",
    label: "Clear - Dealer Only (Hawaii)",
    color: "#FF681F",
  },
  { id: "Clear (Mississippi)", label: "Clear (Mississippi)", color: "#FF681F" },
  {
    id: "WV - CERTIFICATE OF TITLE (P)",
    label: "WV - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "MO - DEALER ONLY SALVAGE TITLE (P)",
    label: "MO - DEALER ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "UT - CERTIFICATE OF TITLE (P)",
    label: "UT - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "OR - NON PUBLIC CLEAN TITLE",
    label: "OR - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "TX - CERT OF TITLE-REBUILT SALVAGE",
    label: "TX - CERT OF TITLE-REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "WI - CERTIFICATE OF TITLE (P)",
    label: "WI - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "MI - SCRAP CERTIFICATE OF TITLE",
    label: "MI - SCRAP CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "Certificate Of Title (Montana)",
    label: "Certificate Of Title (Montana)",
    color: "#FF681F",
  },
  {
    id: "GA - DEALER ONLY CLEAN TITLE",
    label: "GA - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "ID - SALVAGE CERTIFICATE OF TITLE",
    label: "ID - SALVAGE CERTIFICATE OF TITLE",
    color: "#008000",
  },
  {
    id: "Watercraft (Illinois)",
    label: "Watercraft (Illinois)",
    color: "#FF681F",
  },
  {
    id: "Original (West Virginia)",
    label: "Original (West Virginia)",
    color: "#FF681F",
  },
  { id: "VT - FLOOD SALVAGE", label: "VT - FLOOD SALVAGE", color: "#FF681F" },
  {
    id: "Vessel Certificate (Virginia)",
    label: "Vessel Certificate (Virginia)",
    color: "#FF681F",
  },
  {
    id: "OK - CERTIFICATE OF TITLE (P)",
    label: "OK - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "Clear - To Be Obtained (Wisconsin)",
    label: "Clear - To Be Obtained (Wisconsin)",
    color: "#FF681F",
  },
  {
    id: "CA - CLEAN TITLE W/SALVAGE HISTORY",
    label: "CA - CLEAN TITLE W/SALVAGE HISTORY",
    color: "#FF681F",
  },
  {
    id: "Original Title (Mississippi)",
    label: "Original Title (Mississippi)",
    color: "#FF681F",
  },
  {
    id: "TX - CERTIFICATE OF TITLE",
    label: "TX - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "NH - CERTIFICATE OF TITLE",
    label: "NH - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "Boat Certificate Of Title (Wisconsin)",
    label: "Boat Certificate Of Title (Wisconsin)",
    color: "#FF681F",
  },
  { id: "Clear (New Jersey)", label: "Clear (New Jersey)", color: "#FF681F" },
  { id: "Clear (Connecticut)", label: "Clear (Connecticut)", color: "#FF681F" },
  {
    id: "IL - DEALER ONLY CLEAN TITLE (P)",
    label: "IL - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  { id: "Original (Texas)", label: "Original (Texas)", color: "#FF681F" },
  {
    id: "WI - CERT OF TITLE-REBUILT SALVAGE (P)",
    label: "WI - CERT OF TITLE-REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  { id: "Clear (Virginia)", label: "Clear (Virginia)", color: "#FF681F" },
  {
    id: "NE - NON PUBLIC CLEAN TITLE",
    label: "NE - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "KS - CERT OF TITLE-REBUILT SALVAGE",
    label: "KS - CERT OF TITLE-REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "OK - NON PUBLIC CLEAN TITLE",
    label: "OK - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "WI - CERTIFICATE OF ORIGIN (P)",
    label: "WI - CERTIFICATE OF ORIGIN (P)",
    color: "#FF681F",
  },
  {
    id: "UT - CERT OF TITLE-REBUILT/RESTORED",
    label: "UT - CERT OF TITLE-REBUILT/RESTORED",
    color: "#FF681F",
  },
  {
    id: "Clear (Massachusetts)",
    label: "Clear (Massachusetts)",
    color: "#FF681F",
  },
  {
    id: "CA - DIS/DLR/EXP NONREPAIRABLE CERT (P)",
    label: "CA - DIS/DLR/EXP NONREPAIRABLE CERT (P)",
    color: "#FF681F",
  },
  {
    id: "AK - CERT OF VEH TITLE-RECONSTRUCTE",
    label: "AK - CERT OF VEH TITLE-RECONSTRUCTE",
    color: "#FF681F",
  },
  { id: "Clear (Alabama)", label: "Clear (Alabama)", color: "#FF681F" },
  {
    id: "NY - CERT OF TITLE-REBUILT",
    label: "NY - CERT OF TITLE-REBUILT",
    color: "#FF681F",
  },
  { id: "Clear (Oregon)", label: "Clear (Oregon)", color: "#FF681F" },
  {
    id: "Regular Certificate (Iowa)",
    label: "Regular Certificate (Iowa)",
    color: "#FF681F",
  },
  {
    id: "CA - DEALER ONLY CLEAN TITLE (P)",
    label: "CA - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "IA - TITLE CERTIFICATE - BOAT",
    label: "IA - TITLE CERTIFICATE - BOAT",
    color: "#FF681F",
  },
  {
    id: "MA - CERT OF TITLE-RECONSTRCTD COLL",
    label: "MA - CERT OF TITLE-RECONSTRCTD COLL",
    color: "#FF681F",
  },
  {
    id: "NY - MV907A-FLOOD SALVAGE (P)",
    label: "NY - MV907A-FLOOD SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "NY - MV907A-FLOOD SALVAGE",
    label: "NY - MV907A-FLOOD SALVAGE",
    color: "#FF681F",
  },
  { id: "Flood (Mississippi)", label: "Flood (Mississippi)", color: "#FF681F" },
  {
    id: "ID - DEALER ONLY CLEAN TITLE (P)",
    label: "ID - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "ID - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    label: "ID - DLR/DIS/EXP-CT OTHERS-CA ACQ",
    color: "#FF681F",
  },
  {
    id: "Rebuilt (Mississippi)",
    label: "Rebuilt (Mississippi)",
    color: "#FF681F",
  },
  {
    id: "CA - LIEN PAPERS-CLEAN OR AC",
    label: "CA - LIEN PAPERS-CLEAN OR AC",
    color: "#FF681F",
  },
  {
    id: "MS - CERTIFICATE OF TITLE",
    label: "MS - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "NV - CERTIFICATE OF TITLE",
    label: "NV - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "FL - CERTIFICATE OF TITLE",
    label: "FL - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "GA - CERT OF TITLE-REBUILT SALVAGE",
    label: "GA - CERT OF TITLE-REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "Clear-Dealer Only (Arkansas)",
    label: "Clear-Dealer Only (Arkansas)",
    color: "#008000",
  },
  {
    id: "WV - SALVAGE CERT - FLOOD DAMAGED",
    label: "WV - SALVAGE CERT - FLOOD DAMAGED",
    color: "#FF681F",
  },
  {
    id: "Non-Repairable (Kansas)",
    label: "Non-Repairable (Kansas)",
    color: "#FF0000",
  },
  {
    id: "SC - CERT OF TITLE-SALVAGE REBUILT",
    label: "SC - CERT OF TITLE-SALVAGE REBUILT",
    color: "#FF681F",
  },
  {
    id: "CO - CERT OF TITLE-REBUILT SALVAGE",
    label: "CO - CERT OF TITLE-REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "Clear (Pennsylvania)",
    label: "Clear (Pennsylvania)",
    color: "#FF681F",
  },
  {
    id: "VT - CERTIFICATE OF TITLE (P)",
    label: "VT - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "RI - SALVAGE CERTIFICATE OF TITLE",
    label: "RI - SALVAGE CERTIFICATE OF TITLE",
    color: "#008000",
  },
  {
    id: "OK - CERT OF TITLE-REBUILT (P)",
    label: "OK - CERT OF TITLE-REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "IL - SALVAGE CERT-FLOOD",
    label: "IL - SALVAGE CERT-FLOOD",
    color: "#FF681F",
  },
  {
    id: "Enterprise Vehicles Clear Only (North Carolina)",
    label: "Enterprise Vehicles Clear Only (North Carolina)",
    color: "#FF681F",
  },
  {
    id: "TX - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "TX - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "DC - CERTIFICATE OF TITLE",
    label: "DC - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "TN - CERTIFICATE OF TITLE",
    label: "TN - CERTIFICATE OF TITLE",
    color: "#008000",
  },
  { id: "Clear (Minnesota)", label: "Clear (Minnesota)", color: "#FF681F" },
  {
    id: "CA - APP FOR DUP CLEAN OR AC",
    label: "CA - APP FOR DUP CLEAN OR AC",
    color: "#FF681F",
  },
  {
    id: "Clear-Dealer Only (Minnesota)",
    label: "Clear-Dealer Only (Minnesota)",
    color: "#008000",
  },
  {
    id: "Enterprise Vehicles Clear Only (Arkansas)",
    label: "Enterprise Vehicles Clear Only (Arkansas)",
    color: "#FF681F",
  },
  {
    id: "MT - CERTIFICATE OF TITLE",
    label: "MT - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "Ohv Regular (Nevada)",
    label: "Ohv Regular (Nevada)",
    color: "#FF681F",
  },
  {
    id: "Boat Registration Certificate (Mississippi)",
    label: "Boat Registration Certificate (Mississippi)",
    color: "#FF681F",
  },
  {
    id: "Clear - Public Restricted (Oklahoma)",
    label: "Clear - Public Restricted (Oklahoma)",
    color: "#FF681F",
  },
  {
    id: "MN - CERTIFICATE OF TITLE",
    label: "MN - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "Clear-Dealer Only (Alaska)",
    label: "Clear-Dealer Only (Alaska)",
    color: "#008000",
  },
  {
    id: "OK - DEALER ONLY CLEAN TITLE",
    label: "OK - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "OH - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "OH - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "FL - CERT OF TTL-REBUILT&SLVG RBLD (P)",
    label: "FL - CERT OF TTL-REBUILT&SLVG RBLD (P)",
    color: "#FF681F",
  },
  {
    id: "IL - CERT OF TITLE-REBUILT (P)",
    label: "IL - CERT OF TITLE-REBUILT (P)",
    color: "#FF681F",
  },
  {
    id: "NC - NON PUBLIC CLEAN TITLE",
    label: "NC - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "AZ - DLR/DIS/EXP-CT OTHERS-CA ACQUI",
    label: "AZ - DLR/DIS/EXP-CT OTHERS-CA ACQUI",
    color: "#FF681F",
  },
  {
    id: "NJ - DLR/DIS/EXP-CT OTHERS-ACQ",
    label: "NJ - DLR/DIS/EXP-CT OTHERS-ACQ",
    color: "#FF681F",
  },
  {
    id: "GA - CLEAN TITLE WITH THEFT HISTORY",
    label: "GA - CLEAN TITLE WITH THEFT HISTORY",
    color: "#FF681F",
  },
  {
    id: "NV - SALVAGE TITLE-FLOOD DAMAGE",
    label: "NV - SALVAGE TITLE-FLOOD DAMAGE",
    color: "#FF681F",
  },
  {
    id: "NM - CERTIFICATE OF TITLE",
    label: "NM - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "VA - DLR ONLY CLEAN OVER 25% (P)",
    label: "VA - DLR ONLY CLEAN OVER 25% (P)",
    color: "#FF681F",
  },
  {
    id: "KS - CERTIFICATE OF TITLE",
    label: "KS - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "NH - CERTIFICATE OF TITLE (P)",
    label: "NH - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "AR - CERTIFICATE OF TITLE",
    label: "AR - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "NJ - CERT OF TITLE-SALVAGE FLOOD",
    label: "NJ - CERT OF TITLE-SALVAGE FLOOD",
    color: "#FF681F",
  },
  {
    id: "AR - CT CLEAN TITLE PUBLIC ELIG.",
    label: "AR - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "WV - CERTIFICATE OF TITLE",
    label: "WV - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "GA - CERTIFICATE OF TITLE (P)",
    label: "GA - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "Regular (New Mexico)",
    label: "Regular (New Mexico)",
    color: "#FF681F",
  },
  {
    id: "MA - CERTIFICATE OF TITLE (P)",
    label: "MA - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "MD - DEALER ONLY CLEAN TITLE",
    label: "MD - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "SC - NON PUBLIC CLEAN TITLE",
    label: "SC - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "AL - DEALER ONLY CLEAN TITLE (P)",
    label: "AL - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "NJ - DEALER ONLY CLEAN TITLE",
    label: "NJ - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "CT - CERTIFICATE OF TITLE",
    label: "CT - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "NJ - CERTIFICATE OF TITLE",
    label: "NJ - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "MI - CERT OF TITLE-REBUILT SALVAGE",
    label: "MI - CERT OF TITLE-REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "NJ - CERT OF TITLE-SALVAGE FLOOD (P)",
    label: "NJ - CERT OF TITLE-SALVAGE FLOOD (P)",
    color: "#FF681F",
  },
  { id: "NY - FLOOD SALVAGE", label: "NY - FLOOD SALVAGE", color: "#FF681F" },
  {
    id: "FL - CERT OF TITLE-FLOOD & REBUILT",
    label: "FL - CERT OF TITLE-FLOOD & REBUILT",
    color: "#FF681F",
  },
  {
    id: "CA - CERTIFICATE OF TITLE (P)",
    label: "CA - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "TX - CERTIFICATE OF TITLE (P)",
    label: "TX - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "FL - CERTIFICATE OF TITLE (P)",
    label: "FL - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "UT - CERTIFICATE OF TITLE",
    label: "UT - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "IA - CERTIFICATE OF TITLE",
    label: "IA - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "FL - DLR ONLY CLEAN TTL/EXCEEDS 25%",
    label: "FL - DLR ONLY CLEAN TTL/EXCEEDS 25%",
    color: "#FF681F",
  },
  {
    id: "CA - APP FOR DUP CLEAN OR AC (P)",
    label: "CA - APP FOR DUP CLEAN OR AC (P)",
    color: "#FF681F",
  },
  {
    id: "NY - CERTIFICATE OF TITLE (P)",
    label: "NY - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "AZ - CERTIFICATE OF TITLE",
    label: "AZ - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "ON - PERMIT IRREPAIRABLE (P)",
    label: "ON - PERMIT IRREPAIRABLE (P)",
    color: "#FF681F",
  },
  {
    id: "MO - SALVAGE CERTIFICATE OF TITLE",
    label: "MO - SALVAGE CERTIFICATE OF TITLE",
    color: "#008000",
  },
  { id: "Clear (Missouri)", label: "Clear (Missouri)", color: "#FF681F" },
  {
    id: "CT - CERT OF TITLE-REBUILT SALVAGE (P)",
    label: "CT - CERT OF TITLE-REBUILT SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "CT - CERT OF TITLE-REBUILT SALVAGE",
    label: "CT - CERT OF TITLE-REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "NJ - CERT OF TTL W/FLD SLVG HISTORY",
    label: "NJ - CERT OF TTL W/FLD SLVG HISTORY",
    color: "#FF681F",
  },
  {
    id: "NY - REBUILT SALV W/FLOOD HISTORY",
    label: "NY - REBUILT SALV W/FLOOD HISTORY",
    color: "#FF681F",
  },
  { id: "Clear (Texas)", label: "Clear (Texas)", color: "#FF681F" },
  { id: "Clear (Indiana)", label: "Clear (Indiana)", color: "#FF681F" },
  {
    id: "Clear (South Carolina)",
    label: "Clear (South Carolina)",
    color: "#FF681F",
  },
  {
    id: "CT - CERTIFICATE OF ORIGIN",
    label: "CT - CERTIFICATE OF ORIGIN",
    color: "#FF681F",
  },
  {
    id: "NV - SALVAGE TITLE-LEMON LAW",
    label: "NV - SALVAGE TITLE-LEMON LAW",
    color: "#FF681F",
  },
  { id: "Rebuilt (Indiana)", label: "Rebuilt (Indiana)", color: "#FF681F" },
  { id: "Clear (Colorado)", label: "Clear (Colorado)", color: "#FF681F" },
  { id: "Original (Ohio)", label: "Original (Ohio)", color: "#FF681F" },
  {
    id: "FL - CERT OF TITLE-SLVG REBLD FLOOD (P)",
    label: "FL - CERT OF TITLE-SLVG REBLD FLOOD (P)",
    color: "#FF681F",
  },
  {
    id: "ON - PERMIT REBUILT - UNFIT",
    label: "ON - PERMIT REBUILT - UNFIT",
    color: "#FF681F",
  },
  {
    id: "AZ - DEALER ONLY CLEAN TITLE",
    label: "AZ - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "CT - CERT OF TITLE-FLOOD SALVAGE",
    label: "CT - CERT OF TITLE-FLOOD SALVAGE",
    color: "#FF681F",
  },
  { id: "Clear (Tennessee)", label: "Clear (Tennessee)", color: "#FF681F" },
  {
    id: "WA - CERTIFICATE OF ORIGIN",
    label: "WA - CERTIFICATE OF ORIGIN",
    color: "#FF681F",
  },
  {
    id: "NE - DEALER ONLY CLEAN TITLE",
    label: "NE - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "FL - DEALER ONLY CLEAN TITLE",
    label: "FL - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "CO - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "CO - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "ID - CERT OF TITLE -REBUILT SALVAGE",
    label: "ID - CERT OF TITLE -REBUILT SALVAGE",
    color: "#FF681F",
  },
  {
    id: "AZ - DLR/DIS/EXP-CT OTHERS-CA ACQUI (P)",
    label: "AZ - DLR/DIS/EXP-CT OTHERS-CA ACQUI (P)",
    color: "#FF681F",
  },
  {
    id: "CA - DIS/DLR/EXP APP FOR DUP CLEAN",
    label: "CA - DIS/DLR/EXP APP FOR DUP CLEAN",
    color: "#FF681F",
  },
  {
    id: "MT - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "MT - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "WA - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "WA - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "WA - AFF IN LIEU OF TITLE - REBUILT",
    label: "WA - AFF IN LIEU OF TITLE - REBUILT",
    color: "#FF681F",
  },
  {
    id: "OR - DEALER ONLY CLEAN TITLE (P)",
    label: "OR - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  { id: "Clear (Illinois)", label: "Clear (Illinois)", color: "#FF681F" },
  {
    id: "HI - CERTIFICATE OF TITLE (P)",
    label: "HI - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "UT - NON-REPAIRABLE CERTIFICATE",
    label: "UT - NON-REPAIRABLE CERTIFICATE",
    color: "#FF0000",
  },
  { id: "Clear (Florida)", label: "Clear (Florida)", color: "#FF681F" },
  { id: "Clear (New York)", label: "Clear (New York)", color: "#FF681F" },
  {
    id: "MI - CERTIFICATE OF TITLE",
    label: "MI - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "MA - DIS/DLR/EXP ONLY CLEAN TITLE",
    label: "MA - DIS/DLR/EXP ONLY CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "NC - DEALER ONLY CLEAN TITLE",
    label: "NC - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "PA - CERT OF TITLE TO A BOAT",
    label: "PA - CERT OF TITLE TO A BOAT",
    color: "#FF681F",
  },
  {
    id: "AL - CERTIFICATE OF TITLE",
    label: "AL - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "On-Rebuilt (Ontario)",
    label: "On-Rebuilt (Ontario)",
    color: "#FF681F",
  },
  {
    id: "MS - DEALER ONLY CLEAN TITLE",
    label: "MS - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "Clear (District Of Columbia)",
    label: "Clear (District Of Columbia)",
    color: "#FF681F",
  },
  {
    id: "ND - CERTIFICATE OF TITLE FOR A VEH (P)",
    label: "ND - CERTIFICATE OF TITLE FOR A VEH (P)",
    color: "#FF681F",
  },
  {
    id: "Non-Repairable (New Mexico)",
    label: "Non-Repairable (New Mexico)",
    color: "#FF0000",
  },
  {
    id: "Ns-Rebuilt (Nova Scotia)",
    label: "Ns-Rebuilt (Nova Scotia)",
    color: "#FF681F",
  },
  {
    id: "IL - WATERCRAFT CERT OF TITLE",
    label: "IL - WATERCRAFT CERT OF TITLE",
    color: "#FF681F",
  },
  {
    id: "Salvage/Flood (Utah)",
    label: "Salvage/Flood (Utah)",
    color: "#FF681F",
  },
  {
    id: "TN - SALVAGE CERT-WATER DAMAGE",
    label: "TN - SALVAGE CERT-WATER DAMAGE",
    color: "#FF681F",
  },
  {
    id: "Nf-Non-Repairable (Newfoundland And Labrador)",
    label: "Nf-Non-Repairable (Newfoundland And Labrador)",
    color: "#FF0000",
  },
  {
    id: "App For Dup Salv Title - Dealer (California)",
    label: "App For Dup Salv Title - Dealer (California)",
    color: "#FF681F",
  },
  {
    id: "ID - SALVAGE CERTIFICATE OF TITLE (P)",
    label: "ID - SALVAGE CERTIFICATE OF TITLE (P)",
    color: "#008000",
  },
  {
    id: "NE - CERTIFICATE OF TITLE (P)",
    label: "NE - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "KY - CERTIFICATE OF TITLE",
    label: "KY - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  { id: "NB - REBUILT", label: "NB - REBUILT", color: "#FF681F" },
  {
    id: "NS - CERT OF REG - NON-REPAIRABLE",
    label: "NS - CERT OF REG - NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "MI - DEALER ONLY NON-REPAIRABLE",
    label: "MI - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "ON - PERMIT IRREPAIRABLE",
    label: "ON - PERMIT IRREPAIRABLE",
    color: "#FF681F",
  },
  {
    id: "TX - NONREPAIRABLE TITLE",
    label: "TX - NONREPAIRABLE TITLE",
    color: "#FF681F",
  },
  {
    id: "SC - CLEAN TITLE W/ SALVAGE HISTORY",
    label: "SC - CLEAN TITLE W/ SALVAGE HISTORY",
    color: "#FF681F",
  },
  {
    id: "Non-Repairable (Nevada)",
    label: "Non-Repairable (Nevada)",
    color: "#FF0000",
  },
  {
    id: "TX - NONREPAIRABLE TITLE-FLOOD",
    label: "TX - NONREPAIRABLE TITLE-FLOOD",
    color: "#FF681F",
  },
  {
    id: "LA - CERT OF TITLE-SALVAGE FLOOD",
    label: "LA - CERT OF TITLE-SALVAGE FLOOD",
    color: "#FF681F",
  },
  {
    id: "TN - NON-REPAIRABLE CERT-FLOOD",
    label: "TN - NON-REPAIRABLE CERT-FLOOD",
    color: "#FF0000",
  },
  {
    id: "NC - SALVAGE CERTIFICATE OF TITLE",
    label: "NC - SALVAGE CERTIFICATE OF TITLE",
    color: "#008000",
  },
  {
    id: "TN - NON-REPAIRABLE CERTIFICATE",
    label: "TN - NON-REPAIRABLE CERTIFICATE",
    color: "#FF0000",
  },
  {
    id: "CO - CT CLEAN TITLE PUBLIC ELIG.",
    label: "CO - CT CLEAN TITLE PUBLIC ELIG.",
    color: "#FF681F",
  },
  {
    id: "RI - SALVAGE CERTIFICATE OF TITLE (P)",
    label: "RI - SALVAGE CERTIFICATE OF TITLE (P)",
    color: "#008000",
  },
  {
    id: "Clear-Dealer Only (Ohio)",
    label: "Clear-Dealer Only (Ohio)",
    color: "#008000",
  },
  {
    id: "Clear - Tbo (Indiana)",
    label: "Clear - Tbo (Indiana)",
    color: "#FF681F",
  },
  {
    id: "OH - CERTIFICATE OF TITLE",
    label: "OH - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "CO - CERTIFICATE OF TITLE (P)",
    label: "CO - CERTIFICATE OF TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "IA - DEALER ONLY CLEAN TITLE (P)",
    label: "IA - DEALER ONLY CLEAN TITLE (P)",
    color: "#008000",
  },
  {
    id: "MN - DEALER ONLY CLEAN TITLE",
    label: "MN - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "IN - CERTIFICATE OF TITLE",
    label: "IN - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "CO - DEALER ONLY NON-REPAIRABLE",
    label: "CO - DEALER ONLY NON-REPAIRABLE",
    color: "#FF0000",
  },
  {
    id: "GA - CERT OF TITLE-FLOOD SALVAGE",
    label: "GA - CERT OF TITLE-FLOOD SALVAGE",
    color: "#FF681F",
  },
  { id: "Clear (Nevada)", label: "Clear (Nevada)", color: "#FF681F" },
  {
    id: "VA - CERTIFICATE OF TITLE",
    label: "VA - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "LA - NON PUBLIC CLEAN TITLE",
    label: "LA - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "TN - CERTIFICATE OF TITLE",
    label: "TN - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "PA - DEALER ONLY CLEAN TITLE",
    label: "PA - DEALER ONLY CLEAN TITLE",
    color: "#008000",
  },
  {
    id: "PA - NON PUBLIC CLEAN TITLE",
    label: "PA - NON PUBLIC CLEAN TITLE",
    color: "#FF681F",
  },
  {
    id: "SC - CERTIFICATE OF TITLE",
    label: "SC - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "UT - CERT OF TITLE-REBUILT/RESTORED (P)",
    label: "UT - CERT OF TITLE-REBUILT/RESTORED (P)",
    color: "#FF681F",
  },
  {
    id: "KY - CERT OF TITLE-SALVAGE WATER",
    label: "KY - CERT OF TITLE-SALVAGE WATER",
    color: "#FF681F",
  },
  {
    id: "GA - CERT OF TITLE-REBUILT FLOOD",
    label: "GA - CERT OF TITLE-REBUILT FLOOD",
    color: "#FF681F",
  },
  {
    id: "MN - CERT OF TITLE-SALVAGE FLOOD",
    label: "MN - CERT OF TITLE-SALVAGE FLOOD",
    color: "#FF681F",
  },
  {
    id: "Clear-Dealer Only (Montana)",
    label: "Clear-Dealer Only (Montana)",
    color: "#008000",
  },
  {
    id: "MS - CERT OF TITLE - FLOOD SALVAGE",
    label: "MS - CERT OF TITLE - FLOOD SALVAGE",
    color: "#FF681F",
  },
  {
    id: "WY - CERTIFICATE OF TITLE",
    label: "WY - CERTIFICATE OF TITLE",
    color: "#FF681F",
  },
  {
    id: "Mb-Rebuilt (Manitoba)",
    label: "Mb-Rebuilt (Manitoba)",
    color: "#FF681F",
  },
  {
    id: "TX - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    label: "TX - DIS/DLR/EXP ONLY CLEAN TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "CA - NON-REPAIRABLE VEHICLE CERT (P)",
    label: "CA - NON-REPAIRABLE VEHICLE CERT (P)",
    color: "#FF0000",
  },
  { id: "MA - BILL OF SALE (P)", label: "MA - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "Bill Of Sale (New Mexico)",
    label: "Bill Of Sale (New Mexico)",
    color: "#FF0000",
  },
  { id: "Other (New Jersey)", label: "Other (New Jersey)", color: "#FF0000" },
  {
    id: "RI - CERT OF TITLE-SALVG PARTS ONLY (P)",
    label: "RI - CERT OF TITLE-SALVG PARTS ONLY (P)",
    color: "#FF0000",
  },
  { id: "PARTS ONLY BOS - MD", label: "PARTS ONLY BOS - MD", color: "#FF0000" },
  { id: "Other (Wisconsin)", label: "Other (Wisconsin)", color: "#FF0000" },
  {
    id: "FL - ACQUISITION BOS - POST-SALE",
    label: "FL - ACQUISITION BOS - POST-SALE",
    color: "#FF0000",
  },
  { id: "FL - PARTS ONLY", label: "FL - PARTS ONLY", color: "#FF0000" },
  {
    id: "Bill Of Sale (Vermont)",
    label: "Bill Of Sale (Vermont)",
    color: "#FF0000",
  },
  { id: "None (ON)", label: "None (ON)", color: "#FF0000" },
  {
    id: "NB - BILL OF SALE NON-REPAIRABLE",
    label: "NB - BILL OF SALE NON-REPAIRABLE",
    color: "#FF0000",
  },
  { id: "Other (Pennsylvania)", label: "Other (Pennsylvania)", color: "#FF0000" },
  {
    id: "BILL OF SALE  -   NON MOTOR VEHICLE - CA",
    label: "BILL OF SALE  -   NON MOTOR VEHICLE - CA",
    color: "#FF0000",
  },
  { id: "Other (Kentucky)", label: "Other (Kentucky)", color: "#FF0000" },
  { id: "Other (West Virginia)", label: "Other (West Virginia)", color: "#FF0000" },
  { id: "BILL OF SALE - MN", label: "BILL OF SALE - MN", color: "#FF0000" },
  {
    id: "OR - WRECKER'S NOTICE (PARTS ONLY)",
    label: "OR - WRECKER'S NOTICE (PARTS ONLY)",
    color: "#FF0000",
  },
  {
    id: "NY - CERT OF TITLE-PARTS ONLY",
    label: "NY - CERT OF TITLE-PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "FL - CERTIFICATE OF DESTRUCTION (P)",
    label: "FL - CERTIFICATE OF DESTRUCTION (P)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Massachusetts)",
    label: "Bill Of Sale (Massachusetts)",
    color: "#FF0000",
  },
  { id: "Bill Of Sale (Kansas)", label: "Bill Of Sale (Kansas)", color: "#FF0000" },
  { id: "Other (Nebraska)", label: "Other (Nebraska)", color: "#FF0000" },
  { id: "LA - PERMIT TO SELL", label: "LA - PERMIT TO SELL", color: "#FF0000" },
  {
    id: "Affidavit In Lieu Of Title - Non-Public (Washington)",
    label: "Affidavit In Lieu Of Title - Non-Public (Washington)",
    color: "#FF0000",
  },
  {
    id: "Unregisterable Title (Parts Only Title) (North Carolina)",
    label: "Unregisterable Title (Parts Only Title) (North Carolina)",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - MS", label: "BILL OF SALE - MS", color: "#FF0000" },
  {
    id: "MA - CERT OF TITLE-PARTS ONLY SALVA",
    label: "MA - CERT OF TITLE-PARTS ONLY SALVA",
    color: "#FF0000",
  },
  {
    id: "In Pending Provider Review (Idaho)",
    label: "In Pending Provider Review (Idaho)",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - UT", label: "BILL OF SALE - UT", color: "#FF0000" },
  { id: "COURT ORDER - GA", label: "COURT ORDER - GA", color: "#FF0000" },
  { id: "BILL OF SALE - KS", label: "BILL OF SALE - KS", color: "#FF0000" },
  {
    id: "AL - APPLICATION FOR DUPLICATE TITL",
    label: "AL - APPLICATION FOR DUPLICATE TITL",
    color: "#FF0000",
  },
  { id: "HI - BILL OF SALE", label: "HI - BILL OF SALE", color: "#FF0000" },
  { id: "BILL OF SALE - NH", label: "BILL OF SALE - NH", color: "#FF0000" },
  {
    id: "WA - AFF OF LOSS/REL OF INTEREST (P)",
    label: "WA - AFF OF LOSS/REL OF INTEREST (P)",
    color: "#FF0000",
  },
  {
    id: "GARAGEMANS LIEN AFFIRMATION - NY",
    label: "GARAGEMANS LIEN AFFIRMATION - NY",
    color: "#FF0000",
  },
  { id: "Other (Nevada)", label: "Other (Nevada)", color: "#FF0000" },
  {
    id: "MI - SCRAP-BILL OF SALE",
    label: "MI - SCRAP-BILL OF SALE",
    color: "#FF0000",
  },
  {
    id: "NY - MV907A W/UNSATISFIED LIEN",
    label: "NY - MV907A W/UNSATISFIED LIEN",
    color: "#FF0000",
  },
  {
    id: "Other (South Carolina)",
    label: "Other (South Carolina)",
    color: "#FF0000",
  },
  {
    id: "TN - ABANDONMENT-CERT OF SALES (P)",
    label: "TN - ABANDONMENT-CERT OF SALES (P)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Nebraska)",
    label: "Bill Of Sale (Nebraska)",
    color: "#FF0000",
  },
  { id: "VA - BILL OF SALE (P)", label: "VA - BILL OF SALE (P)", color: "#FF0000" },
  { id: "Other (South Dakota)", label: "Other (South Dakota)", color: "#FF0000" },
  {
    id: "CA - LIEN PAPERS-SALVAGE OR AC (P)",
    label: "CA - LIEN PAPERS-SALVAGE OR AC (P)",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - IL", label: "BILL OF SALE - IL", color: "#FF0000" },
  { id: "Other (Illinois)", label: "Other (Illinois)", color: "#FF0000" },
  { id: "UT - undefined", label: "UT - undefined", color: "#FF0000" },
  { id: "CA - undefined", label: "CA - undefined", color: "#FF0000" },
  { id: "Other (Oklahoma)", label: "Other (Oklahoma)", color: "#FF0000" },
  { id: "Other (Hawaii)", label: "Other (Hawaii)", color: "#FF0000" },
  {
    id: "Bill Of Sale - Non-Auto (Maryland)",
    label: "Bill Of Sale - Non-Auto (Maryland)",
    color: "#FF0000",
  },
  { id: "TN - undefined", label: "TN - undefined", color: "#FF0000" },
  {
    id: "JUNKING CERTIFICATE - SD",
    label: "JUNKING CERTIFICATE - SD",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - KY", label: "BILL OF SALE - KY", color: "#FF0000" },
  { id: "BILL OF SALE - OH", label: "BILL OF SALE - OH", color: "#FF0000" },
  { id: "Other (Massachusetts)", label: "Other (Massachusetts)", color: "#FF0000" },
  { id: "JUNK RECEIPT - NC", label: "JUNK RECEIPT - NC", color: "#FF0000" },
  { id: "Other (Colorado)", label: "Other (Colorado)", color: "#FF0000" },
  {
    id: "Bill Of Sale Destruction Only - Salvage (Ohio)",
    label: "Bill Of Sale Destruction Only - Salvage (Ohio)",
    color: "#FF0000",
  },
  { id: "JUNK - WI", label: "JUNK - WI", color: "#FF0000" },
  { id: "Junk (Illinois)", label: "Junk (Illinois)", color: "#FF0000" },
  { id: "Other (Arizona)", label: "Other (Arizona)", color: "#FF0000" },
  { id: "BILL OF SALE - RI", label: "BILL OF SALE - RI", color: "#FF0000" },
  { id: "BILL OF SALE - SC", label: "BILL OF SALE - SC", color: "#FF0000" },
  { id: "BILL OF SALE - TX", label: "BILL OF SALE - TX", color: "#FF0000" },
  {
    id: "WA - AFFIDAVIT IN LIEU OF TITLE",
    label: "WA - AFFIDAVIT IN LIEU OF TITLE",
    color: "#FF0000",
  },
  { id: "Other (Tennessee)", label: "Other (Tennessee)", color: "#FF0000" },
  { id: "Court Order (Georgia)", label: "Court Order (Georgia)", color: "#FF0000" },
  { id: "Junk (Missouri)", label: "Junk (Missouri)", color: "#FF0000" },
  { id: "Parts Only (Hawaii)", label: "Parts Only (Hawaii)", color: "#FF0000" },
  { id: "BILL OF SALE - LA", label: "BILL OF SALE - LA", color: "#FF0000" },
  { id: "Other (New Mexico)", label: "Other (New Mexico)", color: "#FF0000" },
  {
    id: "Bill Of Sale (Wyoming)",
    label: "Bill Of Sale (Wyoming)",
    color: "#FF0000",
  },
  {
    id: "CO - BILL OF SALE-PARTS ONLY",
    label: "CO - BILL OF SALE-PARTS ONLY",
    color: "#FF0000",
  },
  { id: "TX - undefined", label: "TX - undefined", color: "#FF0000" },
  { id: "Other (Mississippi)", label: "Other (Mississippi)", color: "#FF0000" },
  { id: "Other (Kansas)", label: "Other (Kansas)", color: "#FF0000" },
  {
    id: "Bill Of Sale (Pennsylvania)",
    label: "Bill Of Sale (Pennsylvania)",
    color: "#FF0000",
  },
  { id: "Other (Maine)", label: "Other (Maine)", color: "#FF0000" },
  { id: "Other (Oregon)", label: "Other (Oregon)", color: "#FF0000" },
  {
    id: "WY - BILL OF SALE - PARTS ONLY",
    label: "WY - BILL OF SALE - PARTS ONLY",
    color: "#FF0000",
  },
  { id: "Other (Indiana)", label: "Other (Indiana)", color: "#FF0000" },
  {
    id: "Parts Only Bos (Maryland)",
    label: "Parts Only Bos (Maryland)",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - ID", label: "BILL OF SALE - ID", color: "#FF0000" },
  {
    id: "SC - NON-REBUILDABLE SALVAGE TITLE",
    label: "SC - NON-REBUILDABLE SALVAGE TITLE",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - NC", label: "BILL OF SALE - NC", color: "#FF0000" },
  {
    id: "Junking Certificate (Mississippi)",
    label: "Junking Certificate (Mississippi)",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - VA", label: "BILL OF SALE - VA", color: "#FF0000" },
  {
    id: "BILL OF SALE  -  PARTS ONLY - WA",
    label: "BILL OF SALE  -  PARTS ONLY - WA",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - FL", label: "BILL OF SALE - FL", color: "#FF0000" },
  {
    id: "Bos Undocumented Trailer (California)",
    label: "Bos Undocumented Trailer (California)",
    color: "#FF0000",
  },
  {
    id: "In Pending Provider Review (Indiana)",
    label: "In Pending Provider Review (Indiana)",
    color: "#FF0000",
  },
  { id: "Other (Virginia)", label: "Other (Virginia)", color: "#FF0000" },
  {
    id: "BILL OF SALE DESTRUCTION ONLY  -  SALVAGE - OH",
    label: "BILL OF SALE DESTRUCTION ONLY  -  SALVAGE - OH",
    color: "#FF0000",
  },
  {
    id: "Affidavit In Lieu Of Title (Connecticut)",
    label: "Affidavit In Lieu Of Title (Connecticut)",
    color: "#FF0000",
  },
  { id: "PARTS ONLY - NY", label: "PARTS ONLY - NY", color: "#FF0000" },
  { id: "VT - BILL OF SALE", label: "VT - BILL OF SALE", color: "#FF0000" },
  { id: "BILL OF SALE - NM", label: "BILL OF SALE - NM", color: "#FF0000" },
  { id: "Other (Arkansas)", label: "Other (Arkansas)", color: "#FF0000" },
  {
    id: "AR - CERT OF TITLE-PARTS ONLY",
    label: "AR - CERT OF TITLE-PARTS ONLY",
    color: "#FF0000",
  },
  { id: "Other (Alabama)", label: "Other (Alabama)", color: "#FF0000" },
  { id: "Bill Of Sale (Nevada)", label: "Bill Of Sale (Nevada)", color: "#FF0000" },
  { id: "BILL OF SALE - AK", label: "BILL OF SALE - AK", color: "#FF0000" },
  {
    id: "LA - PERMIT TO DISMANTLE (P)",
    label: "LA - PERMIT TO DISMANTLE (P)",
    color: "#FF0000",
  },
  { id: "Other (Ohio)", label: "Other (Ohio)", color: "#FF0000" },
  {
    id: "Bill Of Sale (New York)",
    label: "Bill Of Sale (New York)",
    color: "#FF0000",
  },
  {
    id: "NY - REGISTRATION DOCUMENT CARD (P)",
    label: "NY - REGISTRATION DOCUMENT CARD (P)",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - MO", label: "BILL OF SALE - MO", color: "#FF0000" },
  { id: "Mv - 51B (New York)", label: "Mv - 51B (New York)", color: "#FF0000" },
  {
    id: "IA - JUNKING CERTIFICATE",
    label: "IA - JUNKING CERTIFICATE",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Connecticut)",
    label: "Bill Of Sale (Connecticut)",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - NJ", label: "BILL OF SALE - NJ", color: "#FF0000" },
  { id: "BILL OF SALE - ME", label: "BILL OF SALE - ME", color: "#FF0000" },
  {
    id: "JUNKING CERTIFICATE - IA",
    label: "JUNKING CERTIFICATE - IA",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - PA", label: "BILL OF SALE - PA", color: "#FF0000" },
  { id: "MV  -  51B - NY", label: "MV  -  51B - NY", color: "#FF0000" },
  { id: "BILL OF SALE - SD", label: "BILL OF SALE - SD", color: "#FF0000" },
  {
    id: "Bill Of Sale (Alabama)",
    label: "Bill Of Sale (Alabama)",
    color: "#FF0000",
  },
  { id: "None (NS)", label: "None (NS)", color: "#FF0000" },
  { id: "AB - BOS - ACTIVE", label: "AB - BOS - ACTIVE", color: "#FF0000" },
  {
    id: "AK - BILL OF SALE- SALVAGE",
    label: "AK - BILL OF SALE- SALVAGE",
    color: "#FF0000",
  },
  {
    id: "Storage Lien Docs (Nebraska)",
    label: "Storage Lien Docs (Nebraska)",
    color: "#FF0000",
  },
  { id: "PARTS ONLY - AR", label: "PARTS ONLY - AR", color: "#FF0000" },
  { id: "BILL OF SALE - NV", label: "BILL OF SALE - NV", color: "#FF0000" },
  {
    id: "JUNKING CERTIFICATE - MS",
    label: "JUNKING CERTIFICATE - MS",
    color: "#FF0000",
  },
  {
    id: "BILL OF SALE  -  NON - AUTO - MD",
    label: "BILL OF SALE  -  NON - AUTO - MD",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - MD", label: "BILL OF SALE - MD", color: "#FF0000" },
  {
    id: "MA - CERT OF TITLE-PARTS ONLY SALVA (P)",
    label: "MA - CERT OF TITLE-PARTS ONLY SALVA (P)",
    color: "#FF0000",
  },
  {
    id: "AL - CERT OF TITLE-FLOOD PARTS ONLY",
    label: "AL - CERT OF TITLE-FLOOD PARTS ONLY",
    color: "#FF0000",
  },
  { id: "ON - BILL OF SALE", label: "ON - BILL OF SALE", color: "#FF0000" },
  { id: "Bill Of Sale (Texas)", label: "Bill Of Sale (Texas)", color: "#FF0000" },
  {
    id: "CERTIFICATE OF DESTRUCTION - LA",
    label: "CERTIFICATE OF DESTRUCTION - LA",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Delaware)",
    label: "Bill Of Sale (Delaware)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Wisconsin)",
    label: "Bill Of Sale (Wisconsin)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale - Parts Only (Ohio)",
    label: "Bill Of Sale - Parts Only (Ohio)",
    color: "#FF0000",
  },
  { id: "undefined - undefined", label: "undefined - undefined", color: "#FF0000" },
  {
    id: "PARTS ONLY  -  BILL OF SALE - NC",
    label: "PARTS ONLY  -  BILL OF SALE - NC",
    color: "#FF0000",
  },
  {
    id: "Garagemans Affirmation And Bill Of Sale (New York)",
    label: "Garagemans Affirmation And Bill Of Sale (New York)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (California)",
    label: "Bill Of Sale (California)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Florida)",
    label: "Bill Of Sale (Florida)",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - CO", label: "BILL OF SALE - CO", color: "#FF0000" },
  {
    id: "Bill Of Sale (Missouri)",
    label: "Bill Of Sale (Missouri)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Illinois)",
    label: "Bill Of Sale (Illinois)",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - OR", label: "BILL OF SALE - OR", color: "#FF0000" },
  { id: "BILL OF SALE - NY", label: "BILL OF SALE - NY", color: "#FF0000" },
  { id: "BILL OF SALE - AZ", label: "BILL OF SALE - AZ", color: "#FF0000" },
  {
    id: "MN - PARTS VEHICLE BILL OF SALE",
    label: "MN - PARTS VEHICLE BILL OF SALE",
    color: "#FF0000",
  },
  {
    id: "WA - AFF OF LOSS/REL OF INTEREST",
    label: "WA - AFF OF LOSS/REL OF INTEREST",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - MA", label: "BILL OF SALE - MA", color: "#FF0000" },
  { id: "AB - BOS - ACTIVE (P)", label: "AB - BOS - ACTIVE (P)", color: "#FF0000" },
  {
    id: "Bill Of Sale - Parts Only (Washington)",
    label: "Bill Of Sale - Parts Only (Washington)",
    color: "#FF0000",
  },
  {
    id: "SALVAGE - PARTS ONLY - CT",
    label: "SALVAGE - PARTS ONLY - CT",
    color: "#FF0000",
  },
  {
    id: "AFFIDAVIT IN LIEU OF TITLE - WA",
    label: "AFFIDAVIT IN LIEU OF TITLE - WA",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - WY", label: "BILL OF SALE - WY", color: "#FF0000" },
  { id: "LIEN PAPERS - CA", label: "LIEN PAPERS - CA", color: "#FF0000" },
  {
    id: "MO - JUNKING CERTIFICATE (P)",
    label: "MO - JUNKING CERTIFICATE (P)",
    color: "#FF0000",
  },
  { id: "JUNK - NJ", label: "JUNK - NJ", color: "#FF0000" },
  { id: "JUNK - IL", label: "JUNK - IL", color: "#FF0000" },
  {
    id: "Bill Of Sale (Louisiana)",
    label: "Bill Of Sale (Louisiana)",
    color: "#FF0000",
  },
  { id: "PERMIT TO SELL - LA", label: "PERMIT TO SELL - LA", color: "#FF0000" },
  { id: "BILL OF SALE - IA", label: "BILL OF SALE - IA", color: "#FF0000" },
  { id: "BILL OF SALE - AL", label: "BILL OF SALE - AL", color: "#FF0000" },
  { id: "Parts Only (Arkansas)", label: "Parts Only (Arkansas)", color: "#FF0000" },
  { id: "GU - BILL OF SALE", label: "GU - BILL OF SALE", color: "#FF0000" },
  { id: "BILL OF SALE X2 - WA", label: "BILL OF SALE X2 - WA", color: "#FF0000" },
  { id: "BILL OF SALE - DE", label: "BILL OF SALE - DE", color: "#FF0000" },
  { id: "None (QC)", label: "None (QC)", color: "#FF0000" },
  {
    id: "REPLACE YOUR RIDE (PARTS ONLY) - VT",
    label: "REPLACE YOUR RIDE (PARTS ONLY) - VT",
    color: "#FF0000",
  },
  {
    id: "AFFIDAVIT IN LIEU OF TITLE  -  NON - PUBLIC - WA",
    label: "AFFIDAVIT IN LIEU OF TITLE  -  NON - PUBLIC - WA",
    color: "#FF0000",
  },
  {
    id: "IL - JUNKING CERT OF A VEHICLE",
    label: "IL - JUNKING CERT OF A VEHICLE",
    color: "#FF0000",
  },
  { id: "WA - BILL OF SALE (P)", label: "WA - BILL OF SALE (P)", color: "#FF0000" },
  { id: "SCRAP - AL", label: "SCRAP - AL", color: "#FF0000" },
  { id: "BILL OF SALE - AR", label: "BILL OF SALE - AR", color: "#FF0000" },
  { id: "FOR JUNK ONLY - ID", label: "FOR JUNK ONLY - ID", color: "#FF0000" },
  { id: "KY - undefined", label: "KY - undefined", color: "#FF0000" },
  { id: "Other (Texas)", label: "Other (Texas)", color: "#FF0000" },
  { id: "MD - undefined", label: "MD - undefined", color: "#FF0000" },
  { id: "AB - OOP - ACTIVE", label: "AB - OOP - ACTIVE", color: "#FF0000" },
  {
    id: "NC - DLR ONLY BILL OF SALE (P)",
    label: "NC - DLR ONLY BILL OF SALE (P)",
    color: "#FF0000",
  },
  {
    id: "NC - UNREGISTERABLE CERT OF TITLE",
    label: "NC - UNREGISTERABLE CERT OF TITLE",
    color: "#FF0000",
  },
  { id: "JUNK - MO", label: "JUNK - MO", color: "#FF0000" },
  {
    id: "ON - PERMIT NO BRAND - UNFIT (P)",
    label: "ON - PERMIT NO BRAND - UNFIT (P)",
    color: "#FF0000",
  },
  {
    id: "In Pending Provider Review (Florida)",
    label: "In Pending Provider Review (Florida)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Colorado)",
    label: "Bill Of Sale (Colorado)",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - NE", label: "BILL OF SALE - NE", color: "#FF0000" },
  {
    id: "AK - PARTS ONLY BILL OF SALE",
    label: "AK - PARTS ONLY BILL OF SALE",
    color: "#FF0000",
  },
  { id: "LIEN PAPERS - TX", label: "LIEN PAPERS - TX", color: "#FF0000" },
  { id: "LIEN PAPERS - OR", label: "LIEN PAPERS - OR", color: "#FF0000" },
  { id: "LA - undefined", label: "LA - undefined", color: "#FF0000" },
  {
    id: "GA - BILL OF SALE - PARTS ONLY (P)",
    label: "GA - BILL OF SALE - PARTS ONLY (P)",
    color: "#FF0000",
  },
  { id: "Other (Minnesota)", label: "Other (Minnesota)", color: "#FF0000" },
  { id: "Other (Georgia)", label: "Other (Georgia)", color: "#FF0000" },
  { id: "Other (North Dakota)", label: "Other (North Dakota)", color: "#FF0000" },
  { id: "BILL OF SALE - WI", label: "BILL OF SALE - WI", color: "#FF0000" },
  { id: "Other (Michigan)", label: "Other (Michigan)", color: "#FF0000" },
  { id: "Other (Utah)", label: "Other (Utah)", color: "#FF0000" },
  {
    id: "Bill Of Sale (Arkansas)",
    label: "Bill Of Sale (Arkansas)",
    color: "#FF0000",
  },
  { id: "Dismantle (Arizona)", label: "Dismantle (Arizona)", color: "#FF0000" },
  { id: "SC - BILL OF SALE (P)", label: "SC - BILL OF SALE (P)", color: "#FF0000" },
  { id: "OR - BILL OF SALE", label: "OR - BILL OF SALE", color: "#FF0000" },
  {
    id: "Bill Of Sale (Arizona)",
    label: "Bill Of Sale (Arizona)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Virginia)",
    label: "Bill Of Sale (Virginia)",
    color: "#FF0000",
  },
  { id: "Other (Louisiana)", label: "Other (Louisiana)", color: "#FF0000" },
  {
    id: "MD - PARTS ONLY-NO TITLE LETTER",
    label: "MD - PARTS ONLY-NO TITLE LETTER",
    color: "#FF0000",
  },
  {
    id: "In Pending Provider Review (Minnesota)",
    label: "In Pending Provider Review (Minnesota)",
    color: "#FF0000",
  },
  { id: "Other (Delaware)", label: "Other (Delaware)", color: "#FF0000" },
  {
    id: "Junking Certificate (Iowa)",
    label: "Junking Certificate (Iowa)",
    color: "#FF0000",
  },
  { id: "NJ - PARTS ONLY", label: "NJ - PARTS ONLY", color: "#FF0000" },
  {
    id: "CO - BILL OF SALE-PARTS ONLY (P)",
    label: "CO - BILL OF SALE-PARTS ONLY (P)",
    color: "#FF0000",
  },
  { id: "PARTS ONLY - GA", label: "PARTS ONLY - GA", color: "#FF0000" },
  {
    id: "GA - BILL OF SALE - PARTS ONLY",
    label: "GA - BILL OF SALE - PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "In Pending Provider Review (Illinois)",
    label: "In Pending Provider Review (Illinois)",
    color: "#FF0000",
  },
  {
    id: "AK - CERT OF VEH TITLE-JUNK",
    label: "AK - CERT OF VEH TITLE-JUNK",
    color: "#FF0000",
  },
  {
    id: "In Pending Provider Review (Delaware)",
    label: "In Pending Provider Review (Delaware)",
    color: "#FF0000",
  },
  { id: "SC - BILL OF SALE", label: "SC - BILL OF SALE", color: "#FF0000" },
  { id: "BILL OF SALE - TN", label: "BILL OF SALE - TN", color: "#FF0000" },
  { id: "NC - BILL OF SALE", label: "NC - BILL OF SALE", color: "#FF0000" },
  { id: "For Junk Only (Idaho)", label: "For Junk Only (Idaho)", color: "#FF0000" },
  { id: "ACQ BOS - CA", label: "ACQ BOS - CA", color: "#FF0000" },
  { id: "OH - BILL OF SALE", label: "OH - BILL OF SALE", color: "#FF0000" },
  { id: "AL - BILL OF SALE", label: "AL - BILL OF SALE", color: "#FF0000" },
  {
    id: "In Pending Provider Review (Vermont)",
    label: "In Pending Provider Review (Vermont)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Rhode Island)",
    label: "Bill Of Sale (Rhode Island)",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - OK", label: "BILL OF SALE - OK", color: "#FF0000" },
  { id: "None (BC)", label: "None (BC)", color: "#FF0000" },
  {
    id: "APP FOR DUP SALV CERT - CA",
    label: "APP FOR DUP SALV CERT - CA",
    color: "#FF0000",
  },
  { id: "Junk (California)", label: "Junk (California)", color: "#FF0000" },
  { id: "FL - PARTS ONLY (P)", label: "FL - PARTS ONLY (P)", color: "#FF0000" },
  {
    id: "Bill Of Sale (Indiana)",
    label: "Bill Of Sale (Indiana)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Tennessee)",
    label: "Bill Of Sale (Tennessee)",
    color: "#FF0000",
  },
  { id: "Other (New York)", label: "Other (New York)", color: "#FF0000" },
  { id: "Other (California)", label: "Other (California)", color: "#FF0000" },
  { id: "Other (Maryland)", label: "Other (Maryland)", color: "#FF0000" },
  {
    id: "Other (North Carolina)",
    label: "Other (North Carolina)",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - MI", label: "BILL OF SALE - MI", color: "#FF0000" },
  { id: "Other (Florida)", label: "Other (Florida)", color: "#FF0000" },
  { id: "Other (Iowa)", label: "Other (Iowa)", color: "#FF0000" },
  {
    id: "MA - CERT OF TITLE-SALVG PARTS ONLY",
    label: "MA - CERT OF TITLE-SALVG PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "Unrebuildable Title (Kentucky)",
    label: "Unrebuildable Title (Kentucky)",
    color: "#FF0000",
  },
  {
    id: "WI - JUNKED VEHICLE BILL OF SALE",
    label: "WI - JUNKED VEHICLE BILL OF SALE",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - IN", label: "BILL OF SALE - IN", color: "#FF0000" },
  { id: "MS - BILL OF SALE (P)", label: "MS - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "GA - DERELICT BOS/PARTS ONLY",
    label: "GA - DERELICT BOS/PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "ON - PERMIT NO BRAND - UNFIT",
    label: "ON - PERMIT NO BRAND - UNFIT",
    color: "#FF0000",
  },
  {
    id: "MD - BOAT BILL OF SALE",
    label: "MD - BOAT BILL OF SALE",
    color: "#FF0000",
  },
  { id: "LA - BILL OF SALE (P)", label: "LA - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "TN - CERT TO OBTAIN - PARTS ONLY",
    label: "TN - CERT TO OBTAIN - PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "KY - BILL OF SALE/PART ONLY/NO TITL",
    label: "KY - BILL OF SALE/PART ONLY/NO TITL",
    color: "#FF0000",
  },
  {
    id: "App For Dup Salv Cert (California)",
    label: "App For Dup Salv Cert (California)",
    color: "#FF0000",
  },
  { id: "NM - BILL OF SALE", label: "NM - BILL OF SALE", color: "#FF0000" },
  {
    id: "IA - AFFIDAVIT OF UNREGISTERED",
    label: "IA - AFFIDAVIT OF UNREGISTERED",
    color: "#FF0000",
  },
  {
    id: "LA - CERTIFICATE OF DESTRUCTION (P)",
    label: "LA - CERTIFICATE OF DESTRUCTION (P)",
    color: "#FF0000",
  },
  {
    id: "LA - PERMIT TO DISMANTLE",
    label: "LA - PERMIT TO DISMANTLE",
    color: "#FF0000",
  },
  { id: "OH - BILL OF SALE (P)", label: "OH - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "MO - JUNKING CERTIFICATE",
    label: "MO - JUNKING CERTIFICATE",
    color: "#FF0000",
  },
  {
    id: "LA - CERTIFICATE OF DESTRUCTION",
    label: "LA - CERTIFICATE OF DESTRUCTION",
    color: "#FF0000",
  },
  {
    id: "ID - CERT OF TITLE-JUNK (P)",
    label: "ID - CERT OF TITLE-JUNK (P)",
    color: "#FF0000",
  },
  {
    id: "Us-Parts Only (Michigan)",
    label: "Us-Parts Only (Michigan)",
    color: "#FF0000",
  },
  {
    id: "RI - CERT OF TITLE-SALVG PARTS ONLY",
    label: "RI - CERT OF TITLE-SALVG PARTS ONLY",
    color: "#FF0000",
  },
  { id: "WA - BILL OF SALE", label: "WA - BILL OF SALE", color: "#FF0000" },
  {
    id: "Mb-Write Off (Other) (Manitoba)",
    label: "Mb-Write Off (Other) (Manitoba)",
    color: "#FF0000",
  },
  {
    id: "WI - JUNKED VEHICLE BILL OF SALE (P)",
    label: "WI - JUNKED VEHICLE BILL OF SALE (P)",
    color: "#FF0000",
  },
  {
    id: "Coast Guard Bill Of Sale (Florida)",
    label: "Coast Guard Bill Of Sale (Florida)",
    color: "#FF0000",
  },
  {
    id: "AK - BILL OF SALE-JUNK",
    label: "AK - BILL OF SALE-JUNK",
    color: "#FF0000",
  },
  {
    id: "Dismantling Permit (Utah)",
    label: "Dismantling Permit (Utah)",
    color: "#FF0000",
  },
  {
    id: "Dismantler Permit (Oregon)",
    label: "Dismantler Permit (Oregon)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Montana)",
    label: "Bill Of Sale (Montana)",
    color: "#FF0000",
  },
  {
    id: "MS - CERTIFICATE OF TITLE - JUNK",
    label: "MS - CERTIFICATE OF TITLE - JUNK",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (New Jersey)",
    label: "Bill Of Sale (New Jersey)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Maryland)",
    label: "Bill Of Sale (Maryland)",
    color: "#FF0000",
  },
  {
    id: "Abandonment Paperwork (North Carolina)",
    label: "Abandonment Paperwork (North Carolina)",
    color: "#FF0000",
  },
  {
    id: "Affidavit In Lieu Of Title (Washington)",
    label: "Affidavit In Lieu Of Title (Washington)",
    color: "#FF0000",
  },
  { id: "IN - BILL OF SALE", label: "IN - BILL OF SALE", color: "#FF0000" },
  {
    id: "GA - DLR ONLY BOS -  PARTS ONLY",
    label: "GA - DLR ONLY BOS -  PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "FL - DERELICT VEHICLE CERTIFICATE (P)",
    label: "FL - DERELICT VEHICLE CERTIFICATE (P)",
    color: "#FF0000",
  },
  {
    id: "In Pending Provider Review (West Virginia)",
    label: "In Pending Provider Review (West Virginia)",
    color: "#FF0000",
  },
  { id: "OK - BILL OF SALE", label: "OK - BILL OF SALE", color: "#FF0000" },
  { id: "ID - BILL OF SALE", label: "ID - BILL OF SALE", color: "#FF0000" },
  { id: "AK - BILL OF SALE", label: "AK - BILL OF SALE", color: "#FF0000" },
  { id: "DE - BILL OF SALE", label: "DE - BILL OF SALE", color: "#FF0000" },
  {
    id: "IA - APP TO TRANSFER TO DEMOLISH",
    label: "IA - APP TO TRANSFER TO DEMOLISH",
    color: "#FF0000",
  },
  { id: "NH - BILL OF SALE", label: "NH - BILL OF SALE", color: "#FF0000" },
  {
    id: "DE - PARTS ONLY - NO TITLE",
    label: "DE - PARTS ONLY - NO TITLE",
    color: "#FF0000",
  },
  {
    id: "AZ - CERT OF TITLE-DISMANTLE",
    label: "AZ - CERT OF TITLE-DISMANTLE",
    color: "#FF0000",
  },
  {
    id: "PA - MV-4IS INS APPL SLVG NO TITLE",
    label: "PA - MV-4IS INS APPL SLVG NO TITLE",
    color: "#FF0000",
  },
  { id: "ON - RIV IMPORT JUNK", label: "ON - RIV IMPORT JUNK", color: "#FF0000" },
  { id: "MD - BILL OF SALE", label: "MD - BILL OF SALE", color: "#FF0000" },
  { id: "NE - BILL OF SALE (P)", label: "NE - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "IL - JUNKING CERT OF A VEHICLE (P)",
    label: "IL - JUNKING CERT OF A VEHICLE (P)",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - CT", label: "BILL OF SALE - CT", color: "#FF0000" },
  {
    id: "In Pending Provider Review (Oregon)",
    label: "In Pending Provider Review (Oregon)",
    color: "#FF0000",
  },
  {
    id: "In Pending Provider Review (Nevada)",
    label: "In Pending Provider Review (Nevada)",
    color: "#FF0000",
  },
  { id: "Bill Of Sale (Idaho)", label: "Bill Of Sale (Idaho)", color: "#FF0000" },
  {
    id: "In Pending Provider Review (Texas)",
    label: "In Pending Provider Review (Texas)",
    color: "#FF0000",
  },
  { id: "AZ - BILL OF SALE", label: "AZ - BILL OF SALE", color: "#FF0000" },
  {
    id: "Storage Lien Docs (Indiana)",
    label: "Storage Lien Docs (Indiana)",
    color: "#FF0000",
  },
  {
    id: "Sk-Parts Only (Saskatchewan)",
    label: "Sk-Parts Only (Saskatchewan)",
    color: "#FF0000",
  },
  { id: "OK - BILL OF SALE (P)", label: "OK - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "OR - LIEN PAPERS SALVAGE (P)",
    label: "OR - LIEN PAPERS SALVAGE (P)",
    color: "#FF0000",
  },
  {
    id: "SD - CERT OF TITLE-JUNKING CERTIFIC",
    label: "SD - CERT OF TITLE-JUNKING CERTIFIC",
    color: "#FF0000",
  },
  {
    id: "NY - MV-907A DISMANTLERS",
    label: "NY - MV-907A DISMANTLERS",
    color: "#FF0000",
  },
  { id: "Acq Bos (California)", label: "Acq Bos (California)", color: "#FF0000" },
  {
    id: "Bill Of Sale (Georgia)",
    label: "Bill Of Sale (Georgia)",
    color: "#FF0000",
  },
  {
    id: "NE - BILL OF SALE-PARTS ONLY/SCRAP",
    label: "NE - BILL OF SALE-PARTS ONLY/SCRAP",
    color: "#FF0000",
  },
  { id: "WI - BILL OF SALE (P)", label: "WI - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "CA - CERT OF TITLE-PARTS ONLY",
    label: "CA - CERT OF TITLE-PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "Junking Certificate (South Dakota)",
    label: "Junking Certificate (South Dakota)",
    color: "#FF0000",
  },
  {
    id: "MI - DEALER ONLY BILL OF SALE",
    label: "MI - DEALER ONLY BILL OF SALE",
    color: "#FF0000",
  },
  {
    id: "TN - ABANDONMENT-CERT OF SALES",
    label: "TN - ABANDONMENT-CERT OF SALES",
    color: "#FF0000",
  },
  { id: "NJ - BILL OF SALE", label: "NJ - BILL OF SALE", color: "#FF0000" },
  {
    id: "IA - INSURER'S AFFIDAVIT",
    label: "IA - INSURER'S AFFIDAVIT",
    color: "#FF0000",
  },
  {
    id: "In Pending Provider Review (Kansas)",
    label: "In Pending Provider Review (Kansas)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (South Dakota)",
    label: "Bill Of Sale (South Dakota)",
    color: "#FF0000",
  },
  {
    id: "DC - DLR/DSM/EXP-CT OTHERS-ACQ",
    label: "DC - DLR/DSM/EXP-CT OTHERS-ACQ",
    color: "#FF0000",
  },
  { id: "WI - BILL OF SALE", label: "WI - BILL OF SALE", color: "#FF0000" },
  {
    id: "AL - BILL OF SALE - PARTS ONLY",
    label: "AL - BILL OF SALE - PARTS ONLY",
    color: "#FF0000",
  },
  { id: "CN - PARTS ONLY", label: "CN - PARTS ONLY", color: "#FF0000" },
  { id: "WV - BILL OF SALE (P)", label: "WV - BILL OF SALE (P)", color: "#FF0000" },
  { id: "AR - BILL OF SALE (P)", label: "AR - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "PA - ABANDONMENT DOCUMENTS",
    label: "PA - ABANDONMENT DOCUMENTS",
    color: "#FF0000",
  },
  {
    id: "Permit To Dismantle (Louisiana)",
    label: "Permit To Dismantle (Louisiana)",
    color: "#FF0000",
  },
  {
    id: "In Pending Provider Review (Wyoming)",
    label: "In Pending Provider Review (Wyoming)",
    color: "#FF0000",
  },
  {
    id: "CT - CERT OF TITLE-PARTS ONLY SALVA (P)",
    label: "CT - CERT OF TITLE-PARTS ONLY SALVA (P)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale X2 (Washington)",
    label: "Bill Of Sale X2 (Washington)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (North Dakota)",
    label: "Bill Of Sale (North Dakota)",
    color: "#FF0000",
  },
  { id: "Bill Of Sale (Utah)", label: "Bill Of Sale (Utah)", color: "#FF0000" },
  {
    id: "Regular - Junking (South Dakota)",
    label: "Regular - Junking (South Dakota)",
    color: "#FF0000",
  },
  {
    id: "Salvage-Parts Only (Connecticut)",
    label: "Salvage-Parts Only (Connecticut)",
    color: "#FF0000",
  },
  { id: "PA - BILL OF SALE (P)", label: "PA - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "PA - CERTIFICATE OF REGISTRATION (P)",
    label: "PA - CERTIFICATE OF REGISTRATION (P)",
    color: "#FF0000",
  },
  {
    id: "CN - DLR/DSM GET CT ALL OTHERS ACQ",
    label: "CN - DLR/DSM GET CT ALL OTHERS ACQ",
    color: "#FF0000",
  },
  {
    id: "In Pending Provider Review (Arizona)",
    label: "In Pending Provider Review (Arizona)",
    color: "#FF0000",
  },
  {
    id: "In Pending Provider Review (Pennsylvania)",
    label: "In Pending Provider Review (Pennsylvania)",
    color: "#FF0000",
  },
  {
    id: "OH - BILL OF SALE-PARTS ONLY",
    label: "OH - BILL OF SALE-PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "Abandonment Paperwork (Texas)",
    label: "Abandonment Paperwork (Texas)",
    color: "#FF0000",
  },
  { id: "ME - BILL OF SALE (P)", label: "ME - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "TX - STORAGE LIEN PAPERS",
    label: "TX - STORAGE LIEN PAPERS",
    color: "#FF0000",
  },
  {
    id: "CA - LIEN PAPERS-SALVAGE OR AC",
    label: "CA - LIEN PAPERS-SALVAGE OR AC",
    color: "#FF0000",
  },
  {
    id: "ABANDONMENT PAPERWORK - TN",
    label: "ABANDONMENT PAPERWORK - TN",
    color: "#FF0000",
  },
  {
    id: "ON - PERMIT NO BRAND - FIT (P)",
    label: "ON - PERMIT NO BRAND - FIT (P)",
    color: "#FF0000",
  },
  { id: "FL - BILL OF SALE (P)", label: "FL - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "NY - MV907A-PARTS ONLY (P)",
    label: "NY - MV907A-PARTS ONLY (P)",
    color: "#FF0000",
  },
  {
    id: "WA - AFFIDAVIT IN LIEU OF TITLE (P)",
    label: "WA - AFFIDAVIT IN LIEU OF TITLE (P)",
    color: "#FF0000",
  },
  {
    id: "CA - DIS/DLR/EXP ONLY LIEN PAPERS",
    label: "CA - DIS/DLR/EXP ONLY LIEN PAPERS",
    color: "#FF0000",
  },
  { id: "MT - BILL OF SALE", label: "MT - BILL OF SALE", color: "#FF0000" },
  {
    id: "CO - BILL OF SALE-SALVAGE",
    label: "CO - BILL OF SALE-SALVAGE",
    color: "#FF0000",
  },
  {
    id: "ND - PARTS VEHICLE BILL OF SALE",
    label: "ND - PARTS VEHICLE BILL OF SALE",
    color: "#FF0000",
  },
  {
    id: "LA - PERMIT TO SELL-SALVAGE VEHICLE (P)",
    label: "LA - PERMIT TO SELL-SALVAGE VEHICLE (P)",
    color: "#FF0000",
  },
  { id: "IN - BILL OF SALE (P)", label: "IN - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "CT - BILL OF SALE-FLOOD SALVAGE",
    label: "CT - BILL OF SALE-FLOOD SALVAGE",
    color: "#FF0000",
  },
  {
    id: "GU - BILL OF SALE - PARTS ONLY",
    label: "GU - BILL OF SALE - PARTS ONLY",
    color: "#FF0000",
  },
  { id: "NS - BILL OF SALE", label: "NS - BILL OF SALE", color: "#FF0000" },
  { id: "MN - BILL OF SALE (P)", label: "MN - BILL OF SALE (P)", color: "#FF0000" },
  { id: "CT - BILL OF SALE", label: "CT - BILL OF SALE", color: "#FF0000" },
  {
    id: "DISMANTLER PERMIT - OR",
    label: "DISMANTLER PERMIT - OR",
    color: "#FF0000",
  },
  { id: "FL - BILL OF SALE", label: "FL - BILL OF SALE", color: "#FF0000" },
  { id: "NV - JUNK CERTIFICATE", label: "NV - JUNK CERTIFICATE", color: "#FF0000" },
  {
    id: "NH - CERT OF TITLE-PARTS ONLY",
    label: "NH - CERT OF TITLE-PARTS ONLY",
    color: "#FF0000",
  },
  { id: "CT - BILL OF SALE (P)", label: "CT - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "NY - MV-907A DISMANTLERS (P)",
    label: "NY - MV-907A DISMANTLERS (P)",
    color: "#FF0000",
  },
  { id: "MO - BILL OF SALE (P)", label: "MO - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "CT - BILL OF SALE - PARTS ONLY",
    label: "CT - BILL OF SALE - PARTS ONLY",
    color: "#FF0000",
  },
  { id: "NV - BILL OF SALE", label: "NV - BILL OF SALE", color: "#FF0000" },
  {
    id: "NY - MV-907A DISM-UNSATISFIED LIEN",
    label: "NY - MV-907A DISM-UNSATISFIED LIEN",
    color: "#FF0000",
  },
  {
    id: "VT - CERT OF TITLE-PARTS ONLY SALVA",
    label: "VT - CERT OF TITLE-PARTS ONLY SALVA",
    color: "#FF0000",
  },
  {
    id: "CA - APP FOR DUP SALVAGE OR AC (P)",
    label: "CA - APP FOR DUP SALVAGE OR AC (P)",
    color: "#FF0000",
  },
  { id: "CA - JUNK RECEIPT", label: "CA - JUNK RECEIPT", color: "#FF0000" },
  { id: "CA - BILL OF SALE (P)", label: "CA - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "CT - AFFIDAVIT OF REPOSSESSION (P)",
    label: "CT - AFFIDAVIT OF REPOSSESSION (P)",
    color: "#FF0000",
  },
  {
    id: "CA - DIS/DLR/EXP ONLY BILL OF SALE",
    label: "CA - DIS/DLR/EXP ONLY BILL OF SALE",
    color: "#FF0000",
  },
  { id: "KY - BILL OF SALE (P)", label: "KY - BILL OF SALE (P)", color: "#FF0000" },
  { id: "AZ - BILL OF SALE (P)", label: "AZ - BILL OF SALE (P)", color: "#FF0000" },
  { id: "UT - BILL OF SALE", label: "UT - BILL OF SALE", color: "#FF0000" },
  { id: "IA - BILL OF SALE", label: "IA - BILL OF SALE", color: "#FF0000" },
  {
    id: "LA - PERMIT TO SELL (P)",
    label: "LA - PERMIT TO SELL (P)",
    color: "#FF0000",
  },
  { id: "NJ - BILL OF SALE (P)", label: "NJ - BILL OF SALE (P)", color: "#FF0000" },
  { id: "NH - BILL OF SALE (P)", label: "NH - BILL OF SALE (P)", color: "#FF0000" },
  { id: "KS - BILL OF SALE (P)", label: "KS - BILL OF SALE (P)", color: "#FF0000" },
  { id: "ND - BILL OF SALE", label: "ND - BILL OF SALE", color: "#FF0000" },
  { id: "WV - BILL OF SALE", label: "WV - BILL OF SALE", color: "#FF0000" },
  { id: "KS - BILL OF SALE", label: "KS - BILL OF SALE", color: "#FF0000" },
  { id: "NE - BILL OF SALE", label: "NE - BILL OF SALE", color: "#FF0000" },
  { id: "OR - BILL OF SALE (P)", label: "OR - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "GA - SALVAGE BILL OF SALE",
    label: "GA - SALVAGE BILL OF SALE",
    color: "#FF0000",
  },
  {
    id: "NC - DLR ONLY BILL OF SALE",
    label: "NC - DLR ONLY BILL OF SALE",
    color: "#FF0000",
  },
  {
    id: "ME - BILL OF SALE - PARTS ONLY (P)",
    label: "ME - BILL OF SALE - PARTS ONLY (P)",
    color: "#FF0000",
  },
  { id: "PR - PARTS ONLY", label: "PR - PARTS ONLY", color: "#FF0000" },
  { id: "RI - BILL OF SALE", label: "RI - BILL OF SALE", color: "#FF0000" },
  { id: "Parts Only (New York)", label: "Parts Only (New York)", color: "#FF0000" },
  {
    id: "Bill Of Sale (South Carolina)",
    label: "Bill Of Sale (South Carolina)",
    color: "#FF0000",
  },
  {
    id: "MT - BILL OF SALE- PARTS ONLY",
    label: "MT - BILL OF SALE- PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "HI - BILL OF SALE - PARTS ONLY (P)",
    label: "HI - BILL OF SALE - PARTS ONLY (P)",
    color: "#FF0000",
  },
  {
    id: "Nw-Parts Only (Northwest Territories)",
    label: "Nw-Parts Only (Northwest Territories)",
    color: "#FF0000",
  },
  {
    id: "BOS UNDOCUMENTED TRAILER - SC",
    label: "BOS UNDOCUMENTED TRAILER - SC",
    color: "#FF0000",
  },
  { id: "Scrap (Alabama)", label: "Scrap (Alabama)", color: "#FF0000" },
  {
    id: "NY - MV907A-PARTS ONLY W/LIENHOLDER (P)",
    label: "NY - MV907A-PARTS ONLY W/LIENHOLDER (P)",
    color: "#FF0000",
  },
  {
    id: "MI - TR52 - ABANDONMENT",
    label: "MI - TR52 - ABANDONMENT",
    color: "#FF0000",
  },
  {
    id: "In Pending Provider Review (Utah)",
    label: "In Pending Provider Review (Utah)",
    color: "#FF0000",
  },
  {
    id: "Junk Export Only (Illinois)",
    label: "Junk Export Only (Illinois)",
    color: "#FF0000",
  },
  {
    id: "ID - CERT OF TITLE-JUNK",
    label: "ID - CERT OF TITLE-JUNK",
    color: "#FF0000",
  },
  {
    id: "AL - CERT OF TITLE-PARTS ONLY SALVG (P)",
    label: "AL - CERT OF TITLE-PARTS ONLY SALVG (P)",
    color: "#FF0000",
  },
  { id: "Bill Of Sale (Maine)", label: "Bill Of Sale (Maine)", color: "#FF0000" },
  {
    id: "In Pending Provider Review (New Mexico)",
    label: "In Pending Provider Review (New Mexico)",
    color: "#FF0000",
  },
  {
    id: "FL - DLR ONLY CERT OF DESTRUCTION",
    label: "FL - DLR ONLY CERT OF DESTRUCTION",
    color: "#FF0000",
  },
  {
    id: "PERMIT TO DISMANTLE - LA",
    label: "PERMIT TO DISMANTLE - LA",
    color: "#FF0000",
  },
  {
    id: "Mechanic's Lien Affirmation (Illinois)",
    label: "Mechanic's Lien Affirmation (Illinois)",
    color: "#FF0000",
  },
  {
    id: "OH - BILL OF SALE-PARTS ONLY (P)",
    label: "OH - BILL OF SALE-PARTS ONLY (P)",
    color: "#FF0000",
  },
  { id: "Bill Of Sale (Oregon)", label: "Bill Of Sale (Oregon)", color: "#FF0000" },
  {
    id: "Bill Of Sale - Parts Only (Wisconsin)",
    label: "Bill Of Sale - Parts Only (Wisconsin)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (New Hampshire)",
    label: "Bill Of Sale (New Hampshire)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (West Virginia)",
    label: "Bill Of Sale (West Virginia)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Michigan)",
    label: "Bill Of Sale (Michigan)",
    color: "#FF0000",
  },
  { id: "Other", label: "Other", color: "#FF0000" },
  {
    id: "VT - CERT OF TITLE-PARTS ONLY SALVA (P)",
    label: "VT - CERT OF TITLE-PARTS ONLY SALVA (P)",
    color: "#FF0000",
  },
  { id: "LA - BILL OF SALE", label: "LA - BILL OF SALE", color: "#FF0000" },
  {
    id: "CA - DIS/DLR/EXP ONLY DISMANTLED",
    label: "CA - DIS/DLR/EXP ONLY DISMANTLED",
    color: "#FF0000",
  },
  {
    id: "FL - DLR ONLY CERT OF DESTRUCTION (P)",
    label: "FL - DLR ONLY CERT OF DESTRUCTION (P)",
    color: "#FF0000",
  },
  {
    id: "NY - REGISTRATION DOCUMENT CARD",
    label: "NY - REGISTRATION DOCUMENT CARD",
    color: "#FF0000",
  },
  { id: "NC - BILL OF SALE (P)", label: "NC - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "WA - BILL OF SALE-PARTS ONLY",
    label: "WA - BILL OF SALE-PARTS ONLY",
    color: "#FF0000",
  },
  { id: "CA - BILL OF SALE", label: "CA - BILL OF SALE", color: "#FF0000" },
  {
    id: "OR - SALVAGE BILL OF SALE",
    label: "OR - SALVAGE BILL OF SALE",
    color: "#FF0000",
  },
  { id: "ME - BILL OF SALE", label: "ME - BILL OF SALE", color: "#FF0000" },
  { id: "AL - BILL OF SALE (P)", label: "AL - BILL OF SALE (P)", color: "#FF0000" },
  { id: "IL - BILL OF SALE (P)", label: "IL - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "NY - AFFIRMATION OF REPOSSESSION",
    label: "NY - AFFIRMATION OF REPOSSESSION",
    color: "#FF0000",
  },
  { id: "MS - BILL OF SALE", label: "MS - BILL OF SALE", color: "#FF0000" },
  { id: "NV - BILL OF SALE (P)", label: "NV - BILL OF SALE (P)", color: "#FF0000" },
  { id: "MA - BILL OF SALE", label: "MA - BILL OF SALE", color: "#FF0000" },
  {
    id: "CT - AFFIDAVIT OF COMPLIANCE H-78",
    label: "CT - AFFIDAVIT OF COMPLIANCE H-78",
    color: "#FF0000",
  },
  { id: "MI - BILL OF SALE (P)", label: "MI - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "BILL OF SALE  -  PARTS ONLY - OH",
    label: "BILL OF SALE  -  PARTS ONLY - OH",
    color: "#FF0000",
  },
  {
    id: "MA - CERT OF TITLE-SALVG PARTS ONLY (P)",
    label: "MA - CERT OF TITLE-SALVG PARTS ONLY (P)",
    color: "#FF0000",
  },
  { id: "NY - BILL OF SALE", label: "NY - BILL OF SALE", color: "#FF0000" },
  { id: "Lien Papers (Texas)", label: "Lien Papers (Texas)", color: "#FF0000" },
  { id: "CO - BILL OF SALE (P)", label: "CO - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "Bill Of Sale (Mississippi)",
    label: "Bill Of Sale (Mississippi)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Kentucky)",
    label: "Bill Of Sale (Kentucky)",
    color: "#FF0000",
  },
  { id: "Junk (Minnesota)", label: "Junk (Minnesota)", color: "#FF0000" },
  {
    id: "Bc-Dismantle (British Columbia)",
    label: "Bc-Dismantle (British Columbia)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Washington)",
    label: "Bill Of Sale (Washington)",
    color: "#FF0000",
  },
  {
    id: "AL - CERT OF TITLE-PARTS ONLY SALVG",
    label: "AL - CERT OF TITLE-PARTS ONLY SALVG",
    color: "#FF0000",
  },
  { id: "IL - BILL OF SALE", label: "IL - BILL OF SALE", color: "#FF0000" },
  { id: "BILL OF SALE - CA", label: "BILL OF SALE - CA", color: "#FF0000" },
  { id: "Parts Only (Georgia)", label: "Parts Only (Georgia)", color: "#FF0000" },
  {
    id: "ABANDONMENT PAPERWORK - AL",
    label: "ABANDONMENT PAPERWORK - AL",
    color: "#FF0000",
  },
  { id: "Lien Papers (Oregon)", label: "Lien Papers (Oregon)", color: "#FF0000" },
  {
    id: "IN PENDING PROVIDER REVIEW - MN",
    label: "IN PENDING PROVIDER REVIEW - MN",
    color: "#FF0000",
  },
  { id: "VT - BILL OF SALE (P)", label: "VT - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "BILL OF SALE - PARTS ONLY - CT",
    label: "BILL OF SALE - PARTS ONLY - CT",
    color: "#FF0000",
  },
  {
    id: "COAST GUARD BILL OF SALE - FL",
    label: "COAST GUARD BILL OF SALE - FL",
    color: "#FF0000",
  },
  { id: "NH - undefined", label: "NH - undefined", color: "#FF0000" },
  {
    id: "In Pending Provider Review (California)",
    label: "In Pending Provider Review (California)",
    color: "#FF0000",
  },
  {
    id: "Bos Undocumented Trailer (South Carolina)",
    label: "Bos Undocumented Trailer (South Carolina)",
    color: "#FF0000",
  },
  {
    id: "CT - AFFIDAVIT OF COMPLIANCE H-78 (P)",
    label: "CT - AFFIDAVIT OF COMPLIANCE H-78 (P)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale (Minnesota)",
    label: "Bill Of Sale (Minnesota)",
    color: "#FF0000",
  },
  { id: "KS - JUNK TITLE", label: "KS - JUNK TITLE", color: "#FF0000" },
  { id: "ON - BILL OF SALE (P)", label: "ON - BILL OF SALE (P)", color: "#FF0000" },
  { id: "Junk (Wisconsin)", label: "Junk (Wisconsin)", color: "#FF0000" },
  {
    id: "IN - BILL OF SALE - PARTS ONLY",
    label: "IN - BILL OF SALE - PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "Abandonment Paperwork (Alabama)",
    label: "Abandonment Paperwork (Alabama)",
    color: "#FF0000",
  },
  {
    id: "NY - AFFIRMATION OF REPOSSESSION (P)",
    label: "NY - AFFIRMATION OF REPOSSESSION (P)",
    color: "#FF0000",
  },
  {
    id: "CA - DIS/DLR/EXP ONLY JUNK RECEIPT",
    label: "CA - DIS/DLR/EXP ONLY JUNK RECEIPT",
    color: "#FF0000",
  },
  { id: "TX - BILL OF SALE (P)", label: "TX - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "Parts Only - Bill Of Sale (North Carolina)",
    label: "Parts Only - Bill Of Sale (North Carolina)",
    color: "#FF0000",
  },
  {
    id: "CA - DIS/DLR/EXP LIEN PAPERS-SALV",
    label: "CA - DIS/DLR/EXP LIEN PAPERS-SALV",
    color: "#FF0000",
  },
  { id: "Bill Of Sale (Hawaii)", label: "Bill Of Sale (Hawaii)", color: "#FF0000" },
  { id: "MN - BILL OF SALE", label: "MN - BILL OF SALE", color: "#FF0000" },
  { id: "GA - BILL OF SALE", label: "GA - BILL OF SALE", color: "#FF0000" },
  {
    id: "KY - RED SALVAGE NON-REBUILDABLE (P)",
    label: "KY - RED SALVAGE NON-REBUILDABLE (P)",
    color: "#FF0000",
  },
  {
    id: "Certificate Of Destruction (Florida)",
    label: "Certificate Of Destruction (Florida)",
    color: "#FF0000",
  },
  { id: "Scrap (Michigan)", label: "Scrap (Michigan)", color: "#FF0000" },
  { id: "TN - BILL OF SALE", label: "TN - BILL OF SALE", color: "#FF0000" },
  { id: "GA - undefined", label: "GA - undefined", color: "#FF0000" },
  {
    id: "ON - PERMIT NO BRAND - FIT",
    label: "ON - PERMIT NO BRAND - FIT",
    color: "#FF0000",
  },
  {
    id: "AR - CERT OF TITLE-PARTS ONLY (P)",
    label: "AR - CERT OF TITLE-PARTS ONLY (P)",
    color: "#FF0000",
  },
  { id: "NY - BILL OF SALE (P)", label: "NY - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "LA - PERMIT TO SELL-SALVAGE&WTR DMG (P)",
    label: "LA - PERMIT TO SELL-SALVAGE&WTR DMG (P)",
    color: "#FF0000",
  },
  { id: "JUNK - MN", label: "JUNK - MN", color: "#FF0000" },
  {
    id: "Junk Receipt (North Carolina)",
    label: "Junk Receipt (North Carolina)",
    color: "#FF0000",
  },
  { id: "MA - undefined", label: "MA - undefined", color: "#FF0000" },
  {
    id: "BOS UNDOCUMENTED TRAILER - CA",
    label: "BOS UNDOCUMENTED TRAILER - CA",
    color: "#FF0000",
  },
  {
    id: "RI - BILL OF SALE - FLOOD HISTORY",
    label: "RI - BILL OF SALE - FLOOD HISTORY",
    color: "#FF0000",
  },
  {
    id: "AL - CERT OF TITLE-PARTS ONLY",
    label: "AL - CERT OF TITLE-PARTS ONLY",
    color: "#FF0000",
  },
  { id: "Junk (New Jersey)", label: "Junk (New Jersey)", color: "#FF0000" },
  {
    id: "CT - BILL OF SALE-SALVAGE",
    label: "CT - BILL OF SALE-SALVAGE",
    color: "#FF0000",
  },
  { id: "CO - BILL OF SALE", label: "CO - BILL OF SALE", color: "#FF0000" },
  { id: "NC - undefined", label: "NC - undefined", color: "#FF0000" },
  { id: "MO - BILL OF SALE", label: "MO - BILL OF SALE", color: "#FF0000" },
  {
    id: "CERTIFICATE OF DESTRUCTION - FL",
    label: "CERTIFICATE OF DESTRUCTION - FL",
    color: "#FF0000",
  },
  {
    id: "FL - DERELICT VEHICLE CERTIFICATE",
    label: "FL - DERELICT VEHICLE CERTIFICATE",
    color: "#FF0000",
  },
  { id: "None (AB)", label: "None (AB)", color: "#FF0000" },
  { id: "None (Ontario)", label: "None (Ontario)", color: "#FF0000" },
  {
    id: "VT - BILL OF SALE - PARTS ONLY",
    label: "VT - BILL OF SALE - PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "CT - CERT OF TITLE-PARTS ONLY SALVA",
    label: "CT - CERT OF TITLE-PARTS ONLY SALVA",
    color: "#FF0000",
  },
  { id: "Junk (Oklahoma)", label: "Junk (Oklahoma)", color: "#FF0000" },
  {
    id: "NY - MV907A-PARTS ONLY W/LIENHOLDER",
    label: "NY - MV907A-PARTS ONLY W/LIENHOLDER",
    color: "#FF0000",
  },
  {
    id: "LA - PERMIT TO SELL-WATER DAMAGED",
    label: "LA - PERMIT TO SELL-WATER DAMAGED",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale - Parts Only (Connecticut)",
    label: "Bill Of Sale - Parts Only (Connecticut)",
    color: "#FF0000",
  },
  {
    id: "SC - NON-REB & REM SALVAGE TITLE",
    label: "SC - NON-REB & REM SALVAGE TITLE",
    color: "#FF0000",
  },
  {
    id: "OK - CERTIFICATE OF TITLE-JUNKED (P)",
    label: "OK - CERTIFICATE OF TITLE-JUNKED (P)",
    color: "#FF0000",
  },
  { id: "AB - OOP - ACTIVE (P)", label: "AB - OOP - ACTIVE (P)", color: "#FF0000" },
  {
    id: "OK - CERTIFICATE OF TITLE-JUNKED",
    label: "OK - CERTIFICATE OF TITLE-JUNKED",
    color: "#FF0000",
  },
  { id: "Bill Of Sale (Iowa)", label: "Bill Of Sale (Iowa)", color: "#FF0000" },
  { id: "Other (Washington)", label: "Other (Washington)", color: "#FF0000" },
  {
    id: "Lien Papers (California)",
    label: "Lien Papers (California)",
    color: "#FF0000",
  },
  { id: "Bill Of Sale (Ohio)", label: "Bill Of Sale (Ohio)", color: "#FF0000" },
  {
    id: "Certificate Of Destruction (Louisiana)",
    label: "Certificate Of Destruction (Louisiana)",
    color: "#FF0000",
  },
  { id: "AB - OOP - SALVAGE", label: "AB - OOP - SALVAGE", color: "#FF0000" },
  {
    id: "CA - DIS/DLR/EXP APP FOR DUP SALVAG",
    label: "CA - DIS/DLR/EXP APP FOR DUP SALVAG",
    color: "#FF0000",
  },
  {
    id: "KY - BILL OF SALE/PART ONLY/NO TITL (P)",
    label: "KY - BILL OF SALE/PART ONLY/NO TITL (P)",
    color: "#FF0000",
  },
  {
    id: "Garagemans Lien Affirmation (New York)",
    label: "Garagemans Lien Affirmation (New York)",
    color: "#FF0000",
  },
  { id: "SCRAP - MI", label: "SCRAP - MI", color: "#FF0000" },
  { id: "NJ - PARTS ONLY (P)", label: "NJ - PARTS ONLY (P)", color: "#FF0000" },
  {
    id: "Permit To Sell (Louisiana)",
    label: "Permit To Sell (Louisiana)",
    color: "#FF0000",
  },
  {
    id: "AL - BILL OF SALE - ABANDONED",
    label: "AL - BILL OF SALE - ABANDONED",
    color: "#FF0000",
  },
  {
    id: "CA - ACQ BOS - POST SALE - SALVAGE (P)",
    label: "CA - ACQ BOS - POST SALE - SALVAGE (P)",
    color: "#FF0000",
  },
  { id: "OH - undefined", label: "OH - undefined", color: "#FF0000" },
  {
    id: "QC - BILL OF SALE - PARTS ONLY",
    label: "QC - BILL OF SALE - PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "VT - BILL OF SALE - PARTS ONLY (P)",
    label: "VT - BILL OF SALE - PARTS ONLY (P)",
    color: "#FF0000",
  },
  {
    id: "Repo Paperwork (New York)",
    label: "Repo Paperwork (New York)",
    color: "#FF0000",
  },
  {
    id: "NS - BILL OF SALE - PARTS ONLY",
    label: "NS - BILL OF SALE - PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "NY - MV907A-PARTS ONLY",
    label: "NY - MV907A-PARTS ONLY",
    color: "#FF0000",
  },
  { id: "WA - undefined", label: "WA - undefined", color: "#FF0000" },
  { id: "BILL OF SALE - GA", label: "BILL OF SALE - GA", color: "#FF0000" },
  { id: "VA - BILL OF SALE", label: "VA - BILL OF SALE", color: "#FF0000" },
  { id: "BILL OF SALE - MT", label: "BILL OF SALE - MT", color: "#FF0000" },
  {
    id: "Bill Of Sale (Oklahoma)",
    label: "Bill Of Sale (Oklahoma)",
    color: "#FF0000",
  },
  { id: "ID - undefined", label: "ID - undefined", color: "#FF0000" },
  { id: "WA - PARTS ONLY TITLE", label: "WA - PARTS ONLY TITLE", color: "#FF0000" },
  {
    id: "KY - CERT OF REG-JUNKED VEHICLE",
    label: "KY - CERT OF REG-JUNKED VEHICLE",
    color: "#FF0000",
  },
  { id: "PARTS ONLY BOS - MN", label: "PARTS ONLY BOS - MN", color: "#FF0000" },
  {
    id: "UNREGISTERABLE TITLE (PARTS ONLY TITLE) - NC",
    label: "UNREGISTERABLE TITLE (PARTS ONLY TITLE) - NC",
    color: "#FF0000",
  },
  {
    id: "MD - CERT OF SALVAGE-PARTS ONLY",
    label: "MD - CERT OF SALVAGE-PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "ON - BILL OF SALE - PARTS ONLY",
    label: "ON - BILL OF SALE - PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "Replace Your Ride (Parts Only) (Vermont)",
    label: "Replace Your Ride (Parts Only) (Vermont)",
    color: "#FF0000",
  },
  {
    id: "CT - AFFIDAVIT OF REPOSSESSION",
    label: "CT - AFFIDAVIT OF REPOSSESSION",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - ND", label: "BILL OF SALE - ND", color: "#FF0000" },
  {
    id: "HI - BILL OF SALE - PARTS ONLY",
    label: "HI - BILL OF SALE - PARTS ONLY",
    color: "#FF0000",
  },
  {
    id: "MD - CERT OF SALVAGE-PARTS ONLY (P)",
    label: "MD - CERT OF SALVAGE-PARTS ONLY (P)",
    color: "#FF0000",
  },
  {
    id: "In Pending Provider Review (Louisiana)",
    label: "In Pending Provider Review (Louisiana)",
    color: "#FF0000",
  },
  {
    id: "IL - JUNKING CERT-FLOOD",
    label: "IL - JUNKING CERT-FLOOD",
    color: "#FF0000",
  },
  { id: "BILL OF SALE - VT", label: "BILL OF SALE - VT", color: "#FF0000" },
  {
    id: "MO - BILL OF SALE - DESTRUCTION",
    label: "MO - BILL OF SALE - DESTRUCTION",
    color: "#FF0000",
  },
  { id: "MD - THEFT LETTER", label: "MD - THEFT LETTER", color: "#FF0000" },
  { id: "UT - BILL OF SALE (P)", label: "UT - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "Abandonment Paperwork (New Jersey)",
    label: "Abandonment Paperwork (New Jersey)",
    color: "#FF0000",
  },
  {
    id: "Bill Of Sale -  Non Motor Vehicle (California)",
    label: "Bill Of Sale -  Non Motor Vehicle (California)",
    color: "#FF0000",
  },
  {
    id: "KY - RED SALVAGE NON-REBUILDABLE",
    label: "KY - RED SALVAGE NON-REBUILDABLE",
    color: "#FF0000",
  },
  {
    id: "REGULAR  -  JUNKING - SD",
    label: "REGULAR  -  JUNKING - SD",
    color: "#FF0000",
  },
  {
    id: "ON - BILL OF SALE - PARTS ONLY (P)",
    label: "ON - BILL OF SALE - PARTS ONLY (P)",
    color: "#FF0000",
  },
  { id: "NJ - undefined", label: "NJ - undefined", color: "#FF0000" },
  { id: "CO - undefined", label: "CO - undefined", color: "#FF0000" },
  { id: "BILL OF SALE - WA", label: "BILL OF SALE - WA", color: "#FF0000" },
  {
    id: "Parts Only Bos (Minnesota)",
    label: "Parts Only Bos (Minnesota)",
    color: "#FF0000",
  },
  {
    id: "DISMANTLING PERMIT - UT",
    label: "DISMANTLING PERMIT - UT",
    color: "#FF0000",
  },
  { id: "AK - BILL OF SALE (P)", label: "AK - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "Bill Of Sale (North Carolina)",
    label: "Bill Of Sale (North Carolina)",
    color: "#FF0000",
  },
  { id: "PA - BILL OF SALE", label: "PA - BILL OF SALE", color: "#FF0000" },
  {
    id: "NC - PARTS ONLY-RECORD OF SALE",
    label: "NC - PARTS ONLY-RECORD OF SALE",
    color: "#FF0000",
  },
  { id: "GA - BILL OF SALE (P)", label: "GA - BILL OF SALE (P)", color: "#FF0000" },
  { id: "MI - BILL OF SALE", label: "MI - BILL OF SALE", color: "#FF0000" },
  {
    id: "RI - SALVAGE CERT-PARTS ONLY",
    label: "RI - SALVAGE CERT-PARTS ONLY",
    color: "#FF0000",
  },
  { id: "TN - BILL OF SALE (P)", label: "TN - BILL OF SALE (P)", color: "#FF0000" },
  {
    id: "FL - CERTIFICATE OF DESTRUCTION",
    label: "FL - CERTIFICATE OF DESTRUCTION",
    color: "#FF0000",
  },
  { id: "KY - BILL OF SALE", label: "KY - BILL OF SALE", color: "#FF0000" },
  { id: "BILL OF SALE - HI", label: "BILL OF SALE - HI", color: "#FF0000" },
  { id: "Bill Of Sale (Alaska)", label: "Bill Of Sale (Alaska)", color: "#FF0000" },
  { id: "REPO PAPERWORK - NY", label: "REPO PAPERWORK - NY", color: "#FF0000" },
  {
    id: "CO - PUBLIC - BILL OF SALE PARTS",
    label: "CO - PUBLIC - BILL OF SALE PARTS",
    color: "#FF0000",
  },
  {
    id: "BILL OF SALE  -  PARTS ONLY - WI",
    label: "BILL OF SALE  -  PARTS ONLY - WI",
    color: "#FF0000",
  },
  {
    id: "UT - DISMANTLING PERMIT",
    label: "UT - DISMANTLING PERMIT",
    color: "#FF0000",
  },
  { id: "TX - BILL OF SALE", label: "TX - BILL OF SALE", color: "#FF0000" },
  { id: "JUNK - CA", label: "JUNK - CA", color: "#FF0000" },
  { id: "AR - BILL OF SALE", label: "AR - BILL OF SALE", color: "#FF0000" },
  { id: "JUNK - OK", label: "JUNK - OK", color: "#FF0000" },
  {
    id: "TX - GOVERNMENT TITLE SALVAGE (P)",
    label: "TX - GOVERNMENT TITLE SALVAGE (P)",
    color: "#FF681F",
  },
  { id: "UT - ", label: "UT - ", color: "0000FF" },
  {
    id: "AL - HAIL SALVAGE (P)",
    label: "AL - HAIL SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "CANADIAN REGISTRATION - NY",
    label: "CANADIAN REGISTRATION - NY",
    color: "0000FF",
  },
  {
    id: "AZ - CERT OF TITLE - SALVAGE (P)",
    label: "AZ - CERT OF TITLE - SALVAGE (P)",
    color: "#008000",
  },
  { id: "MD -   (P)", label: "MD -   (P)", color: "0000FF" },
  {
    id: "MI - MOPED REGISTRATION",
    label: "MI - MOPED REGISTRATION",
    color: "0000FF",
  },
  {
    id: "TX - AUCTION SALES RECEIPT -SALVAGE (P)",
    label: "TX - AUCTION SALES RECEIPT -SALVAGE (P)",
    color: "#FF0000",
  },
  {
    id: "FL - CERT OF TITLE SLVG REBUILDABLE (P)",
    label: "FL - CERT OF TITLE SLVG REBUILDABLE (P)",
    color: "#008000",
  },
  {
    id: "SC - CERT OF TITLE-UNDISCLOSED LIEN",
    label: "SC - CERT OF TITLE-UNDISCLOSED LIEN",
    color: "#FF0000",
  },
  {
    id: "AL - CERT OF TITLE-SALVAGE TITLE (P)",
    label: "AL - CERT OF TITLE-SALVAGE TITLE (P)",
    color: "#008000",
  },
  { id: "NC - ", label: "NC - ", color: "0000FF" },
  {
    id: "MO - DUPLICATE TITLE",
    label: "MO - DUPLICATE TITLE",
    color: "#FF681F",
  },
  { id: "MA - ", label: "MA - ", color: "0000FF" },
  {
    id: "Canadian Registration (Texas)",
    label: "Canadian Registration (Texas)",
    color: "0000FF",
  },
  {
    id: "PA - CERT OF TITLE SLVG REBUILDABLE (P)",
    label: "PA - CERT OF TITLE SLVG REBUILDABLE (P)",
    color: "#008000",
  },
  {
    id: "FL - DLR ONLY CERT OF TITLE",
    label: "FL - DLR ONLY CERT OF TITLE",
    color: "#008000",
  },
  { id: "MD - ", label: "MD - ", color: "0000FF" },
  { id: "Mv-907A (New York)", label: "Mv-907A (New York)", color: "0000FF" },
  {
    id: "UT - CERT OF TITLE-MANUFACTURER BUY",
    label: "UT - CERT OF TITLE-MANUFACTURER BUY",
    color: "#FF681F",
  },
  {
    id: "Copy Sale Document (Front) (Mississippi)",
    label: "Copy Sale Document (Front) (Mississippi)",
    color: "0000FF",
  },
  { id: "OR - ", label: "OR - ", color: "0000FF" },
  { id: "PartsOnly (ON)", label: "PartsOnly (ON)", color: "#FF0000" },
  { id: "Repossessed (Kansas)", label: "Repossessed (Kansas)", color: "#008000" },
  {
    id: "MI - CERT OF TITLE-SALVAGE HISTORY (P)",
    label: "MI - CERT OF TITLE-SALVAGE HISTORY (P)",
    color: "#FF681F",
  },
  { id: "PartsOnly (QC)", label: "PartsOnly (QC)", color: "#FF0000" },
  {
    id: "CO - CERT OF TITLE - REBUILDER",
    label: "CO - CERT OF TITLE - REBUILDER",
    color: "#FF681F",
  },
  { id: "DE -", label: "DE -", color: "0000FF" },
  {
    id: "ND - CERT OF TITLE PREVIOUS DAMAGE (P)",
    label: "ND - CERT OF TITLE PREVIOUS DAMAGE (P)",
    color: "#FF681F",
  },
  { id: "KY -   (P)", label: "KY -   (P)", color: "0000FF" },
  { id: "Wait Title", label: "Wait Title", color: "0000FF" },
  {
    id: "PA - CERT OF TITLE FOR A SNOWMOBILE",
    label: "PA - CERT OF TITLE FOR A SNOWMOBILE",
    color: "#FF681F",
  },
  {
    id: "TX - NONREPAIR-CERT OF AUTHORITY",
    label: "TX - NONREPAIR-CERT OF AUTHORITY",
    color: "#FF0000",
  },
  {
    id: "TX - SALVAGE VEHICLE TITLE (P)",
    label: "TX - SALVAGE VEHICLE TITLE (P)",
    color: "#008000",
  },
  {
    id: "NH - CERT OF TITLE-MANUFACTURER BUY (P)",
    label: "NH - CERT OF TITLE-MANUFACTURER BUY (P)",
    color: "#FF681F",
  },
  {
    id: "CERTIFICATE OF SALE - UT",
    label: "CERTIFICATE OF SALE - UT",
    color: "#FF0000",
  },
  {
    id: "QC - IRRECUPERABLE (P)",
    label: "QC - IRRECUPERABLE (P)",
    color: "#FF0000",
  },
  { id: "MO - ", label: "MO - ", color: "0000FF" },
  {
    id: "TN - CERT OF SALES-LIEN",
    label: "TN - CERT OF SALES-LIEN",
    color: "#FF0000",
  },
  {
    id: "CT - ABANDONED VEH SALE NOTIFICATIO",
    label: "CT - ABANDONED VEH SALE NOTIFICATIO",
    color: "#FF0000",
  },
  { id: "NH -", label: "NH -", color: "0000FF" },
  { id: "PartsOnly (AB)", label: "PartsOnly (AB)", color: "0000FF" },
  {
    id: "VA - CERT OF TITLE-SALVAGE WATER (P)",
    label: "VA - CERT OF TITLE-SALVAGE WATER (P)",
    color: "#FF681F",
  },
  {
    id: "SC - DISPOSAL AUTHORITY CERTIFICATE",
    label: "SC - DISPOSAL AUTHORITY CERTIFICATE",
    color: "0000FF",
  },
  { id: "IA -", label: "IA -", color: "0000FF" },
  { id: "AL -   (P)", label: "AL -   (P)", color: "0000FF" },
  {
    id: "QC - GRAVEMENT ACCIDENTE",
    label: "QC - GRAVEMENT ACCIDENTE",
    color: "0000FF",
  },
  { id: "ME - ", label: "ME - ", color: "0000FF" },
  {
    id: "IA - CERT OF TITLE-PRIOR SALVAGE (P)",
    label: "IA - CERT OF TITLE-PRIOR SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "NJ - CERT OF TITLE-SLVG TAXI (P)",
    label: "NJ - CERT OF TITLE-SLVG TAXI (P)",
    color: "#008000",
  },
  {
    id: "PA - CERT OF TITLE (P)",
    label: "PA - CERT OF TITLE (P)",
    color: "#FF681F",
  },
  { id: "KY -", label: "KY -", color: "0000FF" },
  {
    id: "Canadian Registration (North Carolina)",
    label: "Canadian Registration (North Carolina)",
    color: "0000FF",
  },
  {
    id: "Jp Form 40 (Delaware)",
    label: "Jp Form 40 (Delaware)",
    color: "0000FF",
  },
  {
    id: "IA - OFF-HIGHWAY VEHICLE",
    label: "IA - OFF-HIGHWAY VEHICLE",
    color: "0000FF",
  },
  {
    id: "SC - CERT OF TITLE-DLR ONLY >25% (P)",
    label: "SC - CERT OF TITLE-DLR ONLY >25% (P)",
    color: "#FF681F",
  },
  {
    id: "OH - CERT OF TITLE-REPOSSESSION",
    label: "OH - CERT OF TITLE-REPOSSESSION",
    color: "#008000",
  },
  {
    id: "Canadian Registration (Arizona)",
    label: "Canadian Registration (Arizona)",
    color: "0000FF",
  },
  { id: "Restored (Arizona)", label: "Restored (Arizona)", color: "0000FF" },
  { id: "VA - ", label: "VA - ", color: "0000FF" },
  { id: "UT - (P)", label: "UT - (P)", color: "0000FF" },
  { id: "NE -", label: "NE -", color: "0000FF" },
  {
    id: "NY - MV-907A SALVAGE CERTIFICATE (P)",
    label: "NY - MV-907A SALVAGE CERTIFICATE (P)",
    color: "#008000",
  },
  {
    id: "OK - CERT OF TITLE-REPOSSESSION",
    label: "OK - CERT OF TITLE-REPOSSESSION",
    color: "#008000",
  },
  {
    id: "NS - CERT OF REGISTRATION",
    label: "NS - CERT OF REGISTRATION",
    color: "#FF0000",
  },
  { id: "MO -   (P)", label: "MO -   (P)", color: "0000FF" },
  {
    id: "AUCTION SALES RECEIPT - TX",
    label: "AUCTION SALES RECEIPT - TX",
    color: "#FF0000",
  },
  {
    id: "NE - CERT OF TITLE-SALVAGE (P)",
    label: "NE - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "CA - FOREIGN OWNERSHIP DOCUMENTS (P)",
    label: "CA - FOREIGN OWNERSHIP DOCUMENTS (P)",
    color: "#FF0000",
  },
  {
    id: "GA - CERT OF TITLE-SALVAGE HISTORY (P)",
    label: "GA - CERT OF TITLE-SALVAGE HISTORY (P)",
    color: "#FF681F",
  },
  { id: "RI - ", label: "RI - ", color: "0000FF" },
  {
    id: "PA - CERT OF TTL-SLVG ALL-TERRAIN V (P)",
    label: "PA - CERT OF TTL-SLVG ALL-TERRAIN V (P)",
    color: "#008000",
  },
  {
    id: "NC - DLR ONLY REPOSSESSION",
    label: "NC - DLR ONLY REPOSSESSION",
    color: "#008000",
  },
  {
    id: "CA - DIS/DLR/EXP ONLY LEMON LAW",
    label: "CA - DIS/DLR/EXP ONLY LEMON LAW",
    color: "#FF681F",
  },
  {
    id: "AK - CERTIFICATE OF VEHICLE TITLE",
    label: "AK - CERTIFICATE OF VEHICLE TITLE",
    color: "#FF681F",
  },
  {
    id: "Auction Sales Receipt (Texas)",
    label: "Auction Sales Receipt (Texas)",
    color: "#FF0000",
  },
  {
    id: "TX - AUCTION SALES RECEIPT - NONREP",
    label: "TX - AUCTION SALES RECEIPT - NONREP",
    color: "#FF0000",
  },
  {
    id: "FL - CERT OF TITLE-SALVAGE TTL THFT (P)",
    label: "FL - CERT OF TITLE-SALVAGE TTL THFT (P)",
    color: "#008000",
  },
  {
    id: "Canadian Registration (Oklahoma)",
    label: "Canadian Registration (Oklahoma)",
    color: "0000FF",
  },
  {
    id: "SC - CERT OF TITLE-SALVAGE NON-REM (P)",
    label: "SC - CERT OF TITLE-SALVAGE NON-REM (P)",
    color: "#008000",
  },
  { id: "AR -", label: "AR -", color: "0000FF" },
  {
    id: "CA - SALVAGE CERTIFICATE (P)",
    label: "CA - SALVAGE CERTIFICATE (P)",
    color: "#008000",
  },
  {
    id: "PA - CERTIFICATE OF SALVAGE (P)",
    label: "PA - CERTIFICATE OF SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "CA - CERT OF TITLE OR SALVAGE ACQ (P)",
    label: "CA - CERT OF TITLE OR SALVAGE ACQ (P)",
    color: "#008000",
  },
  {
    id: "ME - CERT OF TITLE-WATER DAMAGE VEH",
    label: "ME - CERT OF TITLE-WATER DAMAGE VEH",
    color: "#FF681F",
  },
  { id: "REG CARD - ND", label: "REG CARD - ND", color: "0000FF" },
  {
    id: "NY - CERT OF TITLE-LEMON LAW BUYBAC (P)",
    label: "NY - CERT OF TITLE-LEMON LAW BUYBAC (P)",
    color: "#FF681F",
  },
  { id: "MS - ", label: "MS - ", color: "0000FF" },
  { id: "HAIL - MS", label: "HAIL - MS", color: "#FF681F" },
  {
    id: "NJ - CERT OF TITLE-LEMON LAW",
    label: "NJ - CERT OF TITLE-LEMON LAW",
    color: "#FF681F",
  },
  {
    id: "Rental Rides - Enterprise (Tennessee)",
    label: "Rental Rides - Enterprise (Tennessee)",
    color: "#008000",
  },
  { id: "Non repairable", label: "Non repairable", color: "#FF0000" },
  {
    id: "MN - DLR ONLY CERT OF TITLE - HIST",
    label: "MN - DLR ONLY CERT OF TITLE - HIST",
    color: "#FF681F",
  },
  { id: "NM -", label: "NM -", color: "0000FF" },
  {
    id: "WI - INVOLUNTARY TRANSFER TOW LIEN",
    label: "WI - INVOLUNTARY TRANSFER TOW LIEN",
    color: "0000FF",
  },
  {
    id: "Repossession Paperwork (Georgia)",
    label: "Repossession Paperwork (Georgia)",
    color: "#FF0000",
  },
  {
    id: "KS - DUPLICATE TITLE (P)",
    label: "KS - DUPLICATE TITLE (P)",
    color: "#008000",
  },
  {
    id: "KS - ELECTRONIC CERT OF TITLE",
    label: "KS - ELECTRONIC CERT OF TITLE",
    color: "#FF0000",
  },
  {
    id: "SC - CERT OF TITLE-SALVAGE (P)",
    label: "SC - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "MN - CASH FOR CLUNKERS",
    label: "MN - CASH FOR CLUNKERS",
    color: "#FF0000",
  },
  {
    id: "Repossessed (Missouri)",
    label: "Repossessed (Missouri)",
    color: "0000FF",
  },
  {
    id: "AK - CERT OF TITLE W/SALVAGE HISTOR (P)",
    label: "AK - CERT OF TITLE W/SALVAGE HISTOR (P)",
    color: "#FF681F",
  },
  {
    id: "CANADIAN REGISTRATION - FL",
    label: "CANADIAN REGISTRATION - FL",
    color: "0000FF",
  },
  {
    id: "HI - CERT OF TITLE-REPOSSESSION (P)",
    label: "HI - CERT OF TITLE-REPOSSESSION (P)",
    color: "#008000",
  },
  { id: "REG CARD - MN", label: "REG CARD - MN", color: "#FF0000" },
  {
    id: "LA - CERT OF TITLE-HAIL RECONSTRUCT",
    label: "LA - CERT OF TITLE-HAIL RECONSTRUCT",
    color: "#FF681F",
  },
  {
    id: "Repossession Paperwork (North Carolina)",
    label: "Repossession Paperwork (North Carolina)",
    color: "#FF0000",
  },
  { id: "ON -   (P)", label: "ON -   (P)", color: "0000FF" },
  { id: "IA -", label: "IA -", color: "0000FF" },
  { id: "WA - (P)", label: "WA - (P)", color: "0000FF" },
  {
    id: "CANADIAN REGISTRATION - KY",
    label: "CANADIAN REGISTRATION - KY",
    color: "0000FF",
  },
  {
    id: "PA - CERT OF TITLE-F=OUT OF COUNTRY (P)",
    label: "PA - CERT OF TITLE-F=OUT OF COUNTRY (P)",
    color: "#FF0000",
  },
  {
    id: "Rental Rides - Enterprise (Pennsylvania)",
    label: "Rental Rides - Enterprise (Pennsylvania)",
    color: "#008000",
  },
  { id: "General (Virginia)", label: "General (Virginia)", color: "0000FF" },
  {
    id: "OK - CERT OF TITLE-INDIAN TRIBAL (P)",
    label: "OK - CERT OF TITLE-INDIAN TRIBAL (P)",
    color: "#FF0000",
  },
  { id: "QC - ", label: "QC - ", color: "0000FF" },
  { id: "NYPD  -  PUBLIC - NY", label: "NYPD  -  PUBLIC - NY", color: "0000FF" },
  {
    id: "MD - CERT OF SALVAGE > 75% DAMAGE (P)",
    label: "MD - CERT OF SALVAGE > 75% DAMAGE (P)",
    color: "#008000",
  },
  {
    id: "Information Release Form (Delaware)",
    label: "Information Release Form (Delaware)",
    color: "0000FF",
  },
  {
    id: "DE - CERT OF TITLE-RE-CONST (P)",
    label: "DE - CERT OF TITLE-RE-CONST (P)",
    color: "#FF681F",
  },
  {
    id: "NC - ABND/LIEN NC DLR ONLY DELAY",
    label: "NC - ABND/LIEN NC DLR ONLY DELAY",
    color: "0000FF",
  },
  {
    id: "LA - CERT OF TITLE-WATER DAMAGED",
    label: "LA - CERT OF TITLE-WATER DAMAGED",
    color: "#FF681F",
  },
  { id: "Registration (Iowa)", label: "Registration (Iowa)", color: "0000FF" },
  {
    id: "MN - TRAILER REGISTRATION",
    label: "MN - TRAILER REGISTRATION",
    color: "0000FF",
  },
  {
    id: "Pe-Not Branded (Prince Edward Island)",
    label: "Pe-Not Branded (Prince Edward Island)",
    color: "0000FF",
  },
  { id: "NH -   (P)", label: "NH -   (P)", color: "0000FF" },
  {
    id: "WA - NONCONFORMITY CORRECTED",
    label: "WA - NONCONFORMITY CORRECTED",
    color: "0000FF",
  },
  {
    id: "NY - MV907A WITH ALTERED VIN",
    label: "NY - MV907A WITH ALTERED VIN",
    color: "0000FF",
  },
  { id: "OR -   (P)", label: "OR -   (P)", color: "0000FF" },
  {
    id: "Rental Rides Enterprise (Georgia)",
    label: "Rental Rides Enterprise (Georgia)",
    color: "#008000",
  },
  {
    id: "Rental Rides - Enterprise (North Carolina)",
    label: "Rental Rides - Enterprise (North Carolina)",
    color: "#008000",
  },
  {
    id: "UT - NOTICE OF REQUIREMENT NON REP",
    label: "UT - NOTICE OF REQUIREMENT NON REP",
    color: "#FF0000",
  },
  {
    id: "LA - CERT OF TITLE-KATRINA RECONSTR",
    label: "LA - CERT OF TITLE-KATRINA RECONSTR",
    color: "#FF681F",
  },
  {
    id: "OK - CERT OF TITLE-RECOVERED THEFT",
    label: "OK - CERT OF TITLE-RECOVERED THEFT",
    color: "#FF681F",
  },
  {
    id: "VA - CERT OF TITLE-WATER DAMAGE",
    label: "VA - CERT OF TITLE-WATER DAMAGE",
    color: "#FF681F",
  },
  {
    id: "HI - CERT OF REGISTRATION-MOPED/BIC",
    label: "HI - CERT OF REGISTRATION-MOPED/BIC",
    color: "0000FF",
  },
  {
    id: "TX - CERT OF TITLE-MANUFACTURER BUY",
    label: "TX - CERT OF TITLE-MANUFACTURER BUY",
    color: "#FF681F",
  },
  {
    id: "MD - CERT OF SALVAGE-ABANDONED (P)",
    label: "MD - CERT OF SALVAGE-ABANDONED (P)",
    color: "#008000",
  },
  {
    id: "Rental Rides - Enterprise (Oregon)",
    label: "Rental Rides - Enterprise (Oregon)",
    color: "#008000",
  },
  {
    id: "Repossession Paperwork (Pennsylvania)",
    label: "Repossession Paperwork (Pennsylvania)",
    color: "#FF0000",
  },
  {
    id: "UT - CERT OF TITLE W/SALVAGE HISTOR (P)",
    label: "UT - CERT OF TITLE W/SALVAGE HISTOR (P)",
    color: "#FF681F",
  },
  {
    id: "MT - NOT ACTUAL MILES",
    label: "MT - NOT ACTUAL MILES",
    color: "0000FF",
  },
  {
    id: "AL - E-TITLE STOLEN/UNRECOVERED VEH",
    label: "AL - E-TITLE STOLEN/UNRECOVERED VEH",
    color: "0000FF",
  },
  {
    id: "NY - MV-907A - NO PUBLIC VIN",
    label: "NY - MV-907A - NO PUBLIC VIN",
    color: "0000FF",
  },
  {
    id: "MS - CERT OF TITLE-RECOVERED THEFT",
    label: "MS - CERT OF TITLE-RECOVERED THEFT",
    color: "#008000",
  },
  {
    id: "PA - CERT OF TITLE W/SALVAGE HISTOR (P)",
    label: "PA - CERT OF TITLE W/SALVAGE HISTOR (P)",
    color: "#FF681F",
  },
  {
    id: "Bc-Damage Over $2000 (British Columbia)",
    label: "Bc-Damage Over $2000 (British Columbia)",
    color: "0000FF",
  },
  {
    id: "No Ownership (Ontario)",
    label: "No Ownership (Ontario)",
    color: "0000FF",
  },
  {
    id: "Sk-Not Branded (Saskatchewan)",
    label: "Sk-Not Branded (Saskatchewan)",
    color: "0000FF",
  },
  {
    id: "Mb-Write Off (Hail) (Manitoba)",
    label: "Mb-Write Off (Hail) (Manitoba)",
    color: "#FF0000",
  },
  { id: "ME - LEMON LAW TITLE", label: "ME - LEMON LAW TITLE", color: "0000FF" },
  { id: "Mb-Normal (Manitoba)", label: "Mb-Normal (Manitoba)", color: "0000FF" },
  {
    id: "Nf-Not-Branded (Newfoundland And Labrador)",
    label: "Nf-Not-Branded (Newfoundland And Labrador)",
    color: "0000FF",
  },
  {
    id: "NC - CERT OF TITLE W/SALVAGE HISTOR (P)",
    label: "NC - CERT OF TITLE W/SALVAGE HISTOR (P)",
    color: "#FF681F",
  },
  {
    id: "Qc-Irrecuperable (Quebec)",
    label: "Qc-Irrecuperable (Quebec)",
    color: "0000FF",
  },
  {
    id: "LA - CERT OF TITLE-SALAVGE HAIL",
    label: "LA - CERT OF TITLE-SALAVGE HAIL",
    color: "#008000",
  },
  {
    id: "Sk-No Inspection Required (Saskatchewan)",
    label: "Sk-No Inspection Required (Saskatchewan)",
    color: "0000FF",
  },
  {
    id: "CT - CERT OF TITLE-SALVAGE (P)",
    label: "CT - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "Release Of Interest (Washington)",
    label: "Release Of Interest (Washington)",
    color: "0000FF",
  },
  { id: "Reg Card (Michigan)", label: "Reg Card (Michigan)", color: "0000FF" },
  {
    id: "TX - BOAT MOTOR TITLE",
    label: "TX - BOAT MOTOR TITLE",
    color: "#FF681F",
  },
  {
    id: "Sk-Mechanical Inspection Required (Saskatchewan)",
    label: "Sk-Mechanical Inspection Required (Saskatchewan)",
    color: "0000FF",
  },
  {
    id: "Canadian Registration (Kentucky)",
    label: "Canadian Registration (Kentucky)",
    color: "0000FF",
  },
  { id: "(P)", label: "(P)", color: "0000FF" },
  {
    id: "FL - CERT OF TITLE-SALVAGE THEFT (P)",
    label: "FL - CERT OF TITLE-SALVAGE THEFT (P)",
    color: "#008000",
  },
  {
    id: "ME - CERT OF TITLE-SALVAGE COLLISIO (P)",
    label: "ME - CERT OF TITLE-SALVAGE COLLISIO (P)",
    color: "#008000",
  },
  { id: "Non-Usa (Texas)", label: "Non-Usa (Texas)", color: "#FF0000" },
  { id: "IA - DAMAGE OVER 70%", label: "IA - DAMAGE OVER 70%", color: "0000FF" },
  {
    id: "TX - CERT OF TITLE W/LEMON HISTORY (P)",
    label: "TX - CERT OF TITLE W/LEMON HISTORY (P)",
    color: "#FF681F",
  },
  {
    id: "Previously Damaged (North Dakota)",
    label: "Previously Damaged (North Dakota)",
    color: "0000FF",
  },
  {
    id: "PA - CERT OF SALVAGE-FORMERLY ABAND (P)",
    label: "PA - CERT OF SALVAGE-FORMERLY ABAND (P)",
    color: "#008000",
  },
  {
    id: "CO - CERT OF TITLE W/LEMON LAW HIST",
    label: "CO - CERT OF TITLE W/LEMON LAW HIST",
    color: "#FF681F",
  },
  {
    id: "KY - CERT OF TITLE-WATER DAMAGED (P)",
    label: "KY - CERT OF TITLE-WATER DAMAGED (P)",
    color: "#FF681F",
  },
  {
    id: "Abandon-Cert-Endorsement (Wisconsin)",
    label: "Abandon-Cert-Endorsement (Wisconsin)",
    color: "0000FF",
  },
  {
    id: "FL - CERT OF TITLE-REBUILDABLE SLVG (P)",
    label: "FL - CERT OF TITLE-REBUILDABLE SLVG (P)",
    color: "#008000",
  },
  {
    id: "Qc-Reconstruit (Quebec)",
    label: "Qc-Reconstruit (Quebec)",
    color: "0000FF",
  },
  {
    id: "Recovered Theft (Oklahoma)",
    label: "Recovered Theft (Oklahoma)",
    color: "0000FF",
  },
  {
    id: "Dcas - Public (New York)",
    label: "Dcas - Public (New York)",
    color: "0000FF",
  },
  {
    id: "FL - CERT OF TITLE- OFF-HWY VEHICLE (P)",
    label: "FL - CERT OF TITLE- OFF-HWY VEHICLE (P)",
    color: "#008000",
  },
  {
    id: "NV - CERT OF TITLE-OHV  OFF-HIGHWAY",
    label: "NV - CERT OF TITLE-OHV  OFF-HIGHWAY",
    color: "#FF681F",
  },
  {
    id: "PA - CERT OF TITLE ALL-TERRAIN VEH",
    label: "PA - CERT OF TITLE ALL-TERRAIN VEH",
    color: "#008000",
  },
  { id: "MN -   (P)", label: "MN -   (P)", color: "0000FF" },
  {
    id: "OK - DUPLICATE TITLE",
    label: "OK - DUPLICATE TITLE",
    color: "#FF681F",
  },
  { id: "QC - IRRECUPERABLE", label: "QC - IRRECUPERABLE", color: "0000FF" },
  {
    id: "Unrecovered Theft (Georgia)",
    label: "Unrecovered Theft (Georgia)",
    color: "0000FF",
  },
  {
    id: "Ab-Not Branded (Alberta)",
    label: "Ab-Not Branded (Alberta)",
    color: "0000FF",
  },
  {
    id: "Virtual Lanes - Us Buyers Only (Illinois)",
    label: "Virtual Lanes - Us Buyers Only (Illinois)",
    color: "0000FF",
  },
  {
    id: "Rental Rides - Enterprise (Illinois)",
    label: "Rental Rides - Enterprise (Illinois)",
    color: "#008000",
  },
  { id: "Title 42 (Oklahoma)", label: "Title 42 (Oklahoma)", color: "0000FF" },
  {
    id: "IA - DIS/DLR/EXP ONLY SALVAGE TITLE (P)",
    label: "IA - DIS/DLR/EXP ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "TX - CERT OF TITLE W/SALVAGE HISTOR (P)",
    label: "TX - CERT OF TITLE W/SALVAGE HISTOR (P)",
    color: "#FF681F",
  },
  {
    id: "IA - TITLE CERTIFICATE - SNOWMOBILE",
    label: "IA - TITLE CERTIFICATE - SNOWMOBILE",
    color: "#FF681F",
  },
  {
    id: "FL - ELECTRONIC CERT OF TITLE",
    label: "FL - ELECTRONIC CERT OF TITLE",
    color: "#FF0000",
  },
  {
    id: "Ns-Not Branded (Nova Scotia)",
    label: "Ns-Not Branded (Nova Scotia)",
    color: "0000FF",
  },
  {
    id: "Us-Not Branded (Michigan)",
    label: "Us-Not Branded (Michigan)",
    color: "0000FF",
  },
  { id: "QC - AUCUNE MENTION", label: "QC - AUCUNE MENTION", color: "0000FF" },
  {
    id: "WA - VEH CERT OF OWNERSHIP-SALVAGE (P)",
    label: "WA - VEH CERT OF OWNERSHIP-SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "OH - DIS/DLR/EXP ONLY SALVAGE TITLE (P)",
    label: "OH - DIS/DLR/EXP ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  { id: "Reg Card (Minnesota)", label: "Reg Card (Minnesota)", color: "0000FF" },
  {
    id: "KY - CERT OF TITLE-WATER DAMAGED",
    label: "KY - CERT OF TITLE-WATER DAMAGED",
    color: "#FF681F",
  },
  {
    id: "NY - CERT OF TITLE-LEMON LAW BUYBAC",
    label: "NY - CERT OF TITLE-LEMON LAW BUYBAC",
    color: "#FF681F",
  },
  { id: "GA -   (P)", label: "GA -   (P)", color: "0000FF" },
  {
    id: "GA - CERT OF TITLE-STOLEN/UNRECOVRD",
    label: "GA - CERT OF TITLE-STOLEN/UNRECOVRD",
    color: "#FF0000",
  },
  {
    id: "MA - CERTIFICATE TO OBTAIN SALVAGE (P)",
    label: "MA - CERTIFICATE TO OBTAIN SALVAGE (P)",
    color: "#008000",
  },
  { id: "IL -   (P)", label: "IL -   (P)", color: "0000FF" },
  {
    id: "LA - CERT OF TITLE-UNRECOVERED THEF",
    label: "LA - CERT OF TITLE-UNRECOVERED THEF",
    color: "#FF681F",
  },
  { id: "PA -   (P)", label: "PA -   (P)", color: "0000FF" },
  { id: "FL -   (P)", label: "FL -   (P)", color: "0000FF" },
  {
    id: "NY - CERT OF TITLE W/UNSATISFD LIEN (P)",
    label: "NY - CERT OF TITLE W/UNSATISFD LIEN (P)",
    color: "#FF0000",
  },
  {
    id: "OK - CERT OF TITLE-UNR THEFT",
    label: "OK - CERT OF TITLE-UNR THEFT",
    color: "0000FF",
  },
  {
    id: "LA - CERT OF TITLE-SALVAGE WATER (P)",
    label: "LA - CERT OF TITLE-SALVAGE WATER (P)",
    color: "#FF681F",
  },
  { id: "MA -   (P)", label: "MA -   (P)", color: "0000FF" },
  { id: "TN -   (P)", label: "TN -   (P)", color: "0000FF" },
  { id: "NY -   (P)", label: "NY -   (P)", color: "0000FF" },
  { id: "MI -   (P)", label: "MI -   (P)", color: "0000FF" },
  { id: "NJ -   (P)", label: "NJ -   (P)", color: "0000FF" },
  {
    id: "FL - CERT OF TITLE W/SLVG HISTORY (P)",
    label: "FL - CERT OF TITLE W/SLVG HISTORY (P)",
    color: "#FF681F",
  },
  {
    id: "CA - DIS/DLR/EXP ONLY LEMON LAW (P)",
    label: "CA - DIS/DLR/EXP ONLY LEMON LAW (P)",
    color: "#FF681F",
  },
  {
    id: "ME - CERT OF SALVAGE - WATER DAMAGE (P)",
    label: "ME - CERT OF SALVAGE - WATER DAMAGE (P)",
    color: "#FF681F",
  },
  {
    id: "FL - CERT OF TITLE-MANUF BUY BACK",
    label: "FL - CERT OF TITLE-MANUF BUY BACK",
    color: "#FF681F",
  },
  {
    id: "QC - CERT D'IMMATRICULATION-RECONST (P)",
    label: "QC - CERT D'IMMATRICULATION-RECONST (P)",
    color: "#FF0000",
  },
  {
    id: "OR - CERT OF LIEN FORECLOSURE (P)",
    label: "OR - CERT OF LIEN FORECLOSURE (P)",
    color: "#FF0000",
  },
  { id: "Qc-Insp.req (Quebec)", label: "Qc-Insp.req (Quebec)", color: "0000FF" },
  {
    id: "Mb-Irreparable (Manitoba)",
    label: "Mb-Irreparable (Manitoba)",
    color: "0000FF",
  },
  {
    id: "Mb-Write Off (Stolen) (Manitoba)",
    label: "Mb-Write Off (Stolen) (Manitoba)",
    color: "0000FF",
  },
  {
    id: "TX - CERT OF TITLE W/REASSIGNED VIN",
    label: "TX - CERT OF TITLE W/REASSIGNED VIN",
    color: "0000FF",
  },
  {
    id: "MN - CERT OF TITLE-SALVAGE (P)",
    label: "MN - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "FL - CERT OF TITLE- OFF-HWY VEHICLE",
    label: "FL - CERT OF TITLE- OFF-HWY VEHICLE",
    color: "#FF681F",
  },
  {
    id: "FL - DLR ONLY SALVAGE/REBUILDABLE (P)",
    label: "FL - DLR ONLY SALVAGE/REBUILDABLE (P)",
    color: "#008000",
  },
  { id: "NY - MV-51", label: "NY - MV-51", color: "0000FF" },
  {
    id: "QC - CERTIFICAT-VEH. A INSPECTER (P)",
    label: "QC - CERTIFICAT-VEH. A INSPECTER (P)",
    color: "#FF0000",
  },
  {
    id: "NC - DLR ONLY SALVAGE CERTIFICATE (P)",
    label: "NC - DLR ONLY SALVAGE CERTIFICATE (P)",
    color: "#008000",
  },
  {
    id: "SD - CERT OF TITLE-SALVAGE (P)",
    label: "SD - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "Bc-Not Branded (British Columbia)",
    label: "Bc-Not Branded (British Columbia)",
    color: "0000FF",
  },
  {
    id: "OR - LETTER OF BRAND REVERSAL",
    label: "OR - LETTER OF BRAND REVERSAL",
    color: "0000FF",
  },
  {
    id: "CO - PUBLIC - SALVAGE TITLE (P)",
    label: "CO - PUBLIC - SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "NS - NO TITLE AVAILABLE",
    label: "NS - NO TITLE AVAILABLE",
    color: "#FF0000",
  },
  {
    id: "OK - CERT OF TITLE-SALVAGE HISTORY (P)",
    label: "OK - CERT OF TITLE-SALVAGE HISTORY (P)",
    color: "#FF681F",
  },
  {
    id: "CA - CERT OF TITLE-LEMON LAW BUYBAC (P)",
    label: "CA - CERT OF TITLE-LEMON LAW BUYBAC (P)",
    color: "#FF681F",
  },
  {
    id: "NM - CERT OF TITLE-SALVAGE (P)",
    label: "NM - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "MB - NO TITLE AVAILABLE",
    label: "MB - NO TITLE AVAILABLE",
    color: "#FF0000",
  },
  {
    id: "VT - CERT OF TITLE-SALVAGE VEHICLE (P)",
    label: "VT - CERT OF TITLE-SALVAGE VEHICLE (P)",
    color: "#008000",
  },
  {
    id: "WV - SALVAGE CERTIFICATE (P)",
    label: "WV - SALVAGE CERTIFICATE (P)",
    color: "#008000",
  },
  { id: "CT - (P)", label: "CT - (P)", color: "0000FF" },
  {
    id: "ND - CERT OF TITLE PREVIOUS DAMAGE",
    label: "ND - CERT OF TITLE PREVIOUS DAMAGE",
    color: "#FF681F",
  },
  {
    id: "BC - VEH REGISTRATION-NO BRAND (P)",
    label: "BC - VEH REGISTRATION-NO BRAND (P)",
    color: "#FF0000",
  },
  {
    id: "IL - CERT OF TITLE-CORRECTED (P)",
    label: "IL - CERT OF TITLE-CORRECTED (P)",
    color: "#FF681F",
  },
  {
    id: "MS - CERT OF TITLE-SALVAGED (P)",
    label: "MS - CERT OF TITLE-SALVAGED (P)",
    color: "#008000",
  },
  {
    id: "SC - CERT OF TITLE-DLR ONLY >25%",
    label: "SC - CERT OF TITLE-DLR ONLY >25%",
    color: "#FF681F",
  },
  {
    id: "KS - CERT OF TITLE-FORMER NON-HWY",
    label: "KS - CERT OF TITLE-FORMER NON-HWY",
    color: "0000FF",
  },
  {
    id: "TX - DIS/DLR/EXP ONLY SALVAGE TITLE (P)",
    label: "TX - DIS/DLR/EXP ONLY SALVAGE TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "IN - CERT OF TITLE-SALVAGE TITLE (P)",
    label: "IN - CERT OF TITLE-SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "LA - CERT OF TITLE-SALVAGE HISTORY (P)",
    label: "LA - CERT OF TITLE-SALVAGE HISTORY (P)",
    color: "#FF681F",
  },
  {
    id: "CA - US GOVERNMENT CERT TO OBTAIN (P)",
    label: "CA - US GOVERNMENT CERT TO OBTAIN (P)",
    color: "#FF0000",
  },
  { id: "BC - EXPORT ONLY", label: "BC - EXPORT ONLY", color: "0000FF" },
  {
    id: "WA - TD420-TOTAL LOSS SETTLEMENT",
    label: "WA - TD420-TOTAL LOSS SETTLEMENT",
    color: "0000FF",
  },
  {
    id: "NH - CERT OF TITLE-SALVAGE (P)",
    label: "NH - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "AZ - CERT OF TITLE-RESTORED SALVAGE (P)",
    label: "AZ - CERT OF TITLE-RESTORED SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "MX - MX-MSO FOR EXPORT ONLY",
    label: "MX - MX-MSO FOR EXPORT ONLY",
    color: "0000FF",
  },
  {
    id: "MS - CERT OF TITLE-HAIL DAMAGED",
    label: "MS - CERT OF TITLE-HAIL DAMAGED",
    color: "#FF681F",
  },
  {
    id: "PA - CERT OF TITLE-C=CLASSIC VEHICL",
    label: "PA - CERT OF TITLE-C=CLASSIC VEHICL",
    color: "0000FF",
  },
  {
    id: "HI - CERTIFICATE OF SALVAGE (P)",
    label: "HI - CERTIFICATE OF SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "MA - CERT OF TITLE-RECOVERED THEFT",
    label: "MA - CERT OF TITLE-RECOVERED THEFT",
    color: "0000FF",
  },
  {
    id: "NJ - CERT OF TITLE - POLICE (P)",
    label: "NJ - CERT OF TITLE - POLICE (P)",
    color: "#008000",
  },
  {
    id: "NJ - CERT OF TITLE W/SALVAGE HISTOR (P)",
    label: "NJ - CERT OF TITLE W/SALVAGE HISTOR (P)",
    color: "#FF681F",
  },
  {
    id: "PA - CERT OF TITLE-A=ANTIQUE VEHICL",
    label: "PA - CERT OF TITLE-A=ANTIQUE VEHICL",
    color: "#FF681F",
  },
  {
    id: "PA - CERT OF SALVAGE-R=RECONSTRUCTE (P)",
    label: "PA - CERT OF SALVAGE-R=RECONSTRUCTE (P)",
    color: "#FF681F",
  },
  {
    id: "MA - CERT OF TITLE-SLVG REPAIR THFT (P)",
    label: "MA - CERT OF TITLE-SLVG REPAIR THFT (P)",
    color: "#FF681F",
  },
  {
    id: "OK - CERT OF TITLE-INDIAN TRIBAL",
    label: "OK - CERT OF TITLE-INDIAN TRIBAL",
    color: "0000FF",
  },
  {
    id: "AR - CERT OF TITLE-SALVAGE (P)",
    label: "AR - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "NY - CERT OF TITLE-SALVAGE (P)",
    label: "NY - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "CA - CERT OF TITLE-SALVAGED (P)",
    label: "CA - CERT OF TITLE-SALVAGED (P)",
    color: "#008000",
  },
  {
    id: "CO - CERT OF TITLE-SALVAGE HISTORY (P)",
    label: "CO - CERT OF TITLE-SALVAGE HISTORY (P)",
    color: "#FF681F",
  },
  {
    id: "MO - CERT OF TITLE-PRIOR SALVAGE (P)",
    label: "MO - CERT OF TITLE-PRIOR SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "MD - CERT OF SALVAGE < 75% DAMAGE (P)",
    label: "MD - CERT OF SALVAGE < 75% DAMAGE (P)",
    color: "#008000",
  },
  { id: "MD - VR-112", label: "MD - VR-112", color: "0000FF" },
  {
    id: "PA - CERT OF TITLE-FORMERLY ABANDON",
    label: "PA - CERT OF TITLE-FORMERLY ABANDON",
    color: "0000FF",
  },
  { id: "Hail (Mississippi)", label: "Hail (Mississippi)", color: "#008000" },
  {
    id: "OR - SALVAGE TITLE (P)",
    label: "OR - SALVAGE TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "NE - CERT OF TITLE W/SALVAGE HISTOR (P)",
    label: "NE - CERT OF TITLE W/SALVAGE HISTOR (P)",
    color: "#FF681F",
  },
  { id: "CO - (P)", label: "CO - (P)", color: "0000FF" },
  {
    id: "SC - CERT OF TITLE-SALVAGE WATER (P)",
    label: "SC - CERT OF TITLE-SALVAGE WATER (P)",
    color: "#FF681F",
  },
  {
    id: "Registration Card (Alaska)",
    label: "Registration Card (Alaska)",
    color: "0000FF",
  },
  { id: "OH -   (P)", label: "OH -   (P)", color: "0000FF" },
  {
    id: "UT - SALVAGE CERTIFICATE (P)",
    label: "UT - SALVAGE CERTIFICATE (P)",
    color: "#008000",
  },
  {
    id: "CA - CERT OF TITLE-LEMON LAW BUYBAC",
    label: "CA - CERT OF TITLE-LEMON LAW BUYBAC",
    color: "#FF681F",
  },
  {
    id: "CA - SALVAGE ACQUISITION BILLOFSALE (P)",
    label: "CA - SALVAGE ACQUISITION BILLOFSALE (P)",
    color: "#FF0000",
  },
  {
    id: "QC - GRAVEMENT ACCIDENTE (P)",
    label: "QC - GRAVEMENT ACCIDENTE (P)",
    color: "#FF0000",
  },
  {
    id: "MI - DLR ONLY - CLN TTL EXCEEDS 25%",
    label: "MI - DLR ONLY - CLN TTL EXCEEDS 25%",
    color: "0000FF",
  },
  {
    id: "MN - CERT OF TITLE-PRIOR SALVAGE (P)",
    label: "MN - CERT OF TITLE-PRIOR SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "IA - BOAT CERTIFICATE",
    label: "IA - BOAT CERTIFICATE",
    color: "#FF681F",
  },
  {
    id: "Nb-Not Branded (New Brunswick)",
    label: "Nb-Not Branded (New Brunswick)",
    color: "0000FF",
  },
  {
    id: "Tribal Title -  Public Restricted (Oklahoma)",
    label: "Tribal Title -  Public Restricted (Oklahoma)",
    color: "0000FF",
  },
  { id: "AB - EXPORT ONLY", label: "AB - EXPORT ONLY", color: "#FF681F" },
  {
    id: "NC - ABND/LIEN NC DLR ONLY",
    label: "NC - ABND/LIEN NC DLR ONLY",
    color: "#FF0000",
  },
  {
    id: "KY - DUPLICATE TITLE",
    label: "KY - DUPLICATE TITLE",
    color: "#FF681F",
  },
  {
    id: "OH - ELECTRONIC CERT OF TITLE",
    label: "OH - ELECTRONIC CERT OF TITLE",
    color: "#FF0000",
  },
  {
    id: "WY - CERT OF TITLE-SALVAGE (P)",
    label: "WY - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "QC - AUCUNE MENTION (P)",
    label: "QC - AUCUNE MENTION (P)",
    color: "#FF0000",
  },
  {
    id: "NY - CERT OF TITLE W/UNSATISFD LIEN",
    label: "NY - CERT OF TITLE W/UNSATISFD LIEN",
    color: "0000FF",
  },
  {
    id: "KS - CERT OF TITLE-SALVAGE (P)",
    label: "KS - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "ON - NO TITLE AVAILABLE",
    label: "ON - NO TITLE AVAILABLE",
    color: "0000FF",
  },
  {
    id: "Duplicate Paperwork (California)",
    label: "Duplicate Paperwork (California)",
    color: "#FF0000",
  },
  {
    id: "IA - CERT OF TITLE-SALVAGE TITLE (P)",
    label: "IA - CERT OF TITLE-SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "NJ - CERT OF TITLE-LEMON LAW (P)",
    label: "NJ - CERT OF TITLE-LEMON LAW (P)",
    color: "#FF681F",
  },
  {
    id: "MI - DLR ONLY MUNICIPAL CERT OF TTL",
    label: "MI - DLR ONLY MUNICIPAL CERT OF TTL",
    color: "0000FF",
  },
  {
    id: "UT - CERTIFICATE OF SALE - SALVAGE (P)",
    label: "UT - CERTIFICATE OF SALE - SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "NV - WILDLIFE CERT OF OWNERSHIP (P)",
    label: "NV - WILDLIFE CERT OF OWNERSHIP (P)",
    color: "#FF0000",
  },
  {
    id: "NY - MV-51B/STMT OF OWNERSHIP",
    label: "NY - MV-51B/STMT OF OWNERSHIP",
    color: "0000FF",
  },
  {
    id: "QC - POUR PIECE SEULEMENT",
    label: "QC - POUR PIECE SEULEMENT",
    color: "0000FF",
  },
  {
    id: "QC - CERT D'IMMATRICULATION-RECONST",
    label: "QC - CERT D'IMMATRICULATION-RECONST",
    color: "#FF0000",
  },
  {
    id: "QC - CERTIFICAT-VEH. A INSPECTER",
    label: "QC - CERTIFICAT-VEH. A INSPECTER",
    color: "0000FF",
  },
  {
    id: "NS - CERT OF REGISTRATION (P)",
    label: "NS - CERT OF REGISTRATION (P)",
    color: "#FF0000",
  },
  {
    id: "NB - SALVAGE TITLE (P)",
    label: "NB - SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "NS - SALVAGE TITLE (P)",
    label: "NS - SALVAGE TITLE (P)",
    color: "#FF0000",
  },
  {
    id: "NB - NO TITLE AVAILABLE",
    label: "NB - NO TITLE AVAILABLE",
    color: "0000FF",
  },
  {
    id: "Canadian Registration (Georgia)",
    label: "Canadian Registration (Georgia)",
    color: "0000FF",
  },
  {
    id: "CA - NON-REVIVABLE ACQUISITION (P)",
    label: "CA - NON-REVIVABLE ACQUISITION (P)",
    color: "#FF0000",
  },
  {
    id: "DE - CERT OF TITLE-RE-CONST",
    label: "DE - CERT OF TITLE-RE-CONST",
    color: "#FF681F",
  },
  { id: "NB - NON REPAIRABLE", label: "NB - NON REPAIRABLE", color: "#FF0000" },
  { id: "LA - (P)", label: "LA - (P)", color: "0000FF" },
  {
    id: "Mvr 4 (North Carolina)",
    label: "Mvr 4 (North Carolina)",
    color: "0000FF",
  },
  {
    id: "Canadian Registration (Florida)",
    label: "Canadian Registration (Florida)",
    color: "0000FF",
  },
  {
    id: "Abandoned (Pennsylvania)",
    label: "Abandoned (Pennsylvania)",
    color: "0000FF",
  },
  {
    id: "MO - DUPLICATE TITLE (P)",
    label: "MO - DUPLICATE TITLE (P)",
    color: "#FF681F",
  },
  { id: "NC - (P)", label: "NC - (P)", color: "0000FF" },
  {
    id: "Mb-Not Branded (Manitoba)",
    label: "Mb-Not Branded (Manitoba)",
    color: "0000FF",
  },
  {
    id: "Canadian Registration (Michigan)",
    label: "Canadian Registration (Michigan)",
    color: "0000FF",
  },
  {
    id: "On-Wreck Title No Os (Ontario)",
    label: "On-Wreck Title No Os (Ontario)",
    color: "0000FF",
  },
  {
    id: "On-Irreparable (Ontario)",
    label: "On-Irreparable (Ontario)",
    color: "0000FF",
  },
  {
    id: "RENTAL RIDES  -  ENTERPRISE - NH",
    label: "RENTAL RIDES  -  ENTERPRISE - NH",
    color: "#008000",
  },
  {
    id: "MA - CERT OF TITLE-SALVAGE (P)",
    label: "MA - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "HI - SALVAGE TITLE (P)",
    label: "HI - SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "TN - CERT OF TITLE-SALVAGE HISTORY (P)",
    label: "TN - CERT OF TITLE-SALVAGE HISTORY (P)",
    color: "#FF681F",
  },
  {
    id: "NJ - CERT OF TITLE-SALVAGE (P)",
    label: "NJ - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  { id: "MVR 4 - NC", label: "MVR 4 - NC", color: "0000FF" },
  { id: "NH -", label: "NH -", color: "0000FF" },
  {
    id: "MA - CERT OF TITLE-RECOVERED THEFT (P)",
    label: "MA - CERT OF TITLE-RECOVERED THEFT (P)",
    color: "#008000",
  },
  {
    id: "Rental Rides - Enterprise (New Hampshire)",
    label: "Rental Rides - Enterprise (New Hampshire)",
    color: "#008000",
  },
  { id: "CO - EXPORT ONLY", label: "CO - EXPORT ONLY", color: "#FF681F" },
  {
    id: "IL - CERT OF TITLE-CORRECTED",
    label: "IL - CERT OF TITLE-CORRECTED",
    color: "0000FF",
  },
  {
    id: "Re-Sale Finance (Ohio)",
    label: "Re-Sale Finance (Ohio)",
    color: "0000FF",
  },
  {
    id: "Canadian Registration (Alabama)",
    label: "Canadian Registration (Alabama)",
    color: "0000FF",
  },
  {
    id: "TRIBAL TITLE  -   PUBLIC RESTRICTED - OK",
    label: "TRIBAL TITLE  -   PUBLIC RESTRICTED - OK",
    color: "0000FF",
  },
  {
    id: "RELEASE OF INTEREST - WA",
    label: "RELEASE OF INTEREST - WA",
    color: "0000FF",
  },
  {
    id: "FL - CERT OF TITLE-MANUF BUY BACK (P)",
    label: "FL - CERT OF TITLE-MANUF BUY BACK (P)",
    color: "#FF681F",
  },
  {
    id: "NV - WILDLIFE CERT OF OWNERSHIP",
    label: "NV - WILDLIFE CERT OF OWNERSHIP",
    color: "0000FF",
  },
  {
    id: "FL - DIS/DLR/EXP ONLY SALVAGE TITLE (P)",
    label: "FL - DIS/DLR/EXP ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  { id: "Duplicate (Georgia)", label: "Duplicate (Georgia)", color: "#FF681F" },
  {
    id: "CANADIAN REGISTRATION - GA",
    label: "CANADIAN REGISTRATION - GA",
    color: "0000FF",
  },
  { id: "DCAS  -  PUBLIC - NY", label: "DCAS  -  PUBLIC - NY", color: "0000FF" },
  { id: "NON - USA - TX", label: "NON - USA - TX", color: "#FF0000" },
  {
    id: "PA - CERT OF TITLE-F=OUT OF COUNTRY",
    label: "PA - CERT OF TITLE-F=OUT OF COUNTRY",
    color: "#FF0000",
  },
  { id: "REPOSSESSED - KS", label: "REPOSSESSED - KS", color: "#008000" },
  {
    id: "Nypd - Public (New York)",
    label: "Nypd - Public (New York)",
    color: "0000FF",
  },
  { id: "REGISTRATION - IA", label: "REGISTRATION - IA", color: "0000FF" },
  {
    id: "MD - DLR ONLY CERT OF SALVAGE (P)",
    label: "MD - DLR ONLY CERT OF SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "NV - CERT OF TITLE-OHV  OFF-HIGHWAY (P)",
    label: "NV - CERT OF TITLE-OHV  OFF-HIGHWAY (P)",
    color: "#FF681F",
  },
  { id: "KY -", label: "KY -", color: "0000FF" },
  {
    id: "AZ - CERT OF TITLE-PREVIOUS SALVAGE (P)",
    label: "AZ - CERT OF TITLE-PREVIOUS SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "KY - CERT OF TITLE-SALVAGE (P)",
    label: "KY - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  { id: "MT -", label: "MT -", color: "0000FF" },
  {
    id: "IL - DUPLICATE TITLE",
    label: "IL - DUPLICATE TITLE",
    color: "#FF681F",
  },
  {
    id: "OH - CERT OF TITLE-REPOSSESSION (P)",
    label: "OH - CERT OF TITLE-REPOSSESSION (P)",
    color: "#FF681F",
  },
  {
    id: "Registration (New York)",
    label: "Registration (New York)",
    color: "0000FF",
  },
  {
    id: "FL - CERT OF DESTRUCT-NO VIN PLATE",
    label: "FL - CERT OF DESTRUCT-NO VIN PLATE",
    color: "#FF0000",
  },
  {
    id: "REPOSSESSION PAPERWORK - NC",
    label: "REPOSSESSION PAPERWORK - NC",
    color: "0000FF",
  },
  {
    id: "NV - CERT OF TITLE-OHV TOTAL LOSS",
    label: "NV - CERT OF TITLE-OHV TOTAL LOSS",
    color: "#FF0000",
  },
  {
    id: "FL - CERT OF DESTRUCT-NO VIN PLATE (P)",
    label: "FL - CERT OF DESTRUCT-NO VIN PLATE (P)",
    color: "#FF0000",
  },
  {
    id: "CO - DIS/DLR/EXP ONLY SALVAGE TITLE (P)",
    label: "CO - DIS/DLR/EXP ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "Rental Rides - Enterprise (Iowa)",
    label: "Rental Rides - Enterprise (Iowa)",
    color: "0000FF",
  },
  {
    id: "DC - GOVERNMENT SALVAGE (P)",
    label: "DC - GOVERNMENT SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "IL - SALVAGE CERTIFICATE (P)",
    label: "IL - SALVAGE CERTIFICATE (P)",
    color: "#008000",
  },
  { id: "RESTORED - AZ", label: "RESTORED - AZ", color: "0000FF" },
  { id: "REGISTRATION - NY", label: "REGISTRATION - NY", color: "0000FF" },
  {
    id: "LA - CERT OF TITLE-HAIL DAMAGED",
    label: "LA - CERT OF TITLE-HAIL DAMAGED",
    color: "#FF681F",
  },
  { id: "Tr-52 (Michigan)", label: "Tr-52 (Michigan)", color: "0000FF" },
  {
    id: "ND - CERT OF TITLE - SALVAGE VEHICL (P)",
    label: "ND - CERT OF TITLE - SALVAGE VEHICL (P)",
    color: "#008000",
  },
  { id: "IN -   (P)", label: "IN -   (P)", color: "#FF681F" },
  {
    id: "CANADIAN REGISTRATION - TN",
    label: "CANADIAN REGISTRATION - TN",
    color: "0000FF",
  },
  { id: "REG CARD - MI", label: "REG CARD - MI", color: "0000FF" },
  {
    id: "QC - RIV IMPORT SALVAGE (P)",
    label: "QC - RIV IMPORT SALVAGE (P)",
    color: "#FF681F",
  },
  { id: "NE -", label: "NE -", color: "0000FF" },
  { id: "IL - ", label: "IL - ", color: "0000FF" },
  { id: "NY - ", label: "NY - ", color: "0000FF" },
  { id: "VT -", label: "VT -", color: "0000FF" },
  { id: "TN - ", label: "TN - ", color: "0000FF" },
  { id: "CT - ", label: "CT - ", color: "0000FF" },
  { id: "IN - ", label: "IN - ", color: "0000FF" },
  { id: "AZ - ", label: "AZ - ", color: "0000FF" },
  { id: "WA - ", label: "WA - ", color: "0000FF" },
  { id: "NJ - ", label: "NJ - ", color: "0000FF" },
  { id: "MI - ", label: "MI - ", color: "0000FF" },
  { id: "PA - ", label: "PA - ", color: "0000FF" },
  { id: "LA - ", label: "LA - ", color: "0000FF" },
  { id: "ON - ", label: "ON - ", color: "0000FF" },
  { id: "KS - ", label: "KS - ", color: "0000FF" },
  { id: "SC - ", label: "SC - ", color: "0000FF" },
  { id: "OK - ", label: "OK - ", color: "0000FF" },
  { id: "NL - VEHICLE PERMIT", label: "NL - VEHICLE PERMIT", color: "#FF0000" },
  {
    id: "REPOSSESSION PAPERWORK - NJ",
    label: "REPOSSESSION PAPERWORK - NJ",
    color: "#FF0000",
  },
  { id: "MN - ", label: "MN - ", color: "0000FF" },
  {
    id: "KS - DUPLICATE TITLE",
    label: "KS - DUPLICATE TITLE",
    color: "#FF681F",
  },
  {
    id: "Canadian Registration (Tennessee)",
    label: "Canadian Registration (Tennessee)",
    color: "0000FF",
  },
  { id: "CO - ", label: "CO - ", color: "0000FF" },
  { id: "OH - ", label: "OH - ", color: "0000FF" },
  { id: "GA - ", label: "GA - ", color: "0000FF" },
  { id: "AL - ", label: "AL - ", color: "0000FF" },
  {
    id: "Nw-Not Branded (Northwest Territories)",
    label: "Nw-Not Branded (Northwest Territories)",
    color: "0000FF",
  },
  {
    id: "Repossession Paperwork (South Carolina)",
    label: "Repossession Paperwork (South Carolina)",
    color: "#FF0000",
  },
  {
    id: "TX - CERT OF TITLE W/LEMON HISTORY",
    label: "TX - CERT OF TITLE W/LEMON HISTORY",
    color: "#FF681F",
  },
  {
    id: "Recovered Theft (Georgia)",
    label: "Recovered Theft (Georgia)",
    color: "0000FF",
  },
  {
    id: "NH - CERT OF TITLE-MANUFACTURER BUY",
    label: "NH - CERT OF TITLE-MANUFACTURER BUY",
    color: "#FF681F",
  },
  { id: "TR - 52 - MI", label: "TR - 52 - MI", color: "0000FF" },
  {
    id: "PREVIOUSLY DAMAGED - ND",
    label: "PREVIOUSLY DAMAGED - ND",
    color: "#FF681F",
  },
  {
    id: "AK - CERTIFICATE OF VEHICLE TITLE (P)",
    label: "AK - CERTIFICATE OF VEHICLE TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "Insurance Brand (Wisconsin)",
    label: "Insurance Brand (Wisconsin)",
    color: "#008000",
  },
  {
    id: "RENTAL RIDES  -  ENTERPRISE - TN",
    label: "RENTAL RIDES  -  ENTERPRISE - TN",
    color: "#008000",
  },
  {
    id: "GA - DIS/DLR/EXP ONLY SALVAGE TITLE (P)",
    label: "GA - DIS/DLR/EXP ONLY SALVAGE TITLE (P)",
    color: "#008000",
  },
  { id: "BC -", label: "BC -", color: "0000FF" },
  {
    id: "REGISTRATION CARD - AK",
    label: "REGISTRATION CARD - AK",
    color: "#FF0000",
  },
  {
    id: "Us Government Certificate (Arizona)",
    label: "Us Government Certificate (Arizona)",
    color: "#FF0000",
  },
  {
    id: "OK - CERT OF TITLE-SALVAGE (P)",
    label: "OK - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "ON - NO TITLE AVAILABLE (P)",
    label: "ON - NO TITLE AVAILABLE (P)",
    color: "#FF0000",
  },
  {
    id: "IN - CERT OF TITLE-SALVAGE HISTORY (P)",
    label: "IN - CERT OF TITLE-SALVAGE HISTORY (P)",
    color: "#FF681F",
  },
  { id: "NV - ", label: "NV - ", color: "0000FF" },
  { id: "PA - CERT OF TITLE", label: "PA - CERT OF TITLE", color: "#FF681F" },
  { id: "TX - ", label: "TX - ", color: "0000FF" },
  { id: "FL - ", label: "FL - ", color: "0000FF" },
  { id: "CA - ", label: "CA - ", color: "0000FF" },
  { id: "WI - ", label: "WI - ", color: "0000FF" },
  {
    id: "FL - CERT OF TITLE-TAXI (P)",
    label: "FL - CERT OF TITLE-TAXI (P)",
    color: "#008000",
  },
  {
    id: "NB - NO TITLE AVAILABLE (P)",
    label: "NB - NO TITLE AVAILABLE (P)",
    color: "#FF0000",
  },
  {
    id: "OH - CERT OF TITLE-SALVAGE HISTORY (P)",
    label: "OH - CERT OF TITLE-SALVAGE HISTORY (P)",
    color: "#FF681F",
  },
  { id: "NM -", label: "NM -", color: "0000FF" },
  { id: "PA - ", label: "PA - ", color: "0000FF" },
  {
    id: "BC - VEH REGISTRATION-NO BRAND",
    label: "BC - VEH REGISTRATION-NO BRAND",
    color: "0000FF",
  },
  { id: "SC - ", label: "SC - ", color: "0000FF" },
  { id: "QC - ", label: "QC - ", color: "0000FF" },
  { id: "RI - ", label: "RI - ", color: "0000FF" },
  { id: "MN - ", label: "MN - ", color: "0000FF" },
  { id: "- ", label: "- ", color: "0000FF" },
  { id: "UT - ", label: "UT - ", color: "0000FF" },
  { id: "NC - ", label: "NC - ", color: "0000FF" },
  { id: "CO - ", label: "CO - ", color: "0000FF" },
  {
    id: "Canadian Registration (New York)",
    label: "Canadian Registration (New York)",
    color: "0000FF",
  },
  { id: "AB - ", label: "AB - ", color: "0000FF" },
  {
    id: "FL - CERT OF TITLE-TAXI",
    label: "FL - CERT OF TITLE-TAXI",
    color: "#008000",
  },
  { id: "VA - ", label: "VA - ", color: "0000FF" },
  { id: "WA - ", label: "WA - ", color: "0000FF" },
  { id: "OH - ", label: "OH - ", color: "0000FF" },
  { id: "NV - ", label: "NV - ", color: "0000FF" },
  { id: "WI - ", label: "WI - ", color: "0000FF" },
  { id: "MO - ", label: "MO - ", color: "0000FF" },
  { id: "HI - ", label: "HI - ", color: "0000FF" },
  { id: "OK -   (P)", label: "OK -   (P)", color: "0000FF" },
  {
    id: "NY - MV-907A RECOVRD THEFT BRND WVR",
    label: "NY - MV-907A RECOVRD THEFT BRND WVR",
    color: "#008000",
  },
  { id: "ON - ", label: "ON - ", color: "0000FF" },
  {
    id: "Repossession Paperwork (New Jersey)",
    label: "Repossession Paperwork (New Jersey)",
    color: "#FF0000",
  },
  { id: "ME - ", label: "ME - ", color: "0000FF" },
  { id: "LA - ", label: "LA - ", color: "0000FF" },
  { id: "Ab-Active (Alberta)", label: "Ab-Active (Alberta)", color: "0000FF" },
  {
    id: "TN - SALVAGE CERTIFICATE (P)",
    label: "TN - SALVAGE CERTIFICATE (P)",
    color: "#008000",
  },
  {
    id: "MI - CERT OF TITLE-MUNICIPAL",
    label: "MI - CERT OF TITLE-MUNICIPAL",
    color: "0000FF",
  },
  {
    id: "Mb-Salvagable (Manitoba)",
    label: "Mb-Salvagable (Manitoba)",
    color: "0000FF",
  },
  {
    id: "Qc-Aucun Statut (Quebec)",
    label: "Qc-Aucun Statut (Quebec)",
    color: "0000FF",
  },
  {
    id: "CT - CERT OF TITLE-RECOVERED THEFT",
    label: "CT - CERT OF TITLE-RECOVERED THEFT",
    color: "#008000",
  },
  { id: "CA - ", label: "CA - ", color: "0000FF" },
  { id: "TX - ", label: "TX - ", color: "0000FF" },
  {
    id: "TX - CERT OF TITLE-MANUFACTURER BUY (P)",
    label: "TX - CERT OF TITLE-MANUFACTURER BUY (P)",
    color: "#FF681F",
  },
  { id: "GA - ", label: "GA - ", color: "0000FF" },
  { id: "OK - ", label: "OK - ", color: "0000FF" },
  { id: "CT - ", label: "CT - ", color: "0000FF" },
  { id: "NY - ", label: "NY - ", color: "0000FF" },
  { id: "NJ - ", label: "NJ - ", color: "0000FF" },
  { id: "FL - ", label: "FL - ", color: "0000FF" },
  { id: "IL - ", label: "IL - ", color: "0000FF" },
  { id: "IN - ", label: "IN - ", color: "0000FF" },
  { id: "AZ - ", label: "AZ - ", color: "0000FF" },
  { id: "MA - ", label: "MA - ", color: "0000FF" },
  { id: "MI - ", label: "MI - ", color: "0000FF" },
  { id: "AL - ", label: "AL - ", color: "0000FF" },
  { id: "#NAME?", label: "#NAME?", color: "0000FF" },
  { id: "ID - ", label: "ID - ", color: "0000FF" },
  {
    id: "BcвАУNormal  (British Columbia)",
    label: "BcвАУNormal  (British Columbia)",
    color: "0000FF",
  },
  { id: "SD -", label: "SD -", color: "0000FF" },
  { id: "TN - ", label: "TN - ", color: "0000FF" },
  { id: "MD - ", label: "MD - ", color: "0000FF" },
  {
    id: "OH - DLR ONLY CLN TTL RBLT SVG<25%",
    label: "OH - DLR ONLY CLN TTL RBLT SVG<25%",
    color: "#FF681F",
  },
  {
    id: "SD - CERT OF TITLE-REPOSSESSION",
    label: "SD - CERT OF TITLE-REPOSSESSION",
    color: "#008000",
  },
  { id: "CA -   (P)", label: "CA -   (P)", color: "0000FF" },
  {
    id: "OR - CERT OF LIEN FORECLOSURE",
    label: "OR - CERT OF LIEN FORECLOSURE",
    color: "#FF0000",
  },
  {
    id: "LA - CERT OF TITLE-SALVAGE (P)",
    label: "LA - CERT OF TITLE-SALVAGE (P)",
    color: "#008000",
  },
  { id: "REPOSSESSED - MO", label: "REPOSSESSED - MO", color: "#008000" },
  {
    id: "REPOSSESSION PAPERWORK - SC",
    label: "REPOSSESSION PAPERWORK - SC",
    color: "#FF0000",
  },
  {
    id: "GA - CERT OF TITLE-MANUFCTR BUYBACK (P)",
    label: "GA - CERT OF TITLE-MANUFCTR BUYBACK (P)",
    color: "#FF681F",
  },
  {
    id: "AZ - CERT OF TITLE- NON REPAIR (P)",
    label: "AZ - CERT OF TITLE- NON REPAIR (P)",
    color: "#FF0000",
  },
  { id: "INSURANCE BRAND - WI", label: "INSURANCE BRAND - WI", color: "#008000" },
  {
    id: "DUPLICATE PAPERWORK - CA",
    label: "DUPLICATE PAPERWORK - CA",
    color: "#FF0000",
  },
  {
    id: "CO - SALVAGE TITLE (P)",
    label: "CO - SALVAGE TITLE (P)",
    color: "#008000",
  },
  { id: "RECOVERED THEFT - OK", label: "RECOVERED THEFT - OK", color: "0000FF" },
  {
    id: "MO - CERT OF TITLE-REPOSSESSED (P)",
    label: "MO - CERT OF TITLE-REPOSSESSED (P)",
    color: "#008000",
  },
  {
    id: "VA - CERT OF TITLE - SALVAGE (P)",
    label: "VA - CERT OF TITLE - SALVAGE (P)",
    color: "#008000",
  },
  {
    id: "GA - CERT OF TITLE-MANUFCTR BUYBACK",
    label: "GA - CERT OF TITLE-MANUFCTR BUYBACK",
    color: "#FF681F",
  },
  {
    id: "WI - CERT OF TITLE-SALVAGE VEHICLE (P)",
    label: "WI - CERT OF TITLE-SALVAGE VEHICLE (P)",
    color: "#008000",
  },
  {
    id: "Non Usa - Canada (Ohio)",
    label: "Non Usa - Canada (Ohio)",
    color: "0000FF",
  },
  { id: "MS -   (P)", label: "MS -   (P)", color: "0000FF" },
  {
    id: "GA - SALVAGE ASSEMBLED TITLE (P)",
    label: "GA - SALVAGE ASSEMBLED TITLE (P)",
    color: "#FF681F",
  },
  {
    id: "PA - CERT OF TITLE-A=ANTIQUE VEHICL (P)",
    label: "PA - CERT OF TITLE-A=ANTIQUE VEHICL (P)",
    color: "#FF681F",
  },
  { id: "DE -", label: "DE -", color: "0000FF" },
  {
    id: "NV - SALVAGE TITLE (P)",
    label: "NV - SALVAGE TITLE (P)",
    color: "#008000",
  },
  {
    id: "AZ - CERT OF TITLE-STOLEN",
    label: "AZ - CERT OF TITLE-STOLEN",
    color: "#FF0000",
  },
  {
    id: "MI - SNOWMOBILE REGISTRATION",
    label: "MI - SNOWMOBILE REGISTRATION",
    color: "0000FF",
  },
  {
    id: "MN - DNR REGISTRATION",
    label: "MN - DNR REGISTRATION",
    color: "0000FF",
  },
  { id: "OR - ", label: "OR - ", color: "0000FF" },
  { id: "KS - ", label: "KS - ", color: "0000FF" },
  {
    id: "IA - TRAILER REGISTRATION RECEIPT",
    label: "IA - TRAILER REGISTRATION RECEIPT",
    color: "#FF0000",
  },
  { id: "Qc-V.g.a (Quebec)", label: "Qc-V.g.a (Quebec)", color: "0000FF" },
  {
    id: "On-Not Branded (Ontario)",
    label: "On-Not Branded (Ontario)",
    color: "0000FF",
  },
  {
    id: "Sk-Mechanical & Structural Inspections Required (Saskatchewan)",
    label: "Sk-Mechanical & Structural Inspections Required (Saskatchewan)",
    color: "#FF0000",
  },
  { id: "MV - 907A - NY", label: "MV - 907A - NY", color: "0000FF" },
  {
    id: "REPOSSESSION PAPERWORK - GA",
    label: "REPOSSESSION PAPERWORK - GA",
    color: "#FF0000",
  },
  {
    id: "OR - SALVAGE TITLE CERTIFICATE (P)",
    label: "OR - SALVAGE TITLE CERTIFICATE (P)",
    color: "#008000",
  },
  {
    id: "OK - CERT OF TITLE-REPOSSESSION (P)",
    label: "OK - CERT OF TITLE-REPOSSESSION (P)",
    color: "#FF681F",
  },
  {
    id: "ON - PERMIT SALVAGE (P)",
    label: "ON - PERMIT SALVAGE (P)",
    color: "#FF0000",
  },
  {
    id: "MT - SALVAGE CERTIFICATE OF A VEHIC (P)",
    label: "MT - SALVAGE CERTIFICATE OF A VEHIC (P)",
    color: "#008000",
  },
  {
    id: "AZ - CERT OF TITLE- NON REPAIR",
    label: "AZ - CERT OF TITLE- NON REPAIR",
    color: "#FF0000",
  },
  {
    id: "OH - CERT OF TITLE-SALVAGE (P)",
    label: "OH - CERT OF TITLE-SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "GA - CERT OF TITLE-SALVAGE (P)",
    label: "GA - CERT OF TITLE-SALVAGE (P)",
    color: "#FF681F",
  },
  {
    id: "MI - CERT OF TITLE-SALVAGE VEHICLE (P)",
    label: "MI - CERT OF TITLE-SALVAGE VEHICLE (P)",
    color: "#FF681F",
  },
  {
    id: "AZ - CERT OF TITLE-MNFCTR BBACK/LMN",
    label: "AZ - CERT OF TITLE-MNFCTR BBACK/LMN",
    color: "#FF681F",
  },
  { id: "TX -   (P)", label: "TX -   (P)", color: "0000FF" },
  {
    id: "HI - CERT OF TITLE-REPOSSESSION",
    label: "HI - CERT OF TITLE-REPOSSESSION",
    color: "#FF681F",
  },
  {
    id: "IA - TITLE CERTIFICATE - ATV",
    label: "IA - TITLE CERTIFICATE - ATV",
    color: "#FF681F",
  },
  {
    id: "NV - WILDLIFE CERT OF OWNSHP SALV",
    label: "NV - WILDLIFE CERT OF OWNSHP SALV",
    color: "0000FF",
  },
  {
    id: "CA - NON-REVIVABLE ACQUISITION",
    label: "CA - NON-REVIVABLE ACQUISITION",
    color: "0000FF",
  },
  {
    id: "WI - BOAT/ATV/SNOWMOBILE REG CERT",
    label: "WI - BOAT/ATV/SNOWMOBILE REG CERT",
    color: "0000FF",
  },
  { id: "MS - ", label: "MS - ", color: "#FF681F" },
  {
    id: "UT - CERT OF TITLE-MANUFACTURER BUY (P)",
    label: "UT - CERT OF TITLE-MANUFACTURER BUY (P)",
    color: "#FF681F",
  },
];

  // API key
  const documentOldPIKey = "document_old"; 
  
  // Label
  const documentOldLabel = "Title"; 
  
export { documentOldOption, documentOldPIKey, documentOldLabel };

